import kr, { useMemo as fi } from "react";
function di(u) {
  return u && u.__esModule && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u;
}
function hi(u) {
  if (Object.prototype.hasOwnProperty.call(u, "__esModule")) return u;
  var E = u.default;
  if (typeof E == "function") {
    var b = function l() {
      return this instanceof l ? Reflect.construct(E, arguments, this.constructor) : E.apply(this, arguments);
    };
    b.prototype = E.prototype;
  } else b = {};
  return Object.defineProperty(b, "__esModule", { value: !0 }), Object.keys(u).forEach(function(l) {
    var f = Object.getOwnPropertyDescriptor(u, l);
    Object.defineProperty(b, l, f.get ? f : {
      enumerable: !0,
      get: function() {
        return u[l];
      }
    });
  }), b;
}
var Xe = { exports: {} }, Ve = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var yt, Su;
function Mr() {
  if (Su) return yt;
  Su = 1;
  var u = Object.getOwnPropertySymbols, E = Object.prototype.hasOwnProperty, b = Object.prototype.propertyIsEnumerable;
  function l(p) {
    if (p == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(p);
  }
  function f() {
    try {
      if (!Object.assign)
        return !1;
      var p = new String("abc");
      if (p[5] = "de", Object.getOwnPropertyNames(p)[0] === "5")
        return !1;
      for (var a = {}, d = 0; d < 10; d++)
        a["_" + String.fromCharCode(d)] = d;
      var h = Object.getOwnPropertyNames(a).map(function(r) {
        return a[r];
      });
      if (h.join("") !== "0123456789")
        return !1;
      var i = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(r) {
        i[r] = r;
      }), Object.keys(Object.assign({}, i)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return yt = f() ? Object.assign : function(p, a) {
    for (var d, h = l(p), i, r = 1; r < arguments.length; r++) {
      d = Object(arguments[r]);
      for (var s in d)
        E.call(d, s) && (h[s] = d[s]);
      if (u) {
        i = u(d);
        for (var e = 0; e < i.length; e++)
          b.call(d, i[e]) && (h[i[e]] = d[i[e]]);
      }
    }
    return h;
  }, yt;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tu;
function pi() {
  if (Tu) return Ve;
  Tu = 1, Mr();
  var u = kr, E = 60103;
  if (Ve.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var b = Symbol.for;
    E = b("react.element"), Ve.Fragment = b("react.fragment");
  }
  var l = u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, f = Object.prototype.hasOwnProperty, p = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(d, h, i) {
    var r, s = {}, e = null, t = null;
    i !== void 0 && (e = "" + i), h.key !== void 0 && (e = "" + h.key), h.ref !== void 0 && (t = h.ref);
    for (r in h) f.call(h, r) && !p.hasOwnProperty(r) && (s[r] = h[r]);
    if (d && d.defaultProps) for (r in h = d.defaultProps, h) s[r] === void 0 && (s[r] = h[r]);
    return { $$typeof: E, type: d, key: e, ref: t, props: s, _owner: l.current };
  }
  return Ve.jsx = a, Ve.jsxs = a, Ve;
}
var xt = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Au;
function bi() {
  return Au || (Au = 1, function(u) {
    process.env.NODE_ENV !== "production" && function() {
      var E = kr, b = Mr(), l = 60103, f = 60106;
      u.Fragment = 60107;
      var p = 60108, a = 60114, d = 60109, h = 60110, i = 60112, r = 60113, s = 60120, e = 60115, t = 60116, c = 60121, m = 60122, y = 60117, n = 60129, g = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var v = Symbol.for;
        l = v("react.element"), f = v("react.portal"), u.Fragment = v("react.fragment"), p = v("react.strict_mode"), a = v("react.profiler"), d = v("react.provider"), h = v("react.context"), i = v("react.forward_ref"), r = v("react.suspense"), s = v("react.suspense_list"), e = v("react.memo"), t = v("react.lazy"), c = v("react.block"), m = v("react.server.block"), y = v("react.fundamental"), v("react.scope"), v("react.opaque.id"), n = v("react.debug_trace_mode"), v("react.offscreen"), g = v("react.legacy_hidden");
      }
      var x = typeof Symbol == "function" && Symbol.iterator, o = "@@iterator";
      function w(T) {
        if (T === null || typeof T != "object")
          return null;
        var L = x && T[x] || T[o];
        return typeof L == "function" ? L : null;
      }
      var S = E.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function A(T) {
        {
          for (var L = arguments.length, j = new Array(L > 1 ? L - 1 : 0), U = 1; U < L; U++)
            j[U - 1] = arguments[U];
          C("error", T, j);
        }
      }
      function C(T, L, j) {
        {
          var U = S.ReactDebugCurrentFrame, K = U.getStackAddendum();
          K !== "" && (L += "%s", j = j.concat([K]));
          var Q = j.map(function(W) {
            return "" + W;
          });
          Q.unshift("Warning: " + L), Function.prototype.apply.call(console[T], console, Q);
        }
      }
      var R = !1;
      function q(T) {
        return !!(typeof T == "string" || typeof T == "function" || T === u.Fragment || T === a || T === n || T === p || T === r || T === s || T === g || R || typeof T == "object" && T !== null && (T.$$typeof === t || T.$$typeof === e || T.$$typeof === d || T.$$typeof === h || T.$$typeof === i || T.$$typeof === y || T.$$typeof === c || T[0] === m));
      }
      function O(T, L, j) {
        var U = L.displayName || L.name || "";
        return T.displayName || (U !== "" ? j + "(" + U + ")" : j);
      }
      function I(T) {
        return T.displayName || "Context";
      }
      function k(T) {
        if (T == null)
          return null;
        if (typeof T.tag == "number" && A("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof T == "function")
          return T.displayName || T.name || null;
        if (typeof T == "string")
          return T;
        switch (T) {
          case u.Fragment:
            return "Fragment";
          case f:
            return "Portal";
          case a:
            return "Profiler";
          case p:
            return "StrictMode";
          case r:
            return "Suspense";
          case s:
            return "SuspenseList";
        }
        if (typeof T == "object")
          switch (T.$$typeof) {
            case h:
              var L = T;
              return I(L) + ".Consumer";
            case d:
              var j = T;
              return I(j._context) + ".Provider";
            case i:
              return O(T, T.render, "ForwardRef");
            case e:
              return k(T.type);
            case c:
              return k(T._render);
            case t: {
              var U = T, K = U._payload, Q = U._init;
              try {
                return k(Q(K));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var _ = 0, F, z, J, ee, te, oe, _e;
      function B() {
      }
      B.__reactDisabledLog = !0;
      function ce() {
        {
          if (_ === 0) {
            F = console.log, z = console.info, J = console.warn, ee = console.error, te = console.group, oe = console.groupCollapsed, _e = console.groupEnd;
            var T = {
              configurable: !0,
              enumerable: !0,
              value: B,
              writable: !0
            };
            Object.defineProperties(console, {
              info: T,
              log: T,
              warn: T,
              error: T,
              group: T,
              groupCollapsed: T,
              groupEnd: T
            });
          }
          _++;
        }
      }
      function ye() {
        {
          if (_--, _ === 0) {
            var T = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: b({}, T, {
                value: F
              }),
              info: b({}, T, {
                value: z
              }),
              warn: b({}, T, {
                value: J
              }),
              error: b({}, T, {
                value: ee
              }),
              group: b({}, T, {
                value: te
              }),
              groupCollapsed: b({}, T, {
                value: oe
              }),
              groupEnd: b({}, T, {
                value: _e
              })
            });
          }
          _ < 0 && A("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Ne = S.ReactCurrentDispatcher, xe;
      function Re(T, L, j) {
        {
          if (xe === void 0)
            try {
              throw Error();
            } catch (K) {
              var U = K.stack.trim().match(/\n( *(at )?)/);
              xe = U && U[1] || "";
            }
          return `
` + xe + T;
        }
      }
      var Le = !1, we;
      {
        var N = typeof WeakMap == "function" ? WeakMap : Map;
        we = new N();
      }
      function P(T, L) {
        if (!T || Le)
          return "";
        {
          var j = we.get(T);
          if (j !== void 0)
            return j;
        }
        var U;
        Le = !0;
        var K = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Q;
        Q = Ne.current, Ne.current = null, ce();
        try {
          if (L) {
            var W = function() {
              throw Error();
            };
            if (Object.defineProperty(W.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(W, []);
              } catch (Se) {
                U = Se;
              }
              Reflect.construct(T, [], W);
            } else {
              try {
                W.call();
              } catch (Se) {
                U = Se;
              }
              T.call(W.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Se) {
              U = Se;
            }
            T();
          }
        } catch (Se) {
          if (Se && U && typeof Se.stack == "string") {
            for (var G = Se.stack.split(`
`), ae = U.stack.split(`
`), re = G.length - 1, ie = ae.length - 1; re >= 1 && ie >= 0 && G[re] !== ae[ie]; )
              ie--;
            for (; re >= 1 && ie >= 0; re--, ie--)
              if (G[re] !== ae[ie]) {
                if (re !== 1 || ie !== 1)
                  do
                    if (re--, ie--, ie < 0 || G[re] !== ae[ie]) {
                      var Ee = `
` + G[re].replace(" at new ", " at ");
                      return typeof T == "function" && we.set(T, Ee), Ee;
                    }
                  while (re >= 1 && ie >= 0);
                break;
              }
          }
        } finally {
          Le = !1, Ne.current = Q, ye(), Error.prepareStackTrace = K;
        }
        var He = T ? T.displayName || T.name : "", Eu = He ? Re(He) : "";
        return typeof T == "function" && we.set(T, Eu), Eu;
      }
      function D(T, L, j) {
        return P(T, !1);
      }
      function H(T) {
        var L = T.prototype;
        return !!(L && L.isReactComponent);
      }
      function ue(T, L, j) {
        if (T == null)
          return "";
        if (typeof T == "function")
          return P(T, H(T));
        if (typeof T == "string")
          return Re(T);
        switch (T) {
          case r:
            return Re("Suspense");
          case s:
            return Re("SuspenseList");
        }
        if (typeof T == "object")
          switch (T.$$typeof) {
            case i:
              return D(T.render);
            case e:
              return ue(T.type, L, j);
            case c:
              return D(T._render);
            case t: {
              var U = T, K = U._payload, Q = U._init;
              try {
                return ue(Q(K), L, j);
              } catch {
              }
            }
          }
        return "";
      }
      var ne = {}, ht = S.ReactDebugCurrentFrame;
      function $e(T) {
        if (T) {
          var L = T._owner, j = ue(T.type, T._source, L ? L.type : null);
          ht.setExtraStackFrame(j);
        } else
          ht.setExtraStackFrame(null);
      }
      function X(T, L, j, U, K) {
        {
          var Q = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var W in T)
            if (Q(T, W)) {
              var G = void 0;
              try {
                if (typeof T[W] != "function") {
                  var ae = Error((U || "React class") + ": " + j + " type `" + W + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof T[W] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw ae.name = "Invariant Violation", ae;
                }
                G = T[W](L, W, U, j, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (re) {
                G = re;
              }
              G && !(G instanceof Error) && ($e(K), A("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", U || "React class", j, W, typeof G), $e(null)), G instanceof Error && !(G.message in ne) && (ne[G.message] = !0, $e(K), A("Failed %s type: %s", j, G.message), $e(null));
            }
        }
      }
      var $ = S.ReactCurrentOwner, Ie = Object.prototype.hasOwnProperty, Z = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Y, ge;
      function fe(T) {
        if (Ie.call(T, "ref")) {
          var L = Object.getOwnPropertyDescriptor(T, "ref").get;
          if (L && L.isReactWarning)
            return !1;
        }
        return T.ref !== void 0;
      }
      function le(T) {
        if (Ie.call(T, "key")) {
          var L = Object.getOwnPropertyDescriptor(T, "key").get;
          if (L && L.isReactWarning)
            return !1;
        }
        return T.key !== void 0;
      }
      function pt(T, L) {
        typeof T.ref == "string" && $.current;
      }
      function Ze(T, L) {
        {
          var j = function() {
            Y || (Y = !0, A("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", L));
          };
          j.isReactWarning = !0, Object.defineProperty(T, "key", {
            get: j,
            configurable: !0
          });
        }
      }
      function bt(T, L) {
        {
          var j = function() {
            ge || (ge = !0, A("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", L));
          };
          j.isReactWarning = !0, Object.defineProperty(T, "ref", {
            get: j,
            configurable: !0
          });
        }
      }
      var ti = function(T, L, j, U, K, Q, W) {
        var G = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: l,
          // Built-in properties that belong on the element
          type: T,
          key: L,
          ref: j,
          props: W,
          // Record the component responsible for creating this element.
          _owner: Q
        };
        return G._store = {}, Object.defineProperty(G._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(G, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: U
        }), Object.defineProperty(G, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: K
        }), Object.freeze && (Object.freeze(G.props), Object.freeze(G)), G;
      };
      function ui(T, L, j, U, K) {
        {
          var Q, W = {}, G = null, ae = null;
          j !== void 0 && (G = "" + j), le(L) && (G = "" + L.key), fe(L) && (ae = L.ref, pt(L, K));
          for (Q in L)
            Ie.call(L, Q) && !Z.hasOwnProperty(Q) && (W[Q] = L[Q]);
          if (T && T.defaultProps) {
            var re = T.defaultProps;
            for (Q in re)
              W[Q] === void 0 && (W[Q] = re[Q]);
          }
          if (G || ae) {
            var ie = typeof T == "function" ? T.displayName || T.name || "Unknown" : T;
            G && Ze(W, ie), ae && bt(W, ie);
          }
          return ti(T, G, ae, K, U, $.current, W);
        }
      }
      var mt = S.ReactCurrentOwner, mu = S.ReactDebugCurrentFrame;
      function Ue(T) {
        if (T) {
          var L = T._owner, j = ue(T.type, T._source, L ? L.type : null);
          mu.setExtraStackFrame(j);
        } else
          mu.setExtraStackFrame(null);
      }
      var gt;
      gt = !1;
      function vt(T) {
        return typeof T == "object" && T !== null && T.$$typeof === l;
      }
      function gu() {
        {
          if (mt.current) {
            var T = k(mt.current.type);
            if (T)
              return `

Check the render method of \`` + T + "`.";
          }
          return "";
        }
      }
      function ri(T) {
        return "";
      }
      var vu = {};
      function ii(T) {
        {
          var L = gu();
          if (!L) {
            var j = typeof T == "string" ? T : T.displayName || T.name;
            j && (L = `

Check the top-level render call using <` + j + ">.");
          }
          return L;
        }
      }
      function yu(T, L) {
        {
          if (!T._store || T._store.validated || T.key != null)
            return;
          T._store.validated = !0;
          var j = ii(L);
          if (vu[j])
            return;
          vu[j] = !0;
          var U = "";
          T && T._owner && T._owner !== mt.current && (U = " It was passed a child from " + k(T._owner.type) + "."), Ue(T), A('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', j, U), Ue(null);
        }
      }
      function xu(T, L) {
        {
          if (typeof T != "object")
            return;
          if (Array.isArray(T))
            for (var j = 0; j < T.length; j++) {
              var U = T[j];
              vt(U) && yu(U, L);
            }
          else if (vt(T))
            T._store && (T._store.validated = !0);
          else if (T) {
            var K = w(T);
            if (typeof K == "function" && K !== T.entries)
              for (var Q = K.call(T), W; !(W = Q.next()).done; )
                vt(W.value) && yu(W.value, L);
          }
        }
      }
      function ni(T) {
        {
          var L = T.type;
          if (L == null || typeof L == "string")
            return;
          var j;
          if (typeof L == "function")
            j = L.propTypes;
          else if (typeof L == "object" && (L.$$typeof === i || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          L.$$typeof === e))
            j = L.propTypes;
          else
            return;
          if (j) {
            var U = k(L);
            X(j, T.props, "prop", U, T);
          } else if (L.PropTypes !== void 0 && !gt) {
            gt = !0;
            var K = k(L);
            A("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", K || "Unknown");
          }
          typeof L.getDefaultProps == "function" && !L.getDefaultProps.isReactClassApproved && A("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function ai(T) {
        {
          for (var L = Object.keys(T.props), j = 0; j < L.length; j++) {
            var U = L[j];
            if (U !== "children" && U !== "key") {
              Ue(T), A("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", U), Ue(null);
              break;
            }
          }
          T.ref !== null && (Ue(T), A("Invalid attribute `ref` supplied to `React.Fragment`."), Ue(null));
        }
      }
      function wu(T, L, j, U, K, Q) {
        {
          var W = q(T);
          if (!W) {
            var G = "";
            (T === void 0 || typeof T == "object" && T !== null && Object.keys(T).length === 0) && (G += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var ae = ri();
            ae ? G += ae : G += gu();
            var re;
            T === null ? re = "null" : Array.isArray(T) ? re = "array" : T !== void 0 && T.$$typeof === l ? (re = "<" + (k(T.type) || "Unknown") + " />", G = " Did you accidentally export a JSX literal instead of a component?") : re = typeof T, A("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", re, G);
          }
          var ie = ui(T, L, j, K, Q);
          if (ie == null)
            return ie;
          if (W) {
            var Ee = L.children;
            if (Ee !== void 0)
              if (U)
                if (Array.isArray(Ee)) {
                  for (var He = 0; He < Ee.length; He++)
                    xu(Ee[He], T);
                  Object.freeze && Object.freeze(Ee);
                } else
                  A("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                xu(Ee, T);
          }
          return T === u.Fragment ? ai(ie) : ni(ie), ie;
        }
      }
      function si(T, L, j) {
        return wu(T, L, j, !0);
      }
      function oi(T, L, j) {
        return wu(T, L, j, !1);
      }
      var ci = oi, li = si;
      u.jsx = ci, u.jsxs = li;
    }();
  }(xt)), xt;
}
var qu;
function mi() {
  return qu || (qu = 1, process.env.NODE_ENV === "production" ? Xe.exports = pi() : Xe.exports = bi()), Xe.exports;
}
var M = mi(), de = {}, he = {}, wt = {}, pe = {}, Qe = {}, Ou;
function gi() {
  return Ou || (Ou = 1, Object.defineProperty(Qe, "__esModule", { value: !0 }), Qe.default = new Uint16Array(
    // prettier-ignore
    'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(u) {
      return u.charCodeAt(0);
    })
  )), Qe;
}
var Ke = {}, _u;
function vi() {
  return _u || (_u = 1, Object.defineProperty(Ke, "__esModule", { value: !0 }), Ke.default = new Uint16Array(
    // prettier-ignore
    "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(u) {
      return u.charCodeAt(0);
    })
  )), Ke;
}
var Et = {}, Nu;
function Ru() {
  return Nu || (Nu = 1, function(u) {
    var E;
    Object.defineProperty(u, "__esModule", { value: !0 }), u.replaceCodePoint = u.fromCodePoint = void 0;
    var b = /* @__PURE__ */ new Map([
      [0, 65533],
      // C1 Unicode control character reference replacements
      [128, 8364],
      [130, 8218],
      [131, 402],
      [132, 8222],
      [133, 8230],
      [134, 8224],
      [135, 8225],
      [136, 710],
      [137, 8240],
      [138, 352],
      [139, 8249],
      [140, 338],
      [142, 381],
      [145, 8216],
      [146, 8217],
      [147, 8220],
      [148, 8221],
      [149, 8226],
      [150, 8211],
      [151, 8212],
      [152, 732],
      [153, 8482],
      [154, 353],
      [155, 8250],
      [156, 339],
      [158, 382],
      [159, 376]
    ]);
    u.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
    (E = String.fromCodePoint) !== null && E !== void 0 ? E : function(p) {
      var a = "";
      return p > 65535 && (p -= 65536, a += String.fromCharCode(p >>> 10 & 1023 | 55296), p = 56320 | p & 1023), a += String.fromCharCode(p), a;
    };
    function l(p) {
      var a;
      return p >= 55296 && p <= 57343 || p > 1114111 ? 65533 : (a = b.get(p)) !== null && a !== void 0 ? a : p;
    }
    u.replaceCodePoint = l;
    function f(p) {
      return (0, u.fromCodePoint)(l(p));
    }
    u.default = f;
  }(Et)), Et;
}
var Cu;
function at() {
  return Cu || (Cu = 1, function(u) {
    var E = pe && pe.__createBinding || (Object.create ? function(q, O, I, k) {
      k === void 0 && (k = I);
      var _ = Object.getOwnPropertyDescriptor(O, I);
      (!_ || ("get" in _ ? !O.__esModule : _.writable || _.configurable)) && (_ = { enumerable: !0, get: function() {
        return O[I];
      } }), Object.defineProperty(q, k, _);
    } : function(q, O, I, k) {
      k === void 0 && (k = I), q[k] = O[I];
    }), b = pe && pe.__setModuleDefault || (Object.create ? function(q, O) {
      Object.defineProperty(q, "default", { enumerable: !0, value: O });
    } : function(q, O) {
      q.default = O;
    }), l = pe && pe.__importStar || function(q) {
      if (q && q.__esModule) return q;
      var O = {};
      if (q != null) for (var I in q) I !== "default" && Object.prototype.hasOwnProperty.call(q, I) && E(O, q, I);
      return b(O, q), O;
    }, f = pe && pe.__importDefault || function(q) {
      return q && q.__esModule ? q : { default: q };
    };
    Object.defineProperty(u, "__esModule", { value: !0 }), u.decodeXML = u.decodeHTMLStrict = u.decodeHTMLAttribute = u.decodeHTML = u.determineBranch = u.EntityDecoder = u.DecodingMode = u.BinTrieFlags = u.fromCodePoint = u.replaceCodePoint = u.decodeCodePoint = u.xmlDecodeTree = u.htmlDecodeTree = void 0;
    var p = f(/* @__PURE__ */ gi());
    u.htmlDecodeTree = p.default;
    var a = f(/* @__PURE__ */ vi());
    u.xmlDecodeTree = a.default;
    var d = l(/* @__PURE__ */ Ru());
    u.decodeCodePoint = d.default;
    var h = /* @__PURE__ */ Ru();
    Object.defineProperty(u, "replaceCodePoint", { enumerable: !0, get: function() {
      return h.replaceCodePoint;
    } }), Object.defineProperty(u, "fromCodePoint", { enumerable: !0, get: function() {
      return h.fromCodePoint;
    } });
    var i;
    (function(q) {
      q[q.NUM = 35] = "NUM", q[q.SEMI = 59] = "SEMI", q[q.EQUALS = 61] = "EQUALS", q[q.ZERO = 48] = "ZERO", q[q.NINE = 57] = "NINE", q[q.LOWER_A = 97] = "LOWER_A", q[q.LOWER_F = 102] = "LOWER_F", q[q.LOWER_X = 120] = "LOWER_X", q[q.LOWER_Z = 122] = "LOWER_Z", q[q.UPPER_A = 65] = "UPPER_A", q[q.UPPER_F = 70] = "UPPER_F", q[q.UPPER_Z = 90] = "UPPER_Z";
    })(i || (i = {}));
    var r = 32, s;
    (function(q) {
      q[q.VALUE_LENGTH = 49152] = "VALUE_LENGTH", q[q.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", q[q.JUMP_TABLE = 127] = "JUMP_TABLE";
    })(s = u.BinTrieFlags || (u.BinTrieFlags = {}));
    function e(q) {
      return q >= i.ZERO && q <= i.NINE;
    }
    function t(q) {
      return q >= i.UPPER_A && q <= i.UPPER_F || q >= i.LOWER_A && q <= i.LOWER_F;
    }
    function c(q) {
      return q >= i.UPPER_A && q <= i.UPPER_Z || q >= i.LOWER_A && q <= i.LOWER_Z || e(q);
    }
    function m(q) {
      return q === i.EQUALS || c(q);
    }
    var y;
    (function(q) {
      q[q.EntityStart = 0] = "EntityStart", q[q.NumericStart = 1] = "NumericStart", q[q.NumericDecimal = 2] = "NumericDecimal", q[q.NumericHex = 3] = "NumericHex", q[q.NamedEntity = 4] = "NamedEntity";
    })(y || (y = {}));
    var n;
    (function(q) {
      q[q.Legacy = 0] = "Legacy", q[q.Strict = 1] = "Strict", q[q.Attribute = 2] = "Attribute";
    })(n = u.DecodingMode || (u.DecodingMode = {}));
    var g = (
      /** @class */
      function() {
        function q(O, I, k) {
          this.decodeTree = O, this.emitCodePoint = I, this.errors = k, this.state = y.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = n.Strict;
        }
        return q.prototype.startEntity = function(O) {
          this.decodeMode = O, this.state = y.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
        }, q.prototype.write = function(O, I) {
          switch (this.state) {
            case y.EntityStart:
              return O.charCodeAt(I) === i.NUM ? (this.state = y.NumericStart, this.consumed += 1, this.stateNumericStart(O, I + 1)) : (this.state = y.NamedEntity, this.stateNamedEntity(O, I));
            case y.NumericStart:
              return this.stateNumericStart(O, I);
            case y.NumericDecimal:
              return this.stateNumericDecimal(O, I);
            case y.NumericHex:
              return this.stateNumericHex(O, I);
            case y.NamedEntity:
              return this.stateNamedEntity(O, I);
          }
        }, q.prototype.stateNumericStart = function(O, I) {
          return I >= O.length ? -1 : (O.charCodeAt(I) | r) === i.LOWER_X ? (this.state = y.NumericHex, this.consumed += 1, this.stateNumericHex(O, I + 1)) : (this.state = y.NumericDecimal, this.stateNumericDecimal(O, I));
        }, q.prototype.addToNumericResult = function(O, I, k, _) {
          if (I !== k) {
            var F = k - I;
            this.result = this.result * Math.pow(_, F) + parseInt(O.substr(I, F), _), this.consumed += F;
          }
        }, q.prototype.stateNumericHex = function(O, I) {
          for (var k = I; I < O.length; ) {
            var _ = O.charCodeAt(I);
            if (e(_) || t(_))
              I += 1;
            else
              return this.addToNumericResult(O, k, I, 16), this.emitNumericEntity(_, 3);
          }
          return this.addToNumericResult(O, k, I, 16), -1;
        }, q.prototype.stateNumericDecimal = function(O, I) {
          for (var k = I; I < O.length; ) {
            var _ = O.charCodeAt(I);
            if (e(_))
              I += 1;
            else
              return this.addToNumericResult(O, k, I, 10), this.emitNumericEntity(_, 2);
          }
          return this.addToNumericResult(O, k, I, 10), -1;
        }, q.prototype.emitNumericEntity = function(O, I) {
          var k;
          if (this.consumed <= I)
            return (k = this.errors) === null || k === void 0 || k.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          if (O === i.SEMI)
            this.consumed += 1;
          else if (this.decodeMode === n.Strict)
            return 0;
          return this.emitCodePoint((0, d.replaceCodePoint)(this.result), this.consumed), this.errors && (O !== i.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
        }, q.prototype.stateNamedEntity = function(O, I) {
          for (var k = this.decodeTree, _ = k[this.treeIndex], F = (_ & s.VALUE_LENGTH) >> 14; I < O.length; I++, this.excess++) {
            var z = O.charCodeAt(I);
            if (this.treeIndex = x(k, _, this.treeIndex + Math.max(1, F), z), this.treeIndex < 0)
              return this.result === 0 || // If we are parsing an attribute
              this.decodeMode === n.Attribute && // We shouldn't have consumed any characters after the entity,
              (F === 0 || // And there should be no invalid characters.
              m(z)) ? 0 : this.emitNotTerminatedNamedEntity();
            if (_ = k[this.treeIndex], F = (_ & s.VALUE_LENGTH) >> 14, F !== 0) {
              if (z === i.SEMI)
                return this.emitNamedEntityData(this.treeIndex, F, this.consumed + this.excess);
              this.decodeMode !== n.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
            }
          }
          return -1;
        }, q.prototype.emitNotTerminatedNamedEntity = function() {
          var O, I = this, k = I.result, _ = I.decodeTree, F = (_[k] & s.VALUE_LENGTH) >> 14;
          return this.emitNamedEntityData(k, F, this.consumed), (O = this.errors) === null || O === void 0 || O.missingSemicolonAfterCharacterReference(), this.consumed;
        }, q.prototype.emitNamedEntityData = function(O, I, k) {
          var _ = this.decodeTree;
          return this.emitCodePoint(I === 1 ? _[O] & ~s.VALUE_LENGTH : _[O + 1], k), I === 3 && this.emitCodePoint(_[O + 2], k), k;
        }, q.prototype.end = function() {
          var O;
          switch (this.state) {
            case y.NamedEntity:
              return this.result !== 0 && (this.decodeMode !== n.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case y.NumericDecimal:
              return this.emitNumericEntity(0, 2);
            case y.NumericHex:
              return this.emitNumericEntity(0, 3);
            case y.NumericStart:
              return (O = this.errors) === null || O === void 0 || O.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
            case y.EntityStart:
              return 0;
          }
        }, q;
      }()
    );
    u.EntityDecoder = g;
    function v(q) {
      var O = "", I = new g(q, function(k) {
        return O += (0, d.fromCodePoint)(k);
      });
      return function(_, F) {
        for (var z = 0, J = 0; (J = _.indexOf("&", J)) >= 0; ) {
          O += _.slice(z, J), I.startEntity(F);
          var ee = I.write(
            _,
            // Skip the "&"
            J + 1
          );
          if (ee < 0) {
            z = J + I.end();
            break;
          }
          z = J + ee, J = ee === 0 ? z + 1 : z;
        }
        var te = O + _.slice(z);
        return O = "", te;
      };
    }
    function x(q, O, I, k) {
      var _ = (O & s.BRANCH_LENGTH) >> 7, F = O & s.JUMP_TABLE;
      if (_ === 0)
        return F !== 0 && k === F ? I : -1;
      if (F) {
        var z = k - F;
        return z < 0 || z >= _ ? -1 : q[I + z] - 1;
      }
      for (var J = I, ee = J + _ - 1; J <= ee; ) {
        var te = J + ee >>> 1, oe = q[te];
        if (oe < k)
          J = te + 1;
        else if (oe > k)
          ee = te - 1;
        else
          return q[te + _];
      }
      return -1;
    }
    u.determineBranch = x;
    var o = v(p.default), w = v(a.default);
    function S(q, O) {
      return O === void 0 && (O = n.Legacy), o(q, O);
    }
    u.decodeHTML = S;
    function A(q) {
      return o(q, n.Attribute);
    }
    u.decodeHTMLAttribute = A;
    function C(q) {
      return o(q, n.Strict);
    }
    u.decodeHTMLStrict = C;
    function R(q) {
      return w(q, n.Strict);
    }
    u.decodeXML = R;
  }(pe)), pe;
}
var Du;
function jr() {
  return Du || (Du = 1, function(u) {
    Object.defineProperty(u, "__esModule", { value: !0 }), u.QuoteType = void 0;
    var E = /* @__PURE__ */ at(), b;
    (function(e) {
      e[e.Tab = 9] = "Tab", e[e.NewLine = 10] = "NewLine", e[e.FormFeed = 12] = "FormFeed", e[e.CarriageReturn = 13] = "CarriageReturn", e[e.Space = 32] = "Space", e[e.ExclamationMark = 33] = "ExclamationMark", e[e.Number = 35] = "Number", e[e.Amp = 38] = "Amp", e[e.SingleQuote = 39] = "SingleQuote", e[e.DoubleQuote = 34] = "DoubleQuote", e[e.Dash = 45] = "Dash", e[e.Slash = 47] = "Slash", e[e.Zero = 48] = "Zero", e[e.Nine = 57] = "Nine", e[e.Semi = 59] = "Semi", e[e.Lt = 60] = "Lt", e[e.Eq = 61] = "Eq", e[e.Gt = 62] = "Gt", e[e.Questionmark = 63] = "Questionmark", e[e.UpperA = 65] = "UpperA", e[e.LowerA = 97] = "LowerA", e[e.UpperF = 70] = "UpperF", e[e.LowerF = 102] = "LowerF", e[e.UpperZ = 90] = "UpperZ", e[e.LowerZ = 122] = "LowerZ", e[e.LowerX = 120] = "LowerX", e[e.OpeningSquareBracket = 91] = "OpeningSquareBracket";
    })(b || (b = {}));
    var l;
    (function(e) {
      e[e.Text = 1] = "Text", e[e.BeforeTagName = 2] = "BeforeTagName", e[e.InTagName = 3] = "InTagName", e[e.InSelfClosingTag = 4] = "InSelfClosingTag", e[e.BeforeClosingTagName = 5] = "BeforeClosingTagName", e[e.InClosingTagName = 6] = "InClosingTagName", e[e.AfterClosingTagName = 7] = "AfterClosingTagName", e[e.BeforeAttributeName = 8] = "BeforeAttributeName", e[e.InAttributeName = 9] = "InAttributeName", e[e.AfterAttributeName = 10] = "AfterAttributeName", e[e.BeforeAttributeValue = 11] = "BeforeAttributeValue", e[e.InAttributeValueDq = 12] = "InAttributeValueDq", e[e.InAttributeValueSq = 13] = "InAttributeValueSq", e[e.InAttributeValueNq = 14] = "InAttributeValueNq", e[e.BeforeDeclaration = 15] = "BeforeDeclaration", e[e.InDeclaration = 16] = "InDeclaration", e[e.InProcessingInstruction = 17] = "InProcessingInstruction", e[e.BeforeComment = 18] = "BeforeComment", e[e.CDATASequence = 19] = "CDATASequence", e[e.InSpecialComment = 20] = "InSpecialComment", e[e.InCommentLike = 21] = "InCommentLike", e[e.BeforeSpecialS = 22] = "BeforeSpecialS", e[e.SpecialStartSequence = 23] = "SpecialStartSequence", e[e.InSpecialTag = 24] = "InSpecialTag", e[e.BeforeEntity = 25] = "BeforeEntity", e[e.BeforeNumericEntity = 26] = "BeforeNumericEntity", e[e.InNamedEntity = 27] = "InNamedEntity", e[e.InNumericEntity = 28] = "InNumericEntity", e[e.InHexEntity = 29] = "InHexEntity";
    })(l || (l = {}));
    function f(e) {
      return e === b.Space || e === b.NewLine || e === b.Tab || e === b.FormFeed || e === b.CarriageReturn;
    }
    function p(e) {
      return e === b.Slash || e === b.Gt || f(e);
    }
    function a(e) {
      return e >= b.Zero && e <= b.Nine;
    }
    function d(e) {
      return e >= b.LowerA && e <= b.LowerZ || e >= b.UpperA && e <= b.UpperZ;
    }
    function h(e) {
      return e >= b.UpperA && e <= b.UpperF || e >= b.LowerA && e <= b.LowerF;
    }
    var i;
    (function(e) {
      e[e.NoValue = 0] = "NoValue", e[e.Unquoted = 1] = "Unquoted", e[e.Single = 2] = "Single", e[e.Double = 3] = "Double";
    })(i = u.QuoteType || (u.QuoteType = {}));
    var r = {
      Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
      CdataEnd: new Uint8Array([93, 93, 62]),
      CommentEnd: new Uint8Array([45, 45, 62]),
      ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
      StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
      TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
      // `</title`
    }, s = (
      /** @class */
      function() {
        function e(t, c) {
          var m = t.xmlMode, y = m === void 0 ? !1 : m, n = t.decodeEntities, g = n === void 0 ? !0 : n;
          this.cbs = c, this.state = l.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = l.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = y, this.decodeEntities = g, this.entityTrie = y ? E.xmlDecodeTree : E.htmlDecodeTree;
        }
        return e.prototype.reset = function() {
          this.state = l.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = l.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
        }, e.prototype.write = function(t) {
          this.offset += this.buffer.length, this.buffer = t, this.parse();
        }, e.prototype.end = function() {
          this.running && this.finish();
        }, e.prototype.pause = function() {
          this.running = !1;
        }, e.prototype.resume = function() {
          this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
        }, e.prototype.getIndex = function() {
          return this.index;
        }, e.prototype.getSectionStart = function() {
          return this.sectionStart;
        }, e.prototype.stateText = function(t) {
          t === b.Lt || !this.decodeEntities && this.fastForwardTo(b.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = l.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && t === b.Amp && (this.state = l.BeforeEntity);
        }, e.prototype.stateSpecialStartSequence = function(t) {
          var c = this.sequenceIndex === this.currentSequence.length, m = c ? (
            // If we are at the end of the sequence, make sure the tag name has ended
            p(t)
          ) : (
            // Otherwise, do a case-insensitive comparison
            (t | 32) === this.currentSequence[this.sequenceIndex]
          );
          if (!m)
            this.isSpecial = !1;
          else if (!c) {
            this.sequenceIndex++;
            return;
          }
          this.sequenceIndex = 0, this.state = l.InTagName, this.stateInTagName(t);
        }, e.prototype.stateInSpecialTag = function(t) {
          if (this.sequenceIndex === this.currentSequence.length) {
            if (t === b.Gt || f(t)) {
              var c = this.index - this.currentSequence.length;
              if (this.sectionStart < c) {
                var m = this.index;
                this.index = c, this.cbs.ontext(this.sectionStart, c), this.index = m;
              }
              this.isSpecial = !1, this.sectionStart = c + 2, this.stateInClosingTagName(t);
              return;
            }
            this.sequenceIndex = 0;
          }
          (t | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === r.TitleEnd ? this.decodeEntities && t === b.Amp && (this.state = l.BeforeEntity) : this.fastForwardTo(b.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(t === b.Lt);
        }, e.prototype.stateCDATASequence = function(t) {
          t === r.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === r.Cdata.length && (this.state = l.InCommentLike, this.currentSequence = r.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = l.InDeclaration, this.stateInDeclaration(t));
        }, e.prototype.fastForwardTo = function(t) {
          for (; ++this.index < this.buffer.length + this.offset; )
            if (this.buffer.charCodeAt(this.index - this.offset) === t)
              return !0;
          return this.index = this.buffer.length + this.offset - 1, !1;
        }, e.prototype.stateInCommentLike = function(t) {
          t === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === r.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = l.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : t !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
        }, e.prototype.isTagStartChar = function(t) {
          return this.xmlMode ? !p(t) : d(t);
        }, e.prototype.startSpecial = function(t, c) {
          this.isSpecial = !0, this.currentSequence = t, this.sequenceIndex = c, this.state = l.SpecialStartSequence;
        }, e.prototype.stateBeforeTagName = function(t) {
          if (t === b.ExclamationMark)
            this.state = l.BeforeDeclaration, this.sectionStart = this.index + 1;
          else if (t === b.Questionmark)
            this.state = l.InProcessingInstruction, this.sectionStart = this.index + 1;
          else if (this.isTagStartChar(t)) {
            var c = t | 32;
            this.sectionStart = this.index, !this.xmlMode && c === r.TitleEnd[2] ? this.startSpecial(r.TitleEnd, 3) : this.state = !this.xmlMode && c === r.ScriptEnd[2] ? l.BeforeSpecialS : l.InTagName;
          } else t === b.Slash ? this.state = l.BeforeClosingTagName : (this.state = l.Text, this.stateText(t));
        }, e.prototype.stateInTagName = function(t) {
          p(t) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = l.BeforeAttributeName, this.stateBeforeAttributeName(t));
        }, e.prototype.stateBeforeClosingTagName = function(t) {
          f(t) || (t === b.Gt ? this.state = l.Text : (this.state = this.isTagStartChar(t) ? l.InClosingTagName : l.InSpecialComment, this.sectionStart = this.index));
        }, e.prototype.stateInClosingTagName = function(t) {
          (t === b.Gt || f(t)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = l.AfterClosingTagName, this.stateAfterClosingTagName(t));
        }, e.prototype.stateAfterClosingTagName = function(t) {
          (t === b.Gt || this.fastForwardTo(b.Gt)) && (this.state = l.Text, this.baseState = l.Text, this.sectionStart = this.index + 1);
        }, e.prototype.stateBeforeAttributeName = function(t) {
          t === b.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = l.InSpecialTag, this.sequenceIndex = 0) : this.state = l.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : t === b.Slash ? this.state = l.InSelfClosingTag : f(t) || (this.state = l.InAttributeName, this.sectionStart = this.index);
        }, e.prototype.stateInSelfClosingTag = function(t) {
          t === b.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = l.Text, this.baseState = l.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : f(t) || (this.state = l.BeforeAttributeName, this.stateBeforeAttributeName(t));
        }, e.prototype.stateInAttributeName = function(t) {
          (t === b.Eq || p(t)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = l.AfterAttributeName, this.stateAfterAttributeName(t));
        }, e.prototype.stateAfterAttributeName = function(t) {
          t === b.Eq ? this.state = l.BeforeAttributeValue : t === b.Slash || t === b.Gt ? (this.cbs.onattribend(i.NoValue, this.index), this.state = l.BeforeAttributeName, this.stateBeforeAttributeName(t)) : f(t) || (this.cbs.onattribend(i.NoValue, this.index), this.state = l.InAttributeName, this.sectionStart = this.index);
        }, e.prototype.stateBeforeAttributeValue = function(t) {
          t === b.DoubleQuote ? (this.state = l.InAttributeValueDq, this.sectionStart = this.index + 1) : t === b.SingleQuote ? (this.state = l.InAttributeValueSq, this.sectionStart = this.index + 1) : f(t) || (this.sectionStart = this.index, this.state = l.InAttributeValueNq, this.stateInAttributeValueNoQuotes(t));
        }, e.prototype.handleInAttributeValue = function(t, c) {
          t === c || !this.decodeEntities && this.fastForwardTo(c) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(c === b.DoubleQuote ? i.Double : i.Single, this.index), this.state = l.BeforeAttributeName) : this.decodeEntities && t === b.Amp && (this.baseState = this.state, this.state = l.BeforeEntity);
        }, e.prototype.stateInAttributeValueDoubleQuotes = function(t) {
          this.handleInAttributeValue(t, b.DoubleQuote);
        }, e.prototype.stateInAttributeValueSingleQuotes = function(t) {
          this.handleInAttributeValue(t, b.SingleQuote);
        }, e.prototype.stateInAttributeValueNoQuotes = function(t) {
          f(t) || t === b.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(i.Unquoted, this.index), this.state = l.BeforeAttributeName, this.stateBeforeAttributeName(t)) : this.decodeEntities && t === b.Amp && (this.baseState = this.state, this.state = l.BeforeEntity);
        }, e.prototype.stateBeforeDeclaration = function(t) {
          t === b.OpeningSquareBracket ? (this.state = l.CDATASequence, this.sequenceIndex = 0) : this.state = t === b.Dash ? l.BeforeComment : l.InDeclaration;
        }, e.prototype.stateInDeclaration = function(t) {
          (t === b.Gt || this.fastForwardTo(b.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = l.Text, this.sectionStart = this.index + 1);
        }, e.prototype.stateInProcessingInstruction = function(t) {
          (t === b.Gt || this.fastForwardTo(b.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = l.Text, this.sectionStart = this.index + 1);
        }, e.prototype.stateBeforeComment = function(t) {
          t === b.Dash ? (this.state = l.InCommentLike, this.currentSequence = r.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = l.InDeclaration;
        }, e.prototype.stateInSpecialComment = function(t) {
          (t === b.Gt || this.fastForwardTo(b.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = l.Text, this.sectionStart = this.index + 1);
        }, e.prototype.stateBeforeSpecialS = function(t) {
          var c = t | 32;
          c === r.ScriptEnd[3] ? this.startSpecial(r.ScriptEnd, 4) : c === r.StyleEnd[3] ? this.startSpecial(r.StyleEnd, 4) : (this.state = l.InTagName, this.stateInTagName(t));
        }, e.prototype.stateBeforeEntity = function(t) {
          this.entityExcess = 1, this.entityResult = 0, t === b.Number ? this.state = l.BeforeNumericEntity : t === b.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = l.InNamedEntity, this.stateInNamedEntity(t));
        }, e.prototype.stateInNamedEntity = function(t) {
          if (this.entityExcess += 1, this.trieIndex = (0, E.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, t), this.trieIndex < 0) {
            this.emitNamedEntity(), this.index--;
            return;
          }
          this.trieCurrent = this.entityTrie[this.trieIndex];
          var c = this.trieCurrent & E.BinTrieFlags.VALUE_LENGTH;
          if (c) {
            var m = (c >> 14) - 1;
            if (!this.allowLegacyEntity() && t !== b.Semi)
              this.trieIndex += m;
            else {
              var y = this.index - this.entityExcess + 1;
              y > this.sectionStart && this.emitPartial(this.sectionStart, y), this.entityResult = this.trieIndex, this.trieIndex += m, this.entityExcess = 0, this.sectionStart = this.index + 1, m === 0 && this.emitNamedEntity();
            }
          }
        }, e.prototype.emitNamedEntity = function() {
          if (this.state = this.baseState, this.entityResult !== 0) {
            var t = (this.entityTrie[this.entityResult] & E.BinTrieFlags.VALUE_LENGTH) >> 14;
            switch (t) {
              case 1: {
                this.emitCodePoint(this.entityTrie[this.entityResult] & ~E.BinTrieFlags.VALUE_LENGTH);
                break;
              }
              case 2: {
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                break;
              }
              case 3:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
            }
          }
        }, e.prototype.stateBeforeNumericEntity = function(t) {
          (t | 32) === b.LowerX ? (this.entityExcess++, this.state = l.InHexEntity) : (this.state = l.InNumericEntity, this.stateInNumericEntity(t));
        }, e.prototype.emitNumericEntity = function(t) {
          var c = this.index - this.entityExcess - 1, m = c + 2 + +(this.state === l.InHexEntity);
          m !== this.index && (c > this.sectionStart && this.emitPartial(this.sectionStart, c), this.sectionStart = this.index + Number(t), this.emitCodePoint((0, E.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
        }, e.prototype.stateInNumericEntity = function(t) {
          t === b.Semi ? this.emitNumericEntity(!0) : a(t) ? (this.entityResult = this.entityResult * 10 + (t - b.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
        }, e.prototype.stateInHexEntity = function(t) {
          t === b.Semi ? this.emitNumericEntity(!0) : a(t) ? (this.entityResult = this.entityResult * 16 + (t - b.Zero), this.entityExcess++) : h(t) ? (this.entityResult = this.entityResult * 16 + ((t | 32) - b.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
        }, e.prototype.allowLegacyEntity = function() {
          return !this.xmlMode && (this.baseState === l.Text || this.baseState === l.InSpecialTag);
        }, e.prototype.cleanup = function() {
          this.running && this.sectionStart !== this.index && (this.state === l.Text || this.state === l.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === l.InAttributeValueDq || this.state === l.InAttributeValueSq || this.state === l.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
        }, e.prototype.shouldContinue = function() {
          return this.index < this.buffer.length + this.offset && this.running;
        }, e.prototype.parse = function() {
          for (; this.shouldContinue(); ) {
            var t = this.buffer.charCodeAt(this.index - this.offset);
            switch (this.state) {
              case l.Text: {
                this.stateText(t);
                break;
              }
              case l.SpecialStartSequence: {
                this.stateSpecialStartSequence(t);
                break;
              }
              case l.InSpecialTag: {
                this.stateInSpecialTag(t);
                break;
              }
              case l.CDATASequence: {
                this.stateCDATASequence(t);
                break;
              }
              case l.InAttributeValueDq: {
                this.stateInAttributeValueDoubleQuotes(t);
                break;
              }
              case l.InAttributeName: {
                this.stateInAttributeName(t);
                break;
              }
              case l.InCommentLike: {
                this.stateInCommentLike(t);
                break;
              }
              case l.InSpecialComment: {
                this.stateInSpecialComment(t);
                break;
              }
              case l.BeforeAttributeName: {
                this.stateBeforeAttributeName(t);
                break;
              }
              case l.InTagName: {
                this.stateInTagName(t);
                break;
              }
              case l.InClosingTagName: {
                this.stateInClosingTagName(t);
                break;
              }
              case l.BeforeTagName: {
                this.stateBeforeTagName(t);
                break;
              }
              case l.AfterAttributeName: {
                this.stateAfterAttributeName(t);
                break;
              }
              case l.InAttributeValueSq: {
                this.stateInAttributeValueSingleQuotes(t);
                break;
              }
              case l.BeforeAttributeValue: {
                this.stateBeforeAttributeValue(t);
                break;
              }
              case l.BeforeClosingTagName: {
                this.stateBeforeClosingTagName(t);
                break;
              }
              case l.AfterClosingTagName: {
                this.stateAfterClosingTagName(t);
                break;
              }
              case l.BeforeSpecialS: {
                this.stateBeforeSpecialS(t);
                break;
              }
              case l.InAttributeValueNq: {
                this.stateInAttributeValueNoQuotes(t);
                break;
              }
              case l.InSelfClosingTag: {
                this.stateInSelfClosingTag(t);
                break;
              }
              case l.InDeclaration: {
                this.stateInDeclaration(t);
                break;
              }
              case l.BeforeDeclaration: {
                this.stateBeforeDeclaration(t);
                break;
              }
              case l.BeforeComment: {
                this.stateBeforeComment(t);
                break;
              }
              case l.InProcessingInstruction: {
                this.stateInProcessingInstruction(t);
                break;
              }
              case l.InNamedEntity: {
                this.stateInNamedEntity(t);
                break;
              }
              case l.BeforeEntity: {
                this.stateBeforeEntity(t);
                break;
              }
              case l.InHexEntity: {
                this.stateInHexEntity(t);
                break;
              }
              case l.InNumericEntity: {
                this.stateInNumericEntity(t);
                break;
              }
              default:
                this.stateBeforeNumericEntity(t);
            }
            this.index++;
          }
          this.cleanup();
        }, e.prototype.finish = function() {
          this.state === l.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
        }, e.prototype.handleTrailingData = function() {
          var t = this.buffer.length + this.offset;
          this.state === l.InCommentLike ? this.currentSequence === r.CdataEnd ? this.cbs.oncdata(this.sectionStart, t, 0) : this.cbs.oncomment(this.sectionStart, t, 0) : this.state === l.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === l.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === l.InTagName || this.state === l.BeforeAttributeName || this.state === l.BeforeAttributeValue || this.state === l.AfterAttributeName || this.state === l.InAttributeName || this.state === l.InAttributeValueSq || this.state === l.InAttributeValueDq || this.state === l.InAttributeValueNq || this.state === l.InClosingTagName || this.cbs.ontext(this.sectionStart, t);
        }, e.prototype.emitPartial = function(t, c) {
          this.baseState !== l.Text && this.baseState !== l.InSpecialTag ? this.cbs.onattribdata(t, c) : this.cbs.ontext(t, c);
        }, e.prototype.emitCodePoint = function(t) {
          this.baseState !== l.Text && this.baseState !== l.InSpecialTag ? this.cbs.onattribentity(t) : this.cbs.ontextentity(t);
        }, e;
      }()
    );
    u.default = s;
  }(wt)), wt;
}
var Lu;
function Iu() {
  if (Lu) return he;
  Lu = 1;
  var u = he && he.__createBinding || (Object.create ? function(y, n, g, v) {
    v === void 0 && (v = g);
    var x = Object.getOwnPropertyDescriptor(n, g);
    (!x || ("get" in x ? !n.__esModule : x.writable || x.configurable)) && (x = { enumerable: !0, get: function() {
      return n[g];
    } }), Object.defineProperty(y, v, x);
  } : function(y, n, g, v) {
    v === void 0 && (v = g), y[v] = n[g];
  }), E = he && he.__setModuleDefault || (Object.create ? function(y, n) {
    Object.defineProperty(y, "default", { enumerable: !0, value: n });
  } : function(y, n) {
    y.default = n;
  }), b = he && he.__importStar || function(y) {
    if (y && y.__esModule) return y;
    var n = {};
    if (y != null) for (var g in y) g !== "default" && Object.prototype.hasOwnProperty.call(y, g) && u(n, y, g);
    return E(n, y), n;
  };
  Object.defineProperty(he, "__esModule", { value: !0 }), he.Parser = void 0;
  var l = b(/* @__PURE__ */ jr()), f = /* @__PURE__ */ at(), p = /* @__PURE__ */ new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
  ]), a = /* @__PURE__ */ new Set(["p"]), d = /* @__PURE__ */ new Set(["thead", "tbody"]), h = /* @__PURE__ */ new Set(["dd", "dt"]), i = /* @__PURE__ */ new Set(["rt", "rp"]), r = /* @__PURE__ */ new Map([
    ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
    ["th", /* @__PURE__ */ new Set(["th"])],
    ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
    ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
    ["li", /* @__PURE__ */ new Set(["li"])],
    ["p", a],
    ["h1", a],
    ["h2", a],
    ["h3", a],
    ["h4", a],
    ["h5", a],
    ["h6", a],
    ["select", p],
    ["input", p],
    ["output", p],
    ["button", p],
    ["datalist", p],
    ["textarea", p],
    ["option", /* @__PURE__ */ new Set(["option"])],
    ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
    ["dd", h],
    ["dt", h],
    ["address", a],
    ["article", a],
    ["aside", a],
    ["blockquote", a],
    ["details", a],
    ["div", a],
    ["dl", a],
    ["fieldset", a],
    ["figcaption", a],
    ["figure", a],
    ["footer", a],
    ["form", a],
    ["header", a],
    ["hr", a],
    ["main", a],
    ["nav", a],
    ["ol", a],
    ["pre", a],
    ["section", a],
    ["table", a],
    ["ul", a],
    ["rt", i],
    ["rp", i],
    ["tbody", d],
    ["tfoot", d]
  ]), s = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]), e = /* @__PURE__ */ new Set(["math", "svg"]), t = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
  ]), c = /\s|\//, m = (
    /** @class */
    function() {
      function y(n, g) {
        g === void 0 && (g = {});
        var v, x, o, w, S;
        this.options = g, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = n ?? {}, this.lowerCaseTagNames = (v = g.lowerCaseTags) !== null && v !== void 0 ? v : !g.xmlMode, this.lowerCaseAttributeNames = (x = g.lowerCaseAttributeNames) !== null && x !== void 0 ? x : !g.xmlMode, this.tokenizer = new ((o = g.Tokenizer) !== null && o !== void 0 ? o : l.default)(this.options, this), (S = (w = this.cbs).onparserinit) === null || S === void 0 || S.call(w, this);
      }
      return y.prototype.ontext = function(n, g) {
        var v, x, o = this.getSlice(n, g);
        this.endIndex = g - 1, (x = (v = this.cbs).ontext) === null || x === void 0 || x.call(v, o), this.startIndex = g;
      }, y.prototype.ontextentity = function(n) {
        var g, v, x = this.tokenizer.getSectionStart();
        this.endIndex = x - 1, (v = (g = this.cbs).ontext) === null || v === void 0 || v.call(g, (0, f.fromCodePoint)(n)), this.startIndex = x;
      }, y.prototype.isVoidElement = function(n) {
        return !this.options.xmlMode && s.has(n);
      }, y.prototype.onopentagname = function(n, g) {
        this.endIndex = g;
        var v = this.getSlice(n, g);
        this.lowerCaseTagNames && (v = v.toLowerCase()), this.emitOpenTag(v);
      }, y.prototype.emitOpenTag = function(n) {
        var g, v, x, o;
        this.openTagStart = this.startIndex, this.tagname = n;
        var w = !this.options.xmlMode && r.get(n);
        if (w)
          for (; this.stack.length > 0 && w.has(this.stack[this.stack.length - 1]); ) {
            var S = this.stack.pop();
            (v = (g = this.cbs).onclosetag) === null || v === void 0 || v.call(g, S, !0);
          }
        this.isVoidElement(n) || (this.stack.push(n), e.has(n) ? this.foreignContext.push(!0) : t.has(n) && this.foreignContext.push(!1)), (o = (x = this.cbs).onopentagname) === null || o === void 0 || o.call(x, n), this.cbs.onopentag && (this.attribs = {});
      }, y.prototype.endOpenTag = function(n) {
        var g, v;
        this.startIndex = this.openTagStart, this.attribs && ((v = (g = this.cbs).onopentag) === null || v === void 0 || v.call(g, this.tagname, this.attribs, n), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
      }, y.prototype.onopentagend = function(n) {
        this.endIndex = n, this.endOpenTag(!1), this.startIndex = n + 1;
      }, y.prototype.onclosetag = function(n, g) {
        var v, x, o, w, S, A;
        this.endIndex = g;
        var C = this.getSlice(n, g);
        if (this.lowerCaseTagNames && (C = C.toLowerCase()), (e.has(C) || t.has(C)) && this.foreignContext.pop(), this.isVoidElement(C))
          !this.options.xmlMode && C === "br" && ((x = (v = this.cbs).onopentagname) === null || x === void 0 || x.call(v, "br"), (w = (o = this.cbs).onopentag) === null || w === void 0 || w.call(o, "br", {}, !0), (A = (S = this.cbs).onclosetag) === null || A === void 0 || A.call(S, "br", !1));
        else {
          var R = this.stack.lastIndexOf(C);
          if (R !== -1)
            if (this.cbs.onclosetag)
              for (var q = this.stack.length - R; q--; )
                this.cbs.onclosetag(this.stack.pop(), q !== 0);
            else
              this.stack.length = R;
          else !this.options.xmlMode && C === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
        }
        this.startIndex = g + 1;
      }, y.prototype.onselfclosingtag = function(n) {
        this.endIndex = n, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = n + 1) : this.onopentagend(n);
      }, y.prototype.closeCurrentTag = function(n) {
        var g, v, x = this.tagname;
        this.endOpenTag(n), this.stack[this.stack.length - 1] === x && ((v = (g = this.cbs).onclosetag) === null || v === void 0 || v.call(g, x, !n), this.stack.pop());
      }, y.prototype.onattribname = function(n, g) {
        this.startIndex = n;
        var v = this.getSlice(n, g);
        this.attribname = this.lowerCaseAttributeNames ? v.toLowerCase() : v;
      }, y.prototype.onattribdata = function(n, g) {
        this.attribvalue += this.getSlice(n, g);
      }, y.prototype.onattribentity = function(n) {
        this.attribvalue += (0, f.fromCodePoint)(n);
      }, y.prototype.onattribend = function(n, g) {
        var v, x;
        this.endIndex = g, (x = (v = this.cbs).onattribute) === null || x === void 0 || x.call(v, this.attribname, this.attribvalue, n === l.QuoteType.Double ? '"' : n === l.QuoteType.Single ? "'" : n === l.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
      }, y.prototype.getInstructionName = function(n) {
        var g = n.search(c), v = g < 0 ? n : n.substr(0, g);
        return this.lowerCaseTagNames && (v = v.toLowerCase()), v;
      }, y.prototype.ondeclaration = function(n, g) {
        this.endIndex = g;
        var v = this.getSlice(n, g);
        if (this.cbs.onprocessinginstruction) {
          var x = this.getInstructionName(v);
          this.cbs.onprocessinginstruction("!".concat(x), "!".concat(v));
        }
        this.startIndex = g + 1;
      }, y.prototype.onprocessinginstruction = function(n, g) {
        this.endIndex = g;
        var v = this.getSlice(n, g);
        if (this.cbs.onprocessinginstruction) {
          var x = this.getInstructionName(v);
          this.cbs.onprocessinginstruction("?".concat(x), "?".concat(v));
        }
        this.startIndex = g + 1;
      }, y.prototype.oncomment = function(n, g, v) {
        var x, o, w, S;
        this.endIndex = g, (o = (x = this.cbs).oncomment) === null || o === void 0 || o.call(x, this.getSlice(n, g - v)), (S = (w = this.cbs).oncommentend) === null || S === void 0 || S.call(w), this.startIndex = g + 1;
      }, y.prototype.oncdata = function(n, g, v) {
        var x, o, w, S, A, C, R, q, O, I;
        this.endIndex = g;
        var k = this.getSlice(n, g - v);
        this.options.xmlMode || this.options.recognizeCDATA ? ((o = (x = this.cbs).oncdatastart) === null || o === void 0 || o.call(x), (S = (w = this.cbs).ontext) === null || S === void 0 || S.call(w, k), (C = (A = this.cbs).oncdataend) === null || C === void 0 || C.call(A)) : ((q = (R = this.cbs).oncomment) === null || q === void 0 || q.call(R, "[CDATA[".concat(k, "]]")), (I = (O = this.cbs).oncommentend) === null || I === void 0 || I.call(O)), this.startIndex = g + 1;
      }, y.prototype.onend = function() {
        var n, g;
        if (this.cbs.onclosetag) {
          this.endIndex = this.startIndex;
          for (var v = this.stack.length; v > 0; this.cbs.onclosetag(this.stack[--v], !0))
            ;
        }
        (g = (n = this.cbs).onend) === null || g === void 0 || g.call(n);
      }, y.prototype.reset = function() {
        var n, g, v, x;
        (g = (n = this.cbs).onreset) === null || g === void 0 || g.call(n), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (x = (v = this.cbs).onparserinit) === null || x === void 0 || x.call(v, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
      }, y.prototype.parseComplete = function(n) {
        this.reset(), this.end(n);
      }, y.prototype.getSlice = function(n, g) {
        for (; n - this.bufferOffset >= this.buffers[0].length; )
          this.shiftBuffer();
        for (var v = this.buffers[0].slice(n - this.bufferOffset, g - this.bufferOffset); g - this.bufferOffset > this.buffers[0].length; )
          this.shiftBuffer(), v += this.buffers[0].slice(0, g - this.bufferOffset);
        return v;
      }, y.prototype.shiftBuffer = function() {
        this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
      }, y.prototype.write = function(n) {
        var g, v;
        if (this.ended) {
          (v = (g = this.cbs).onerror) === null || v === void 0 || v.call(g, new Error(".write() after done!"));
          return;
        }
        this.buffers.push(n), this.tokenizer.running && (this.tokenizer.write(n), this.writeIndex++);
      }, y.prototype.end = function(n) {
        var g, v;
        if (this.ended) {
          (v = (g = this.cbs).onerror) === null || v === void 0 || v.call(g, new Error(".end() after done!"));
          return;
        }
        n && this.write(n), this.ended = !0, this.tokenizer.end();
      }, y.prototype.pause = function() {
        this.tokenizer.pause();
      }, y.prototype.resume = function() {
        for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
          this.tokenizer.write(this.buffers[this.writeIndex++]);
        this.ended && this.tokenizer.end();
      }, y.prototype.parseChunk = function(n) {
        this.write(n);
      }, y.prototype.done = function(n) {
        this.end(n);
      }, y;
    }()
  );
  return he.Parser = m, he;
}
var Pe = {}, St = {}, Pu;
function We() {
  return Pu || (Pu = 1, function(u) {
    Object.defineProperty(u, "__esModule", { value: !0 }), u.Doctype = u.CDATA = u.Tag = u.Style = u.Script = u.Comment = u.Directive = u.Text = u.Root = u.isTag = u.ElementType = void 0;
    var E;
    (function(l) {
      l.Root = "root", l.Text = "text", l.Directive = "directive", l.Comment = "comment", l.Script = "script", l.Style = "style", l.Tag = "tag", l.CDATA = "cdata", l.Doctype = "doctype";
    })(E = u.ElementType || (u.ElementType = {}));
    function b(l) {
      return l.type === E.Tag || l.type === E.Script || l.type === E.Style;
    }
    u.isTag = b, u.Root = E.Root, u.Text = E.Text, u.Directive = E.Directive, u.Comment = E.Comment, u.Script = E.Script, u.Style = E.Style, u.Tag = E.Tag, u.CDATA = E.CDATA, u.Doctype = E.Doctype;
  }(St)), St;
}
var V = {}, ku;
function Mu() {
  if (ku) return V;
  ku = 1;
  var u = V && V.__extends || /* @__PURE__ */ function() {
    var o = function(w, S) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(A, C) {
        A.__proto__ = C;
      } || function(A, C) {
        for (var R in C) Object.prototype.hasOwnProperty.call(C, R) && (A[R] = C[R]);
      }, o(w, S);
    };
    return function(w, S) {
      if (typeof S != "function" && S !== null)
        throw new TypeError("Class extends value " + String(S) + " is not a constructor or null");
      o(w, S);
      function A() {
        this.constructor = w;
      }
      w.prototype = S === null ? Object.create(S) : (A.prototype = S.prototype, new A());
    };
  }(), E = V && V.__assign || function() {
    return E = Object.assign || function(o) {
      for (var w, S = 1, A = arguments.length; S < A; S++) {
        w = arguments[S];
        for (var C in w) Object.prototype.hasOwnProperty.call(w, C) && (o[C] = w[C]);
      }
      return o;
    }, E.apply(this, arguments);
  };
  Object.defineProperty(V, "__esModule", { value: !0 }), V.cloneNode = V.hasChildren = V.isDocument = V.isDirective = V.isComment = V.isText = V.isCDATA = V.isTag = V.Element = V.Document = V.CDATA = V.NodeWithChildren = V.ProcessingInstruction = V.Comment = V.Text = V.DataNode = V.Node = void 0;
  var b = /* @__PURE__ */ We(), l = (
    /** @class */
    function() {
      function o() {
        this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
      }
      return Object.defineProperty(o.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.parent;
        },
        set: function(w) {
          this.parent = w;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.prev;
        },
        set: function(w) {
          this.prev = w;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.next;
        },
        set: function(w) {
          this.next = w;
        },
        enumerable: !1,
        configurable: !0
      }), o.prototype.cloneNode = function(w) {
        return w === void 0 && (w = !1), v(this, w);
      }, o;
    }()
  );
  V.Node = l;
  var f = (
    /** @class */
    function(o) {
      u(w, o);
      function w(S) {
        var A = o.call(this) || this;
        return A.data = S, A;
      }
      return Object.defineProperty(w.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.data;
        },
        set: function(S) {
          this.data = S;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(l)
  );
  V.DataNode = f;
  var p = (
    /** @class */
    function(o) {
      u(w, o);
      function w() {
        var S = o !== null && o.apply(this, arguments) || this;
        return S.type = b.ElementType.Text, S;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 3;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(f)
  );
  V.Text = p;
  var a = (
    /** @class */
    function(o) {
      u(w, o);
      function w() {
        var S = o !== null && o.apply(this, arguments) || this;
        return S.type = b.ElementType.Comment, S;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 8;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(f)
  );
  V.Comment = a;
  var d = (
    /** @class */
    function(o) {
      u(w, o);
      function w(S, A) {
        var C = o.call(this, A) || this;
        return C.name = S, C.type = b.ElementType.Directive, C;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(f)
  );
  V.ProcessingInstruction = d;
  var h = (
    /** @class */
    function(o) {
      u(w, o);
      function w(S) {
        var A = o.call(this) || this;
        return A.children = S, A;
      }
      return Object.defineProperty(w.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function() {
          var S;
          return (S = this.children[0]) !== null && S !== void 0 ? S : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "lastChild", {
        /** Last child of the node. */
        get: function() {
          return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.children;
        },
        set: function(S) {
          this.children = S;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(l)
  );
  V.NodeWithChildren = h;
  var i = (
    /** @class */
    function(o) {
      u(w, o);
      function w() {
        var S = o !== null && o.apply(this, arguments) || this;
        return S.type = b.ElementType.CDATA, S;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 4;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(h)
  );
  V.CDATA = i;
  var r = (
    /** @class */
    function(o) {
      u(w, o);
      function w() {
        var S = o !== null && o.apply(this, arguments) || this;
        return S.type = b.ElementType.Root, S;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 9;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(h)
  );
  V.Document = r;
  var s = (
    /** @class */
    function(o) {
      u(w, o);
      function w(S, A, C, R) {
        C === void 0 && (C = []), R === void 0 && (R = S === "script" ? b.ElementType.Script : S === "style" ? b.ElementType.Style : b.ElementType.Tag);
        var q = o.call(this, C) || this;
        return q.name = S, q.attribs = A, q.type = R, q;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.name;
        },
        set: function(S) {
          this.name = S;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "attributes", {
        get: function() {
          var S = this;
          return Object.keys(this.attribs).map(function(A) {
            var C, R;
            return {
              name: A,
              value: S.attribs[A],
              namespace: (C = S["x-attribsNamespace"]) === null || C === void 0 ? void 0 : C[A],
              prefix: (R = S["x-attribsPrefix"]) === null || R === void 0 ? void 0 : R[A]
            };
          });
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(h)
  );
  V.Element = s;
  function e(o) {
    return (0, b.isTag)(o);
  }
  V.isTag = e;
  function t(o) {
    return o.type === b.ElementType.CDATA;
  }
  V.isCDATA = t;
  function c(o) {
    return o.type === b.ElementType.Text;
  }
  V.isText = c;
  function m(o) {
    return o.type === b.ElementType.Comment;
  }
  V.isComment = m;
  function y(o) {
    return o.type === b.ElementType.Directive;
  }
  V.isDirective = y;
  function n(o) {
    return o.type === b.ElementType.Root;
  }
  V.isDocument = n;
  function g(o) {
    return Object.prototype.hasOwnProperty.call(o, "children");
  }
  V.hasChildren = g;
  function v(o, w) {
    w === void 0 && (w = !1);
    var S;
    if (c(o))
      S = new p(o.data);
    else if (m(o))
      S = new a(o.data);
    else if (e(o)) {
      var A = w ? x(o.children) : [], C = new s(o.name, E({}, o.attribs), A);
      A.forEach(function(I) {
        return I.parent = C;
      }), o.namespace != null && (C.namespace = o.namespace), o["x-attribsNamespace"] && (C["x-attribsNamespace"] = E({}, o["x-attribsNamespace"])), o["x-attribsPrefix"] && (C["x-attribsPrefix"] = E({}, o["x-attribsPrefix"])), S = C;
    } else if (t(o)) {
      var A = w ? x(o.children) : [], R = new i(A);
      A.forEach(function(k) {
        return k.parent = R;
      }), S = R;
    } else if (n(o)) {
      var A = w ? x(o.children) : [], q = new r(A);
      A.forEach(function(k) {
        return k.parent = q;
      }), o["x-mode"] && (q["x-mode"] = o["x-mode"]), S = q;
    } else if (y(o)) {
      var O = new d(o.name, o.data);
      o["x-name"] != null && (O["x-name"] = o["x-name"], O["x-publicId"] = o["x-publicId"], O["x-systemId"] = o["x-systemId"]), S = O;
    } else
      throw new Error("Not implemented yet: ".concat(o.type));
    return S.startIndex = o.startIndex, S.endIndex = o.endIndex, o.sourceCodeLocation != null && (S.sourceCodeLocation = o.sourceCodeLocation), S;
  }
  V.cloneNode = v;
  function x(o) {
    for (var w = o.map(function(A) {
      return v(A, !0);
    }), S = 1; S < w.length; S++)
      w[S].prev = w[S - 1], w[S - 1].next = w[S];
    return w;
  }
  return V;
}
var ju;
function De() {
  return ju || (ju = 1, function(u) {
    var E = Pe && Pe.__createBinding || (Object.create ? function(d, h, i, r) {
      r === void 0 && (r = i);
      var s = Object.getOwnPropertyDescriptor(h, i);
      (!s || ("get" in s ? !h.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return h[i];
      } }), Object.defineProperty(d, r, s);
    } : function(d, h, i, r) {
      r === void 0 && (r = i), d[r] = h[i];
    }), b = Pe && Pe.__exportStar || function(d, h) {
      for (var i in d) i !== "default" && !Object.prototype.hasOwnProperty.call(h, i) && E(h, d, i);
    };
    Object.defineProperty(u, "__esModule", { value: !0 }), u.DomHandler = void 0;
    var l = /* @__PURE__ */ We(), f = /* @__PURE__ */ Mu();
    b(/* @__PURE__ */ Mu(), u);
    var p = {
      withStartIndices: !1,
      withEndIndices: !1,
      xmlMode: !1
    }, a = (
      /** @class */
      function() {
        function d(h, i, r) {
          this.dom = [], this.root = new f.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof i == "function" && (r = i, i = p), typeof h == "object" && (i = h, h = void 0), this.callback = h ?? null, this.options = i ?? p, this.elementCB = r ?? null;
        }
        return d.prototype.onparserinit = function(h) {
          this.parser = h;
        }, d.prototype.onreset = function() {
          this.dom = [], this.root = new f.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
        }, d.prototype.onend = function() {
          this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
        }, d.prototype.onerror = function(h) {
          this.handleCallback(h);
        }, d.prototype.onclosetag = function() {
          this.lastNode = null;
          var h = this.tagStack.pop();
          this.options.withEndIndices && (h.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(h);
        }, d.prototype.onopentag = function(h, i) {
          var r = this.options.xmlMode ? l.ElementType.Tag : void 0, s = new f.Element(h, i, void 0, r);
          this.addNode(s), this.tagStack.push(s);
        }, d.prototype.ontext = function(h) {
          var i = this.lastNode;
          if (i && i.type === l.ElementType.Text)
            i.data += h, this.options.withEndIndices && (i.endIndex = this.parser.endIndex);
          else {
            var r = new f.Text(h);
            this.addNode(r), this.lastNode = r;
          }
        }, d.prototype.oncomment = function(h) {
          if (this.lastNode && this.lastNode.type === l.ElementType.Comment) {
            this.lastNode.data += h;
            return;
          }
          var i = new f.Comment(h);
          this.addNode(i), this.lastNode = i;
        }, d.prototype.oncommentend = function() {
          this.lastNode = null;
        }, d.prototype.oncdatastart = function() {
          var h = new f.Text(""), i = new f.CDATA([h]);
          this.addNode(i), h.parent = i, this.lastNode = h;
        }, d.prototype.oncdataend = function() {
          this.lastNode = null;
        }, d.prototype.onprocessinginstruction = function(h, i) {
          var r = new f.ProcessingInstruction(h, i);
          this.addNode(r);
        }, d.prototype.handleCallback = function(h) {
          if (typeof this.callback == "function")
            this.callback(h, this.dom);
          else if (h)
            throw h;
        }, d.prototype.addNode = function(h) {
          var i = this.tagStack[this.tagStack.length - 1], r = i.children[i.children.length - 1];
          this.options.withStartIndices && (h.startIndex = this.parser.startIndex), this.options.withEndIndices && (h.endIndex = this.parser.endIndex), i.children.push(h), r && (h.prev = r, r.next = h), h.parent = i, this.lastNode = null;
        }, d;
      }()
    );
    u.DomHandler = a, u.default = a;
  }(Pe)), Pe;
}
var ke = {}, ve = {}, se = {}, Tt = {}, Te = {}, et = {}, Bu;
function yi() {
  if (Bu) return et;
  Bu = 1, Object.defineProperty(et, "__esModule", { value: !0 });
  function u(E) {
    for (var b = 1; b < E.length; b++)
      E[b][0] += E[b - 1][0] + 1;
    return E;
  }
  return et.default = new Map(/* @__PURE__ */ u([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ u([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ u([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ u([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]])), et;
}
var At = {}, Uu;
function au() {
  return Uu || (Uu = 1, function(u) {
    Object.defineProperty(u, "__esModule", { value: !0 }), u.escapeText = u.escapeAttribute = u.escapeUTF8 = u.escape = u.encodeXML = u.getCodePoint = u.xmlReplacer = void 0, u.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
    var E = /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [39, "&apos;"],
      [60, "&lt;"],
      [62, "&gt;"]
    ]);
    u.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? function(f, p) {
      return f.codePointAt(p);
    } : (
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      function(f, p) {
        return (f.charCodeAt(p) & 64512) === 55296 ? (f.charCodeAt(p) - 55296) * 1024 + f.charCodeAt(p + 1) - 56320 + 65536 : f.charCodeAt(p);
      }
    );
    function b(f) {
      for (var p = "", a = 0, d; (d = u.xmlReplacer.exec(f)) !== null; ) {
        var h = d.index, i = f.charCodeAt(h), r = E.get(i);
        r !== void 0 ? (p += f.substring(a, h) + r, a = h + 1) : (p += "".concat(f.substring(a, h), "&#x").concat((0, u.getCodePoint)(f, h).toString(16), ";"), a = u.xmlReplacer.lastIndex += +((i & 64512) === 55296));
      }
      return p + f.substr(a);
    }
    u.encodeXML = b, u.escape = b;
    function l(f, p) {
      return function(d) {
        for (var h, i = 0, r = ""; h = f.exec(d); )
          i !== h.index && (r += d.substring(i, h.index)), r += p.get(h[0].charCodeAt(0)), i = h.index + 1;
        return r + d.substring(i);
      };
    }
    u.escapeUTF8 = l(/[&<>'"]/g, E), u.escapeAttribute = l(/["&\u00A0]/g, /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [160, "&nbsp;"]
    ])), u.escapeText = l(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
      [38, "&amp;"],
      [60, "&lt;"],
      [62, "&gt;"],
      [160, "&nbsp;"]
    ]));
  }(At)), At;
}
var Hu;
function Vu() {
  if (Hu) return Te;
  Hu = 1;
  var u = Te && Te.__importDefault || function(d) {
    return d && d.__esModule ? d : { default: d };
  };
  Object.defineProperty(Te, "__esModule", { value: !0 }), Te.encodeNonAsciiHTML = Te.encodeHTML = void 0;
  var E = u(/* @__PURE__ */ yi()), b = /* @__PURE__ */ au(), l = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
  function f(d) {
    return a(l, d);
  }
  Te.encodeHTML = f;
  function p(d) {
    return a(b.xmlReplacer, d);
  }
  Te.encodeNonAsciiHTML = p;
  function a(d, h) {
    for (var i = "", r = 0, s; (s = d.exec(h)) !== null; ) {
      var e = s.index;
      i += h.substring(r, e);
      var t = h.charCodeAt(e), c = E.default.get(t);
      if (typeof c == "object") {
        if (e + 1 < h.length) {
          var m = h.charCodeAt(e + 1), y = typeof c.n == "number" ? c.n === m ? c.o : void 0 : c.n.get(m);
          if (y !== void 0) {
            i += y, r = d.lastIndex += 1;
            continue;
          }
        }
        c = c.v;
      }
      if (c !== void 0)
        i += c, r = e + 1;
      else {
        var n = (0, b.getCodePoint)(h, e);
        i += "&#x".concat(n.toString(16), ";"), r = d.lastIndex += +(n !== t);
      }
    }
    return i + h.substr(r);
  }
  return Te;
}
var Fu;
function xi() {
  return Fu || (Fu = 1, function(u) {
    Object.defineProperty(u, "__esModule", { value: !0 }), u.decodeXMLStrict = u.decodeHTML5Strict = u.decodeHTML4Strict = u.decodeHTML5 = u.decodeHTML4 = u.decodeHTMLAttribute = u.decodeHTMLStrict = u.decodeHTML = u.decodeXML = u.DecodingMode = u.EntityDecoder = u.encodeHTML5 = u.encodeHTML4 = u.encodeNonAsciiHTML = u.encodeHTML = u.escapeText = u.escapeAttribute = u.escapeUTF8 = u.escape = u.encodeXML = u.encode = u.decodeStrict = u.decode = u.EncodingMode = u.EntityLevel = void 0;
    var E = /* @__PURE__ */ at(), b = /* @__PURE__ */ Vu(), l = /* @__PURE__ */ au(), f;
    (function(e) {
      e[e.XML = 0] = "XML", e[e.HTML = 1] = "HTML";
    })(f = u.EntityLevel || (u.EntityLevel = {}));
    var p;
    (function(e) {
      e[e.UTF8 = 0] = "UTF8", e[e.ASCII = 1] = "ASCII", e[e.Extensive = 2] = "Extensive", e[e.Attribute = 3] = "Attribute", e[e.Text = 4] = "Text";
    })(p = u.EncodingMode || (u.EncodingMode = {}));
    function a(e, t) {
      t === void 0 && (t = f.XML);
      var c = typeof t == "number" ? t : t.level;
      if (c === f.HTML) {
        var m = typeof t == "object" ? t.mode : void 0;
        return (0, E.decodeHTML)(e, m);
      }
      return (0, E.decodeXML)(e);
    }
    u.decode = a;
    function d(e, t) {
      var c;
      t === void 0 && (t = f.XML);
      var m = typeof t == "number" ? { level: t } : t;
      return (c = m.mode) !== null && c !== void 0 || (m.mode = E.DecodingMode.Strict), a(e, m);
    }
    u.decodeStrict = d;
    function h(e, t) {
      t === void 0 && (t = f.XML);
      var c = typeof t == "number" ? { level: t } : t;
      return c.mode === p.UTF8 ? (0, l.escapeUTF8)(e) : c.mode === p.Attribute ? (0, l.escapeAttribute)(e) : c.mode === p.Text ? (0, l.escapeText)(e) : c.level === f.HTML ? c.mode === p.ASCII ? (0, b.encodeNonAsciiHTML)(e) : (0, b.encodeHTML)(e) : (0, l.encodeXML)(e);
    }
    u.encode = h;
    var i = /* @__PURE__ */ au();
    Object.defineProperty(u, "encodeXML", { enumerable: !0, get: function() {
      return i.encodeXML;
    } }), Object.defineProperty(u, "escape", { enumerable: !0, get: function() {
      return i.escape;
    } }), Object.defineProperty(u, "escapeUTF8", { enumerable: !0, get: function() {
      return i.escapeUTF8;
    } }), Object.defineProperty(u, "escapeAttribute", { enumerable: !0, get: function() {
      return i.escapeAttribute;
    } }), Object.defineProperty(u, "escapeText", { enumerable: !0, get: function() {
      return i.escapeText;
    } });
    var r = /* @__PURE__ */ Vu();
    Object.defineProperty(u, "encodeHTML", { enumerable: !0, get: function() {
      return r.encodeHTML;
    } }), Object.defineProperty(u, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
      return r.encodeNonAsciiHTML;
    } }), Object.defineProperty(u, "encodeHTML4", { enumerable: !0, get: function() {
      return r.encodeHTML;
    } }), Object.defineProperty(u, "encodeHTML5", { enumerable: !0, get: function() {
      return r.encodeHTML;
    } });
    var s = /* @__PURE__ */ at();
    Object.defineProperty(u, "EntityDecoder", { enumerable: !0, get: function() {
      return s.EntityDecoder;
    } }), Object.defineProperty(u, "DecodingMode", { enumerable: !0, get: function() {
      return s.DecodingMode;
    } }), Object.defineProperty(u, "decodeXML", { enumerable: !0, get: function() {
      return s.decodeXML;
    } }), Object.defineProperty(u, "decodeHTML", { enumerable: !0, get: function() {
      return s.decodeHTML;
    } }), Object.defineProperty(u, "decodeHTMLStrict", { enumerable: !0, get: function() {
      return s.decodeHTMLStrict;
    } }), Object.defineProperty(u, "decodeHTMLAttribute", { enumerable: !0, get: function() {
      return s.decodeHTMLAttribute;
    } }), Object.defineProperty(u, "decodeHTML4", { enumerable: !0, get: function() {
      return s.decodeHTML;
    } }), Object.defineProperty(u, "decodeHTML5", { enumerable: !0, get: function() {
      return s.decodeHTML;
    } }), Object.defineProperty(u, "decodeHTML4Strict", { enumerable: !0, get: function() {
      return s.decodeHTMLStrict;
    } }), Object.defineProperty(u, "decodeHTML5Strict", { enumerable: !0, get: function() {
      return s.decodeHTMLStrict;
    } }), Object.defineProperty(u, "decodeXMLStrict", { enumerable: !0, get: function() {
      return s.decodeXML;
    } });
  }(Tt)), Tt;
}
var Me = {}, zu;
function wi() {
  return zu || (zu = 1, Object.defineProperty(Me, "__esModule", { value: !0 }), Me.attributeNames = Me.elementNames = void 0, Me.elementNames = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
  ].map(function(u) {
    return [u.toLowerCase(), u];
  })), Me.attributeNames = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
  ].map(function(u) {
    return [u.toLowerCase(), u];
  }))), Me;
}
var Gu;
function Ei() {
  if (Gu) return se;
  Gu = 1;
  var u = se && se.__assign || function() {
    return u = Object.assign || function(x) {
      for (var o, w = 1, S = arguments.length; w < S; w++) {
        o = arguments[w];
        for (var A in o) Object.prototype.hasOwnProperty.call(o, A) && (x[A] = o[A]);
      }
      return x;
    }, u.apply(this, arguments);
  }, E = se && se.__createBinding || (Object.create ? function(x, o, w, S) {
    S === void 0 && (S = w);
    var A = Object.getOwnPropertyDescriptor(o, w);
    (!A || ("get" in A ? !o.__esModule : A.writable || A.configurable)) && (A = { enumerable: !0, get: function() {
      return o[w];
    } }), Object.defineProperty(x, S, A);
  } : function(x, o, w, S) {
    S === void 0 && (S = w), x[S] = o[w];
  }), b = se && se.__setModuleDefault || (Object.create ? function(x, o) {
    Object.defineProperty(x, "default", { enumerable: !0, value: o });
  } : function(x, o) {
    x.default = o;
  }), l = se && se.__importStar || function(x) {
    if (x && x.__esModule) return x;
    var o = {};
    if (x != null) for (var w in x) w !== "default" && Object.prototype.hasOwnProperty.call(x, w) && E(o, x, w);
    return b(o, x), o;
  };
  Object.defineProperty(se, "__esModule", { value: !0 }), se.render = void 0;
  var f = l(/* @__PURE__ */ We()), p = /* @__PURE__ */ xi(), a = /* @__PURE__ */ wi(), d = /* @__PURE__ */ new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
  ]);
  function h(x) {
    return x.replace(/"/g, "&quot;");
  }
  function i(x, o) {
    var w;
    if (x) {
      var S = ((w = o.encodeEntities) !== null && w !== void 0 ? w : o.decodeEntities) === !1 ? h : o.xmlMode || o.encodeEntities !== "utf8" ? p.encodeXML : p.escapeAttribute;
      return Object.keys(x).map(function(A) {
        var C, R, q = (C = x[A]) !== null && C !== void 0 ? C : "";
        return o.xmlMode === "foreign" && (A = (R = a.attributeNames.get(A)) !== null && R !== void 0 ? R : A), !o.emptyAttrs && !o.xmlMode && q === "" ? A : "".concat(A, '="').concat(S(q), '"');
      }).join(" ");
    }
  }
  var r = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]);
  function s(x, o) {
    o === void 0 && (o = {});
    for (var w = ("length" in x) ? x : [x], S = "", A = 0; A < w.length; A++)
      S += e(w[A], o);
    return S;
  }
  se.render = s, se.default = s;
  function e(x, o) {
    switch (x.type) {
      case f.Root:
        return s(x.children, o);
      // @ts-expect-error We don't use `Doctype` yet
      case f.Doctype:
      case f.Directive:
        return y(x);
      case f.Comment:
        return v(x);
      case f.CDATA:
        return g(x);
      case f.Script:
      case f.Style:
      case f.Tag:
        return m(x, o);
      case f.Text:
        return n(x, o);
    }
  }
  var t = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
  ]), c = /* @__PURE__ */ new Set(["svg", "math"]);
  function m(x, o) {
    var w;
    o.xmlMode === "foreign" && (x.name = (w = a.elementNames.get(x.name)) !== null && w !== void 0 ? w : x.name, x.parent && t.has(x.parent.name) && (o = u(u({}, o), { xmlMode: !1 }))), !o.xmlMode && c.has(x.name) && (o = u(u({}, o), { xmlMode: "foreign" }));
    var S = "<".concat(x.name), A = i(x.attribs, o);
    return A && (S += " ".concat(A)), x.children.length === 0 && (o.xmlMode ? (
      // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
      o.selfClosingTags !== !1
    ) : (
      // User explicitly asked for self-closing tags, even in HTML mode
      o.selfClosingTags && r.has(x.name)
    )) ? (o.xmlMode || (S += " "), S += "/>") : (S += ">", x.children.length > 0 && (S += s(x.children, o)), (o.xmlMode || !r.has(x.name)) && (S += "</".concat(x.name, ">"))), S;
  }
  function y(x) {
    return "<".concat(x.data, ">");
  }
  function n(x, o) {
    var w, S = x.data || "";
    return ((w = o.encodeEntities) !== null && w !== void 0 ? w : o.decodeEntities) !== !1 && !(!o.xmlMode && x.parent && d.has(x.parent.name)) && (S = o.xmlMode || o.encodeEntities !== "utf8" ? (0, p.encodeXML)(S) : (0, p.escapeText)(S)), S;
  }
  function g(x) {
    return "<![CDATA[".concat(x.children[0].data, "]]>");
  }
  function v(x) {
    return "<!--".concat(x.data, "-->");
  }
  return se;
}
var $u;
function Br() {
  if ($u) return ve;
  $u = 1;
  var u = ve && ve.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(ve, "__esModule", { value: !0 }), ve.getOuterHTML = f, ve.getInnerHTML = p, ve.getText = a, ve.textContent = d, ve.innerText = h;
  var E = /* @__PURE__ */ De(), b = u(/* @__PURE__ */ Ei()), l = /* @__PURE__ */ We();
  function f(i, r) {
    return (0, b.default)(i, r);
  }
  function p(i, r) {
    return (0, E.hasChildren)(i) ? i.children.map(function(s) {
      return f(s, r);
    }).join("") : "";
  }
  function a(i) {
    return Array.isArray(i) ? i.map(a).join("") : (0, E.isTag)(i) ? i.name === "br" ? `
` : a(i.children) : (0, E.isCDATA)(i) ? a(i.children) : (0, E.isText)(i) ? i.data : "";
  }
  function d(i) {
    return Array.isArray(i) ? i.map(d).join("") : (0, E.hasChildren)(i) && !(0, E.isComment)(i) ? d(i.children) : (0, E.isText)(i) ? i.data : "";
  }
  function h(i) {
    return Array.isArray(i) ? i.map(h).join("") : (0, E.hasChildren)(i) && (i.type === l.ElementType.Tag || (0, E.isCDATA)(i)) ? h(i.children) : (0, E.isText)(i) ? i.data : "";
  }
  return ve;
}
var be = {}, Wu;
function Si() {
  if (Wu) return be;
  Wu = 1, Object.defineProperty(be, "__esModule", { value: !0 }), be.getChildren = E, be.getParent = b, be.getSiblings = l, be.getAttributeValue = f, be.hasAttrib = p, be.getName = a, be.nextElementSibling = d, be.prevElementSibling = h;
  var u = /* @__PURE__ */ De();
  function E(i) {
    return (0, u.hasChildren)(i) ? i.children : [];
  }
  function b(i) {
    return i.parent || null;
  }
  function l(i) {
    var r, s, e = b(i);
    if (e != null)
      return E(e);
    for (var t = [i], c = i.prev, m = i.next; c != null; )
      t.unshift(c), r = c, c = r.prev;
    for (; m != null; )
      t.push(m), s = m, m = s.next;
    return t;
  }
  function f(i, r) {
    var s;
    return (s = i.attribs) === null || s === void 0 ? void 0 : s[r];
  }
  function p(i, r) {
    return i.attribs != null && Object.prototype.hasOwnProperty.call(i.attribs, r) && i.attribs[r] != null;
  }
  function a(i) {
    return i.name;
  }
  function d(i) {
    for (var r, s = i.next; s !== null && !(0, u.isTag)(s); )
      r = s, s = r.next;
    return s;
  }
  function h(i) {
    for (var r, s = i.prev; s !== null && !(0, u.isTag)(s); )
      r = s, s = r.prev;
    return s;
  }
  return be;
}
var Ae = {}, Yu;
function Ti() {
  if (Yu) return Ae;
  Yu = 1, Object.defineProperty(Ae, "__esModule", { value: !0 }), Ae.removeElement = u, Ae.replaceElement = E, Ae.appendChild = b, Ae.append = l, Ae.prependChild = f, Ae.prepend = p;
  function u(a) {
    if (a.prev && (a.prev.next = a.next), a.next && (a.next.prev = a.prev), a.parent) {
      var d = a.parent.children, h = d.lastIndexOf(a);
      h >= 0 && d.splice(h, 1);
    }
    a.next = null, a.prev = null, a.parent = null;
  }
  function E(a, d) {
    var h = d.prev = a.prev;
    h && (h.next = d);
    var i = d.next = a.next;
    i && (i.prev = d);
    var r = d.parent = a.parent;
    if (r) {
      var s = r.children;
      s[s.lastIndexOf(a)] = d, a.parent = null;
    }
  }
  function b(a, d) {
    if (u(d), d.next = null, d.parent = a, a.children.push(d) > 1) {
      var h = a.children[a.children.length - 2];
      h.next = d, d.prev = h;
    } else
      d.prev = null;
  }
  function l(a, d) {
    u(d);
    var h = a.parent, i = a.next;
    if (d.next = i, d.prev = a, a.next = d, d.parent = h, i) {
      if (i.prev = d, h) {
        var r = h.children;
        r.splice(r.lastIndexOf(i), 0, d);
      }
    } else h && h.children.push(d);
  }
  function f(a, d) {
    if (u(d), d.parent = a, d.prev = null, a.children.unshift(d) !== 1) {
      var h = a.children[1];
      h.prev = d, d.next = h;
    } else
      d.next = null;
  }
  function p(a, d) {
    u(d);
    var h = a.parent;
    if (h) {
      var i = h.children;
      i.splice(i.indexOf(a), 0, d);
    }
    a.prev && (a.prev.next = d), d.parent = h, d.prev = a.prev, d.next = a, a.prev = d;
  }
  return Ae;
}
var qe = {}, Ju;
function Ur() {
  if (Ju) return qe;
  Ju = 1, Object.defineProperty(qe, "__esModule", { value: !0 }), qe.filter = E, qe.find = b, qe.findOneChild = l, qe.findOne = f, qe.existsOne = p, qe.findAll = a;
  var u = /* @__PURE__ */ De();
  function E(d, h, i, r) {
    return i === void 0 && (i = !0), r === void 0 && (r = 1 / 0), b(d, Array.isArray(h) ? h : [h], i, r);
  }
  function b(d, h, i, r) {
    for (var s = [], e = [Array.isArray(h) ? h : [h]], t = [0]; ; ) {
      if (t[0] >= e[0].length) {
        if (t.length === 1)
          return s;
        e.shift(), t.shift();
        continue;
      }
      var c = e[0][t[0]++];
      if (d(c) && (s.push(c), --r <= 0))
        return s;
      i && (0, u.hasChildren)(c) && c.children.length > 0 && (t.unshift(0), e.unshift(c.children));
    }
  }
  function l(d, h) {
    return h.find(d);
  }
  function f(d, h, i) {
    i === void 0 && (i = !0);
    for (var r = Array.isArray(h) ? h : [h], s = 0; s < r.length; s++) {
      var e = r[s];
      if ((0, u.isTag)(e) && d(e))
        return e;
      if (i && (0, u.hasChildren)(e) && e.children.length > 0) {
        var t = f(d, e.children, !0);
        if (t)
          return t;
      }
    }
    return null;
  }
  function p(d, h) {
    return (Array.isArray(h) ? h : [h]).some(function(i) {
      return (0, u.isTag)(i) && d(i) || (0, u.hasChildren)(i) && p(d, i.children);
    });
  }
  function a(d, h) {
    for (var i = [], r = [Array.isArray(h) ? h : [h]], s = [0]; ; ) {
      if (s[0] >= r[0].length) {
        if (r.length === 1)
          return i;
        r.shift(), s.shift();
        continue;
      }
      var e = r[0][s[0]++];
      (0, u.isTag)(e) && d(e) && i.push(e), (0, u.hasChildren)(e) && e.children.length > 0 && (s.unshift(0), r.unshift(e.children));
    }
  }
  return qe;
}
var Oe = {}, Zu;
function Hr() {
  if (Zu) return Oe;
  Zu = 1, Object.defineProperty(Oe, "__esModule", { value: !0 }), Oe.testElement = a, Oe.getElements = d, Oe.getElementById = h, Oe.getElementsByTagName = i, Oe.getElementsByClassName = r, Oe.getElementsByTagType = s;
  var u = /* @__PURE__ */ De(), E = /* @__PURE__ */ Ur(), b = {
    tag_name: function(e) {
      return typeof e == "function" ? function(t) {
        return (0, u.isTag)(t) && e(t.name);
      } : e === "*" ? u.isTag : function(t) {
        return (0, u.isTag)(t) && t.name === e;
      };
    },
    tag_type: function(e) {
      return typeof e == "function" ? function(t) {
        return e(t.type);
      } : function(t) {
        return t.type === e;
      };
    },
    tag_contains: function(e) {
      return typeof e == "function" ? function(t) {
        return (0, u.isText)(t) && e(t.data);
      } : function(t) {
        return (0, u.isText)(t) && t.data === e;
      };
    }
  };
  function l(e, t) {
    return typeof t == "function" ? function(c) {
      return (0, u.isTag)(c) && t(c.attribs[e]);
    } : function(c) {
      return (0, u.isTag)(c) && c.attribs[e] === t;
    };
  }
  function f(e, t) {
    return function(c) {
      return e(c) || t(c);
    };
  }
  function p(e) {
    var t = Object.keys(e).map(function(c) {
      var m = e[c];
      return Object.prototype.hasOwnProperty.call(b, c) ? b[c](m) : l(c, m);
    });
    return t.length === 0 ? null : t.reduce(f);
  }
  function a(e, t) {
    var c = p(e);
    return c ? c(t) : !0;
  }
  function d(e, t, c, m) {
    m === void 0 && (m = 1 / 0);
    var y = p(e);
    return y ? (0, E.filter)(y, t, c, m) : [];
  }
  function h(e, t, c) {
    return c === void 0 && (c = !0), Array.isArray(t) || (t = [t]), (0, E.findOne)(l("id", e), t, c);
  }
  function i(e, t, c, m) {
    return c === void 0 && (c = !0), m === void 0 && (m = 1 / 0), (0, E.filter)(b.tag_name(e), t, c, m);
  }
  function r(e, t, c, m) {
    return c === void 0 && (c = !0), m === void 0 && (m = 1 / 0), (0, E.filter)(l("class", e), t, c, m);
  }
  function s(e, t, c, m) {
    return c === void 0 && (c = !0), m === void 0 && (m = 1 / 0), (0, E.filter)(b.tag_type(e), t, c, m);
  }
  return Oe;
}
var Ce = {}, Xu;
function Ai() {
  if (Xu) return Ce;
  Xu = 1, Object.defineProperty(Ce, "__esModule", { value: !0 }), Ce.DocumentPosition = void 0, Ce.removeSubsets = E, Ce.compareDocumentPosition = l, Ce.uniqueSort = f;
  var u = /* @__PURE__ */ De();
  function E(p) {
    for (var a = p.length; --a >= 0; ) {
      var d = p[a];
      if (a > 0 && p.lastIndexOf(d, a - 1) >= 0) {
        p.splice(a, 1);
        continue;
      }
      for (var h = d.parent; h; h = h.parent)
        if (p.includes(h)) {
          p.splice(a, 1);
          break;
        }
    }
    return p;
  }
  var b;
  (function(p) {
    p[p.DISCONNECTED = 1] = "DISCONNECTED", p[p.PRECEDING = 2] = "PRECEDING", p[p.FOLLOWING = 4] = "FOLLOWING", p[p.CONTAINS = 8] = "CONTAINS", p[p.CONTAINED_BY = 16] = "CONTAINED_BY";
  })(b || (Ce.DocumentPosition = b = {}));
  function l(p, a) {
    var d = [], h = [];
    if (p === a)
      return 0;
    for (var i = (0, u.hasChildren)(p) ? p : p.parent; i; )
      d.unshift(i), i = i.parent;
    for (i = (0, u.hasChildren)(a) ? a : a.parent; i; )
      h.unshift(i), i = i.parent;
    for (var r = Math.min(d.length, h.length), s = 0; s < r && d[s] === h[s]; )
      s++;
    if (s === 0)
      return b.DISCONNECTED;
    var e = d[s - 1], t = e.children, c = d[s], m = h[s];
    return t.indexOf(c) > t.indexOf(m) ? e === a ? b.FOLLOWING | b.CONTAINED_BY : b.FOLLOWING : e === p ? b.PRECEDING | b.CONTAINS : b.PRECEDING;
  }
  function f(p) {
    return p = p.filter(function(a, d, h) {
      return !h.includes(a, d + 1);
    }), p.sort(function(a, d) {
      var h = l(a, d);
      return h & b.PRECEDING ? -1 : h & b.FOLLOWING ? 1 : 0;
    }), p;
  }
  return Ce;
}
var tt = {}, Qu;
function qi() {
  if (Qu) return tt;
  Qu = 1, Object.defineProperty(tt, "__esModule", { value: !0 }), tt.getFeed = b;
  var u = /* @__PURE__ */ Br(), E = /* @__PURE__ */ Hr();
  function b(e) {
    var t = h(s, e);
    return t ? t.name === "feed" ? l(t) : f(t) : null;
  }
  function l(e) {
    var t, c = e.children, m = {
      type: "atom",
      items: (0, E.getElementsByTagName)("entry", c).map(function(g) {
        var v, x = g.children, o = { media: d(x) };
        r(o, "id", "id", x), r(o, "title", "title", x);
        var w = (v = h("link", x)) === null || v === void 0 ? void 0 : v.attribs.href;
        w && (o.link = w);
        var S = i("summary", x) || i("content", x);
        S && (o.description = S);
        var A = i("updated", x);
        return A && (o.pubDate = new Date(A)), o;
      })
    };
    r(m, "id", "id", c), r(m, "title", "title", c);
    var y = (t = h("link", c)) === null || t === void 0 ? void 0 : t.attribs.href;
    y && (m.link = y), r(m, "description", "subtitle", c);
    var n = i("updated", c);
    return n && (m.updated = new Date(n)), r(m, "author", "email", c, !0), m;
  }
  function f(e) {
    var t, c, m = (c = (t = h("channel", e.children)) === null || t === void 0 ? void 0 : t.children) !== null && c !== void 0 ? c : [], y = {
      type: e.name.substr(0, 3),
      id: "",
      items: (0, E.getElementsByTagName)("item", e.children).map(function(g) {
        var v = g.children, x = { media: d(v) };
        r(x, "id", "guid", v), r(x, "title", "title", v), r(x, "link", "link", v), r(x, "description", "description", v);
        var o = i("pubDate", v) || i("dc:date", v);
        return o && (x.pubDate = new Date(o)), x;
      })
    };
    r(y, "title", "title", m), r(y, "link", "link", m), r(y, "description", "description", m);
    var n = i("lastBuildDate", m);
    return n && (y.updated = new Date(n)), r(y, "author", "managingEditor", m, !0), y;
  }
  var p = ["url", "type", "lang"], a = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
  ];
  function d(e) {
    return (0, E.getElementsByTagName)("media:content", e).map(function(t) {
      for (var c = t.attribs, m = {
        medium: c.medium,
        isDefault: !!c.isDefault
      }, y = 0, n = p; y < n.length; y++) {
        var g = n[y];
        c[g] && (m[g] = c[g]);
      }
      for (var v = 0, x = a; v < x.length; v++) {
        var g = x[v];
        c[g] && (m[g] = parseInt(c[g], 10));
      }
      return c.expression && (m.expression = c.expression), m;
    });
  }
  function h(e, t) {
    return (0, E.getElementsByTagName)(e, t, !0, 1)[0];
  }
  function i(e, t, c) {
    return c === void 0 && (c = !1), (0, u.textContent)((0, E.getElementsByTagName)(e, t, c, 1)).trim();
  }
  function r(e, t, c, m, y) {
    y === void 0 && (y = !1);
    var n = i(c, m, y);
    n && (e[t] = n);
  }
  function s(e) {
    return e === "rss" || e === "feed" || e === "rdf:RDF";
  }
  return tt;
}
var Ku;
function qt() {
  return Ku || (Ku = 1, function(u) {
    var E = ke && ke.__createBinding || (Object.create ? function(f, p, a, d) {
      d === void 0 && (d = a);
      var h = Object.getOwnPropertyDescriptor(p, a);
      (!h || ("get" in h ? !p.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
        return p[a];
      } }), Object.defineProperty(f, d, h);
    } : function(f, p, a, d) {
      d === void 0 && (d = a), f[d] = p[a];
    }), b = ke && ke.__exportStar || function(f, p) {
      for (var a in f) a !== "default" && !Object.prototype.hasOwnProperty.call(p, a) && E(p, f, a);
    };
    Object.defineProperty(u, "__esModule", { value: !0 }), u.hasChildren = u.isDocument = u.isComment = u.isText = u.isCDATA = u.isTag = void 0, b(/* @__PURE__ */ Br(), u), b(/* @__PURE__ */ Si(), u), b(/* @__PURE__ */ Ti(), u), b(/* @__PURE__ */ Ur(), u), b(/* @__PURE__ */ Hr(), u), b(/* @__PURE__ */ Ai(), u), b(/* @__PURE__ */ qi(), u);
    var l = /* @__PURE__ */ De();
    Object.defineProperty(u, "isTag", { enumerable: !0, get: function() {
      return l.isTag;
    } }), Object.defineProperty(u, "isCDATA", { enumerable: !0, get: function() {
      return l.isCDATA;
    } }), Object.defineProperty(u, "isText", { enumerable: !0, get: function() {
      return l.isText;
    } }), Object.defineProperty(u, "isComment", { enumerable: !0, get: function() {
      return l.isComment;
    } }), Object.defineProperty(u, "isDocument", { enumerable: !0, get: function() {
      return l.isDocument;
    } }), Object.defineProperty(u, "hasChildren", { enumerable: !0, get: function() {
      return l.hasChildren;
    } });
  }(ke)), ke;
}
var er;
function Oi() {
  return er || (er = 1, function(u) {
    var E = de && de.__createBinding || (Object.create ? function(n, g, v, x) {
      x === void 0 && (x = v);
      var o = Object.getOwnPropertyDescriptor(g, v);
      (!o || ("get" in o ? !g.__esModule : o.writable || o.configurable)) && (o = { enumerable: !0, get: function() {
        return g[v];
      } }), Object.defineProperty(n, x, o);
    } : function(n, g, v, x) {
      x === void 0 && (x = v), n[x] = g[v];
    }), b = de && de.__setModuleDefault || (Object.create ? function(n, g) {
      Object.defineProperty(n, "default", { enumerable: !0, value: g });
    } : function(n, g) {
      n.default = g;
    }), l = de && de.__importStar || function(n) {
      if (n && n.__esModule) return n;
      var g = {};
      if (n != null) for (var v in n) v !== "default" && Object.prototype.hasOwnProperty.call(n, v) && E(g, n, v);
      return b(g, n), g;
    }, f = de && de.__importDefault || function(n) {
      return n && n.__esModule ? n : { default: n };
    };
    Object.defineProperty(u, "__esModule", { value: !0 }), u.DomUtils = u.parseFeed = u.getFeed = u.ElementType = u.Tokenizer = u.createDomStream = u.parseDOM = u.parseDocument = u.DefaultHandler = u.DomHandler = u.Parser = void 0;
    var p = /* @__PURE__ */ Iu(), a = /* @__PURE__ */ Iu();
    Object.defineProperty(u, "Parser", { enumerable: !0, get: function() {
      return a.Parser;
    } });
    var d = /* @__PURE__ */ De(), h = /* @__PURE__ */ De();
    Object.defineProperty(u, "DomHandler", { enumerable: !0, get: function() {
      return h.DomHandler;
    } }), Object.defineProperty(u, "DefaultHandler", { enumerable: !0, get: function() {
      return h.DomHandler;
    } });
    function i(n, g) {
      var v = new d.DomHandler(void 0, g);
      return new p.Parser(v, g).end(n), v.root;
    }
    u.parseDocument = i;
    function r(n, g) {
      return i(n, g).children;
    }
    u.parseDOM = r;
    function s(n, g, v) {
      var x = new d.DomHandler(n, g, v);
      return new p.Parser(x, g);
    }
    u.createDomStream = s;
    var e = /* @__PURE__ */ jr();
    Object.defineProperty(u, "Tokenizer", { enumerable: !0, get: function() {
      return f(e).default;
    } }), u.ElementType = l(/* @__PURE__ */ We());
    var t = /* @__PURE__ */ qt(), c = /* @__PURE__ */ qt();
    Object.defineProperty(u, "getFeed", { enumerable: !0, get: function() {
      return c.getFeed;
    } });
    var m = { xmlMode: !0 };
    function y(n, g) {
      return g === void 0 && (g = m), (0, t.getFeed)(r(n, g));
    }
    u.parseFeed = y, u.DomUtils = l(/* @__PURE__ */ qt());
  }(de)), de;
}
var Ot, tr;
function _i() {
  return tr || (tr = 1, Ot = (u) => {
    if (typeof u != "string")
      throw new TypeError("Expected a string");
    return u.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  }), Ot;
}
var ut = {}, ur;
function Ni() {
  if (ur) return ut;
  ur = 1, Object.defineProperty(ut, "__esModule", { value: !0 });
  /*!
   * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
   *
   * Copyright (c) 2014-2017, Jon Schlinkert.
   * Released under the MIT License.
   */
  function u(b) {
    return Object.prototype.toString.call(b) === "[object Object]";
  }
  function E(b) {
    var l, f;
    return u(b) === !1 ? !1 : (l = b.constructor, l === void 0 ? !0 : (f = l.prototype, !(u(f) === !1 || f.hasOwnProperty("isPrototypeOf") === !1)));
  }
  return ut.isPlainObject = E, ut;
}
var _t, rr;
function Ri() {
  if (rr) return _t;
  rr = 1;
  var u = function(g) {
    return E(g) && !b(g);
  };
  function E(n) {
    return !!n && typeof n == "object";
  }
  function b(n) {
    var g = Object.prototype.toString.call(n);
    return g === "[object RegExp]" || g === "[object Date]" || p(n);
  }
  var l = typeof Symbol == "function" && Symbol.for, f = l ? Symbol.for("react.element") : 60103;
  function p(n) {
    return n.$$typeof === f;
  }
  function a(n) {
    return Array.isArray(n) ? [] : {};
  }
  function d(n, g) {
    return g.clone !== !1 && g.isMergeableObject(n) ? m(a(n), n, g) : n;
  }
  function h(n, g, v) {
    return n.concat(g).map(function(x) {
      return d(x, v);
    });
  }
  function i(n, g) {
    if (!g.customMerge)
      return m;
    var v = g.customMerge(n);
    return typeof v == "function" ? v : m;
  }
  function r(n) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(n).filter(function(g) {
      return Object.propertyIsEnumerable.call(n, g);
    }) : [];
  }
  function s(n) {
    return Object.keys(n).concat(r(n));
  }
  function e(n, g) {
    try {
      return g in n;
    } catch {
      return !1;
    }
  }
  function t(n, g) {
    return e(n, g) && !(Object.hasOwnProperty.call(n, g) && Object.propertyIsEnumerable.call(n, g));
  }
  function c(n, g, v) {
    var x = {};
    return v.isMergeableObject(n) && s(n).forEach(function(o) {
      x[o] = d(n[o], v);
    }), s(g).forEach(function(o) {
      t(n, o) || (e(n, o) && v.isMergeableObject(g[o]) ? x[o] = i(o, v)(n[o], g[o], v) : x[o] = d(g[o], v));
    }), x;
  }
  function m(n, g, v) {
    v = v || {}, v.arrayMerge = v.arrayMerge || h, v.isMergeableObject = v.isMergeableObject || u, v.cloneUnlessOtherwiseSpecified = d;
    var x = Array.isArray(g), o = Array.isArray(n), w = x === o;
    return w ? x ? v.arrayMerge(n, g, v) : c(n, g, v) : d(g, v);
  }
  m.all = function(g, v) {
    if (!Array.isArray(g))
      throw new Error("first argument should be an array");
    return g.reduce(function(x, o) {
      return m(x, o, v);
    }, {});
  };
  var y = m;
  return _t = y, _t;
}
var nt = { exports: {} }, Ci = nt.exports, ir;
function Di() {
  return ir || (ir = 1, function(u) {
    (function(E, b) {
      u.exports ? u.exports = b() : E.parseSrcset = b();
    })(Ci, function() {
      return function(E) {
        function b(x) {
          return x === " " || // space
          x === "	" || // horizontal tab
          x === `
` || // new line
          x === "\f" || // form feed
          x === "\r";
        }
        function l(x) {
          var o, w = x.exec(E.substring(y));
          if (w)
            return o = w[0], y += o.length, o;
        }
        for (var f = E.length, p = /^[ \t\n\r\u000c]+/, a = /^[, \t\n\r\u000c]+/, d = /^[^ \t\n\r\u000c]+/, h = /[,]+$/, i = /^\d+$/, r = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, s, e, t, c, m, y = 0, n = []; ; ) {
          if (l(a), y >= f)
            return n;
          s = l(d), e = [], s.slice(-1) === "," ? (s = s.replace(h, ""), v()) : g();
        }
        function g() {
          for (l(p), t = "", c = "in descriptor"; ; ) {
            if (m = E.charAt(y), c === "in descriptor")
              if (b(m))
                t && (e.push(t), t = "", c = "after descriptor");
              else if (m === ",") {
                y += 1, t && e.push(t), v();
                return;
              } else if (m === "(")
                t = t + m, c = "in parens";
              else if (m === "") {
                t && e.push(t), v();
                return;
              } else
                t = t + m;
            else if (c === "in parens")
              if (m === ")")
                t = t + m, c = "in descriptor";
              else if (m === "") {
                e.push(t), v();
                return;
              } else
                t = t + m;
            else if (c === "after descriptor" && !b(m))
              if (m === "") {
                v();
                return;
              } else
                c = "in descriptor", y -= 1;
            y += 1;
          }
        }
        function v() {
          var x = !1, o, w, S, A, C = {}, R, q, O, I, k;
          for (A = 0; A < e.length; A++)
            R = e[A], q = R[R.length - 1], O = R.substring(0, R.length - 1), I = parseInt(O, 10), k = parseFloat(O), i.test(O) && q === "w" ? ((o || w) && (x = !0), I === 0 ? x = !0 : o = I) : r.test(O) && q === "x" ? ((o || w || S) && (x = !0), k < 0 ? x = !0 : w = k) : i.test(O) && q === "h" ? ((S || w) && (x = !0), I === 0 ? x = !0 : S = I) : x = !0;
          x ? console && console.log && console.log("Invalid srcset descriptor found in '" + E + "' at '" + R + "'.") : (C.url = s, o && (C.w = o), w && (C.d = w), S && (C.h = S), n.push(C));
        }
      };
    });
  }(nt)), nt.exports;
}
var rt = { exports: {} }, nr;
function Li() {
  if (nr) return rt.exports;
  nr = 1;
  var u = String, E = function() {
    return { isColorSupported: !1, reset: u, bold: u, dim: u, italic: u, underline: u, inverse: u, hidden: u, strikethrough: u, black: u, red: u, green: u, yellow: u, blue: u, magenta: u, cyan: u, white: u, gray: u, bgBlack: u, bgRed: u, bgGreen: u, bgYellow: u, bgBlue: u, bgMagenta: u, bgCyan: u, bgWhite: u, blackBright: u, redBright: u, greenBright: u, yellowBright: u, blueBright: u, magentaBright: u, cyanBright: u, whiteBright: u, bgBlackBright: u, bgRedBright: u, bgGreenBright: u, bgYellowBright: u, bgBlueBright: u, bgMagentaBright: u, bgCyanBright: u, bgWhiteBright: u };
  };
  return rt.exports = E(), rt.exports.createColors = E, rt.exports;
}
const Ii = {}, Pi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ii
}, Symbol.toStringTag, { value: "Module" })), me = /* @__PURE__ */ hi(Pi);
var Nt, ar;
function su() {
  if (ar) return Nt;
  ar = 1;
  let u = /* @__PURE__ */ Li(), E = me;
  class b extends Error {
    constructor(f, p, a, d, h, i) {
      super(f), this.name = "CssSyntaxError", this.reason = f, h && (this.file = h), d && (this.source = d), i && (this.plugin = i), typeof p < "u" && typeof a < "u" && (typeof p == "number" ? (this.line = p, this.column = a) : (this.line = p.line, this.column = p.column, this.endLine = a.line, this.endColumn = a.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, b);
    }
    setMessage() {
      this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
    }
    showSourceCode(f) {
      if (!this.source) return "";
      let p = this.source;
      f == null && (f = u.isColorSupported);
      let a = (t) => t, d = (t) => t, h = (t) => t;
      if (f) {
        let { bold: t, gray: c, red: m } = u.createColors(!0);
        d = (y) => t(m(y)), a = (y) => c(y), E && (h = (y) => E(y));
      }
      let i = p.split(/\r?\n/), r = Math.max(this.line - 3, 0), s = Math.min(this.line + 2, i.length), e = String(s).length;
      return i.slice(r, s).map((t, c) => {
        let m = r + 1 + c, y = " " + (" " + m).slice(-e) + " | ";
        if (m === this.line) {
          if (t.length > 160) {
            let g = 20, v = Math.max(0, this.column - g), x = Math.max(
              this.column + g,
              this.endColumn + g
            ), o = t.slice(v, x), w = a(y.replace(/\d/g, " ")) + t.slice(0, Math.min(this.column - 1, g - 1)).replace(/[^\t]/g, " ");
            return d(">") + a(y) + h(o) + `
 ` + w + d("^");
          }
          let n = a(y.replace(/\d/g, " ")) + t.slice(0, this.column - 1).replace(/[^\t]/g, " ");
          return d(">") + a(y) + h(t) + `
 ` + n + d("^");
        }
        return " " + a(y) + h(t);
      }).join(`
`);
    }
    toString() {
      let f = this.showSourceCode();
      return f && (f = `

` + f + `
`), this.name + ": " + this.message + f;
    }
  }
  return Nt = b, b.default = b, Nt;
}
var Rt, sr;
function Vr() {
  if (sr) return Rt;
  sr = 1;
  const u = {
    after: `
`,
    beforeClose: `
`,
    beforeComment: `
`,
    beforeDecl: `
`,
    beforeOpen: " ",
    beforeRule: `
`,
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: !1
  };
  function E(l) {
    return l[0].toUpperCase() + l.slice(1);
  }
  class b {
    constructor(f) {
      this.builder = f;
    }
    atrule(f, p) {
      let a = "@" + f.name, d = f.params ? this.rawValue(f, "params") : "";
      if (typeof f.raws.afterName < "u" ? a += f.raws.afterName : d && (a += " "), f.nodes)
        this.block(f, a + d);
      else {
        let h = (f.raws.between || "") + (p ? ";" : "");
        this.builder(a + d + h, f);
      }
    }
    beforeAfter(f, p) {
      let a;
      f.type === "decl" ? a = this.raw(f, null, "beforeDecl") : f.type === "comment" ? a = this.raw(f, null, "beforeComment") : p === "before" ? a = this.raw(f, null, "beforeRule") : a = this.raw(f, null, "beforeClose");
      let d = f.parent, h = 0;
      for (; d && d.type !== "root"; )
        h += 1, d = d.parent;
      if (a.includes(`
`)) {
        let i = this.raw(f, null, "indent");
        if (i.length)
          for (let r = 0; r < h; r++) a += i;
      }
      return a;
    }
    block(f, p) {
      let a = this.raw(f, "between", "beforeOpen");
      this.builder(p + a + "{", f, "start");
      let d;
      f.nodes && f.nodes.length ? (this.body(f), d = this.raw(f, "after")) : d = this.raw(f, "after", "emptyBody"), d && this.builder(d), this.builder("}", f, "end");
    }
    body(f) {
      let p = f.nodes.length - 1;
      for (; p > 0 && f.nodes[p].type === "comment"; )
        p -= 1;
      let a = this.raw(f, "semicolon");
      for (let d = 0; d < f.nodes.length; d++) {
        let h = f.nodes[d], i = this.raw(h, "before");
        i && this.builder(i), this.stringify(h, p !== d || a);
      }
    }
    comment(f) {
      let p = this.raw(f, "left", "commentLeft"), a = this.raw(f, "right", "commentRight");
      this.builder("/*" + p + f.text + a + "*/", f);
    }
    decl(f, p) {
      let a = this.raw(f, "between", "colon"), d = f.prop + a + this.rawValue(f, "value");
      f.important && (d += f.raws.important || " !important"), p && (d += ";"), this.builder(d, f);
    }
    document(f) {
      this.body(f);
    }
    raw(f, p, a) {
      let d;
      if (a || (a = p), p && (d = f.raws[p], typeof d < "u"))
        return d;
      let h = f.parent;
      if (a === "before" && (!h || h.type === "root" && h.first === f || h && h.type === "document"))
        return "";
      if (!h) return u[a];
      let i = f.root();
      if (i.rawCache || (i.rawCache = {}), typeof i.rawCache[a] < "u")
        return i.rawCache[a];
      if (a === "before" || a === "after")
        return this.beforeAfter(f, a);
      {
        let r = "raw" + E(a);
        this[r] ? d = this[r](i, f) : i.walk((s) => {
          if (d = s.raws[p], typeof d < "u") return !1;
        });
      }
      return typeof d > "u" && (d = u[a]), i.rawCache[a] = d, d;
    }
    rawBeforeClose(f) {
      let p;
      return f.walk((a) => {
        if (a.nodes && a.nodes.length > 0 && typeof a.raws.after < "u")
          return p = a.raws.after, p.includes(`
`) && (p = p.replace(/[^\n]+$/, "")), !1;
      }), p && (p = p.replace(/\S/g, "")), p;
    }
    rawBeforeComment(f, p) {
      let a;
      return f.walkComments((d) => {
        if (typeof d.raws.before < "u")
          return a = d.raws.before, a.includes(`
`) && (a = a.replace(/[^\n]+$/, "")), !1;
      }), typeof a > "u" ? a = this.raw(p, null, "beforeDecl") : a && (a = a.replace(/\S/g, "")), a;
    }
    rawBeforeDecl(f, p) {
      let a;
      return f.walkDecls((d) => {
        if (typeof d.raws.before < "u")
          return a = d.raws.before, a.includes(`
`) && (a = a.replace(/[^\n]+$/, "")), !1;
      }), typeof a > "u" ? a = this.raw(p, null, "beforeRule") : a && (a = a.replace(/\S/g, "")), a;
    }
    rawBeforeOpen(f) {
      let p;
      return f.walk((a) => {
        if (a.type !== "decl" && (p = a.raws.between, typeof p < "u"))
          return !1;
      }), p;
    }
    rawBeforeRule(f) {
      let p;
      return f.walk((a) => {
        if (a.nodes && (a.parent !== f || f.first !== a) && typeof a.raws.before < "u")
          return p = a.raws.before, p.includes(`
`) && (p = p.replace(/[^\n]+$/, "")), !1;
      }), p && (p = p.replace(/\S/g, "")), p;
    }
    rawColon(f) {
      let p;
      return f.walkDecls((a) => {
        if (typeof a.raws.between < "u")
          return p = a.raws.between.replace(/[^\s:]/g, ""), !1;
      }), p;
    }
    rawEmptyBody(f) {
      let p;
      return f.walk((a) => {
        if (a.nodes && a.nodes.length === 0 && (p = a.raws.after, typeof p < "u"))
          return !1;
      }), p;
    }
    rawIndent(f) {
      if (f.raws.indent) return f.raws.indent;
      let p;
      return f.walk((a) => {
        let d = a.parent;
        if (d && d !== f && d.parent && d.parent === f && typeof a.raws.before < "u") {
          let h = a.raws.before.split(`
`);
          return p = h[h.length - 1], p = p.replace(/\S/g, ""), !1;
        }
      }), p;
    }
    rawSemicolon(f) {
      let p;
      return f.walk((a) => {
        if (a.nodes && a.nodes.length && a.last.type === "decl" && (p = a.raws.semicolon, typeof p < "u"))
          return !1;
      }), p;
    }
    rawValue(f, p) {
      let a = f[p], d = f.raws[p];
      return d && d.value === a ? d.raw : a;
    }
    root(f) {
      this.body(f), f.raws.after && this.builder(f.raws.after);
    }
    rule(f) {
      this.block(f, this.rawValue(f, "selector")), f.raws.ownSemicolon && this.builder(f.raws.ownSemicolon, f, "end");
    }
    stringify(f, p) {
      if (!this[f.type])
        throw new Error(
          "Unknown AST node type " + f.type + ". Maybe you need to change PostCSS stringifier."
        );
      this[f.type](f, p);
    }
  }
  return Rt = b, b.default = b, Rt;
}
var Ct, or;
function ot() {
  if (or) return Ct;
  or = 1;
  let u = Vr();
  function E(b, l) {
    new u(l).stringify(b);
  }
  return Ct = E, E.default = E, Ct;
}
var it = {}, cr;
function ou() {
  return cr || (cr = 1, it.isClean = Symbol("isClean"), it.my = Symbol("my")), it;
}
var Dt, lr;
function ct() {
  if (lr) return Dt;
  lr = 1;
  let u = su(), E = Vr(), b = ot(), { isClean: l, my: f } = ou();
  function p(h, i) {
    let r = new h.constructor();
    for (let s in h) {
      if (!Object.prototype.hasOwnProperty.call(h, s) || s === "proxyCache") continue;
      let e = h[s], t = typeof e;
      s === "parent" && t === "object" ? i && (r[s] = i) : s === "source" ? r[s] = e : Array.isArray(e) ? r[s] = e.map((c) => p(c, r)) : (t === "object" && e !== null && (e = p(e)), r[s] = e);
    }
    return r;
  }
  function a(h, i) {
    if (i && typeof i.offset < "u")
      return i.offset;
    let r = 1, s = 1, e = 0;
    for (let t = 0; t < h.length; t++) {
      if (s === i.line && r === i.column) {
        e = t;
        break;
      }
      h[t] === `
` ? (r = 1, s += 1) : r += 1;
    }
    return e;
  }
  class d {
    get proxyOf() {
      return this;
    }
    constructor(i = {}) {
      this.raws = {}, this[l] = !1, this[f] = !0;
      for (let r in i)
        if (r === "nodes") {
          this.nodes = [];
          for (let s of i[r])
            typeof s.clone == "function" ? this.append(s.clone()) : this.append(s);
        } else
          this[r] = i[r];
    }
    addToError(i) {
      if (i.postcssNode = this, i.stack && this.source && /\n\s{4}at /.test(i.stack)) {
        let r = this.source;
        i.stack = i.stack.replace(
          /\n\s{4}at /,
          `$&${r.input.from}:${r.start.line}:${r.start.column}$&`
        );
      }
      return i;
    }
    after(i) {
      return this.parent.insertAfter(this, i), this;
    }
    assign(i = {}) {
      for (let r in i)
        this[r] = i[r];
      return this;
    }
    before(i) {
      return this.parent.insertBefore(this, i), this;
    }
    cleanRaws(i) {
      delete this.raws.before, delete this.raws.after, i || delete this.raws.between;
    }
    clone(i = {}) {
      let r = p(this);
      for (let s in i)
        r[s] = i[s];
      return r;
    }
    cloneAfter(i = {}) {
      let r = this.clone(i);
      return this.parent.insertAfter(this, r), r;
    }
    cloneBefore(i = {}) {
      let r = this.clone(i);
      return this.parent.insertBefore(this, r), r;
    }
    error(i, r = {}) {
      if (this.source) {
        let { end: s, start: e } = this.rangeBy(r);
        return this.source.input.error(
          i,
          { column: e.column, line: e.line },
          { column: s.column, line: s.line },
          r
        );
      }
      return new u(i);
    }
    getProxyProcessor() {
      return {
        get(i, r) {
          return r === "proxyOf" ? i : r === "root" ? () => i.root().toProxy() : i[r];
        },
        set(i, r, s) {
          return i[r] === s || (i[r] = s, (r === "prop" || r === "value" || r === "name" || r === "params" || r === "important" || /* c8 ignore next */
          r === "text") && i.markDirty()), !0;
        }
      };
    }
    /* c8 ignore next 3 */
    markClean() {
      this[l] = !0;
    }
    markDirty() {
      if (this[l]) {
        this[l] = !1;
        let i = this;
        for (; i = i.parent; )
          i[l] = !1;
      }
    }
    next() {
      if (!this.parent) return;
      let i = this.parent.index(this);
      return this.parent.nodes[i + 1];
    }
    positionBy(i) {
      let r = this.source.start;
      if (i.index)
        r = this.positionInside(i.index);
      else if (i.word) {
        let s = "document" in this.source.input ? this.source.input.document : this.source.input.css, t = s.slice(
          a(s, this.source.start),
          a(s, this.source.end)
        ).indexOf(i.word);
        t !== -1 && (r = this.positionInside(t));
      }
      return r;
    }
    positionInside(i) {
      let r = this.source.start.column, s = this.source.start.line, e = "document" in this.source.input ? this.source.input.document : this.source.input.css, t = a(e, this.source.start), c = t + i;
      for (let m = t; m < c; m++)
        e[m] === `
` ? (r = 1, s += 1) : r += 1;
      return { column: r, line: s };
    }
    prev() {
      if (!this.parent) return;
      let i = this.parent.index(this);
      return this.parent.nodes[i - 1];
    }
    rangeBy(i) {
      let r = {
        column: this.source.start.column,
        line: this.source.start.line
      }, s = this.source.end ? {
        column: this.source.end.column + 1,
        line: this.source.end.line
      } : {
        column: r.column + 1,
        line: r.line
      };
      if (i.word) {
        let e = "document" in this.source.input ? this.source.input.document : this.source.input.css, c = e.slice(
          a(e, this.source.start),
          a(e, this.source.end)
        ).indexOf(i.word);
        c !== -1 && (r = this.positionInside(c), s = this.positionInside(
          c + i.word.length
        ));
      } else
        i.start ? r = {
          column: i.start.column,
          line: i.start.line
        } : i.index && (r = this.positionInside(i.index)), i.end ? s = {
          column: i.end.column,
          line: i.end.line
        } : typeof i.endIndex == "number" ? s = this.positionInside(i.endIndex) : i.index && (s = this.positionInside(i.index + 1));
      return (s.line < r.line || s.line === r.line && s.column <= r.column) && (s = { column: r.column + 1, line: r.line }), { end: s, start: r };
    }
    raw(i, r) {
      return new E().raw(this, i, r);
    }
    remove() {
      return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
    }
    replaceWith(...i) {
      if (this.parent) {
        let r = this, s = !1;
        for (let e of i)
          e === this ? s = !0 : s ? (this.parent.insertAfter(r, e), r = e) : this.parent.insertBefore(r, e);
        s || this.remove();
      }
      return this;
    }
    root() {
      let i = this;
      for (; i.parent && i.parent.type !== "document"; )
        i = i.parent;
      return i;
    }
    toJSON(i, r) {
      let s = {}, e = r == null;
      r = r || /* @__PURE__ */ new Map();
      let t = 0;
      for (let c in this) {
        if (!Object.prototype.hasOwnProperty.call(this, c) || c === "parent" || c === "proxyCache") continue;
        let m = this[c];
        if (Array.isArray(m))
          s[c] = m.map((y) => typeof y == "object" && y.toJSON ? y.toJSON(null, r) : y);
        else if (typeof m == "object" && m.toJSON)
          s[c] = m.toJSON(null, r);
        else if (c === "source") {
          let y = r.get(m.input);
          y == null && (y = t, r.set(m.input, t), t++), s[c] = {
            end: m.end,
            inputId: y,
            start: m.start
          };
        } else
          s[c] = m;
      }
      return e && (s.inputs = [...r.keys()].map((c) => c.toJSON())), s;
    }
    toProxy() {
      return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
    }
    toString(i = b) {
      i.stringify && (i = i.stringify);
      let r = "";
      return i(this, (s) => {
        r += s;
      }), r;
    }
    warn(i, r, s) {
      let e = { node: this };
      for (let t in s) e[t] = s[t];
      return i.warn(r, e);
    }
  }
  return Dt = d, d.default = d, Dt;
}
var Lt, fr;
function lt() {
  if (fr) return Lt;
  fr = 1;
  let u = ct();
  class E extends u {
    constructor(l) {
      super(l), this.type = "comment";
    }
  }
  return Lt = E, E.default = E, Lt;
}
var It, dr;
function ft() {
  if (dr) return It;
  dr = 1;
  let u = ct();
  class E extends u {
    get variable() {
      return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(l) {
      l && typeof l.value < "u" && typeof l.value != "string" && (l = { ...l, value: String(l.value) }), super(l), this.type = "decl";
    }
  }
  return It = E, E.default = E, It;
}
var Pt, hr;
function je() {
  if (hr) return Pt;
  hr = 1;
  let u = lt(), E = ft(), b = ct(), { isClean: l, my: f } = ou(), p, a, d, h;
  function i(e) {
    return e.map((t) => (t.nodes && (t.nodes = i(t.nodes)), delete t.source, t));
  }
  function r(e) {
    if (e[l] = !1, e.proxyOf.nodes)
      for (let t of e.proxyOf.nodes)
        r(t);
  }
  class s extends b {
    get first() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[0];
    }
    get last() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...t) {
      for (let c of t) {
        let m = this.normalize(c, this.last);
        for (let y of m) this.proxyOf.nodes.push(y);
      }
      return this.markDirty(), this;
    }
    cleanRaws(t) {
      if (super.cleanRaws(t), this.nodes)
        for (let c of this.nodes) c.cleanRaws(t);
    }
    each(t) {
      if (!this.proxyOf.nodes) return;
      let c = this.getIterator(), m, y;
      for (; this.indexes[c] < this.proxyOf.nodes.length && (m = this.indexes[c], y = t(this.proxyOf.nodes[m], m), y !== !1); )
        this.indexes[c] += 1;
      return delete this.indexes[c], y;
    }
    every(t) {
      return this.nodes.every(t);
    }
    getIterator() {
      this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
      let t = this.lastEach;
      return this.indexes[t] = 0, t;
    }
    getProxyProcessor() {
      return {
        get(t, c) {
          return c === "proxyOf" ? t : t[c] ? c === "each" || typeof c == "string" && c.startsWith("walk") ? (...m) => t[c](
            ...m.map((y) => typeof y == "function" ? (n, g) => y(n.toProxy(), g) : y)
          ) : c === "every" || c === "some" ? (m) => t[c](
            (y, ...n) => m(y.toProxy(), ...n)
          ) : c === "root" ? () => t.root().toProxy() : c === "nodes" ? t.nodes.map((m) => m.toProxy()) : c === "first" || c === "last" ? t[c].toProxy() : t[c] : t[c];
        },
        set(t, c, m) {
          return t[c] === m || (t[c] = m, (c === "name" || c === "params" || c === "selector") && t.markDirty()), !0;
        }
      };
    }
    index(t) {
      return typeof t == "number" ? t : (t.proxyOf && (t = t.proxyOf), this.proxyOf.nodes.indexOf(t));
    }
    insertAfter(t, c) {
      let m = this.index(t), y = this.normalize(c, this.proxyOf.nodes[m]).reverse();
      m = this.index(t);
      for (let g of y) this.proxyOf.nodes.splice(m + 1, 0, g);
      let n;
      for (let g in this.indexes)
        n = this.indexes[g], m < n && (this.indexes[g] = n + y.length);
      return this.markDirty(), this;
    }
    insertBefore(t, c) {
      let m = this.index(t), y = m === 0 ? "prepend" : !1, n = this.normalize(
        c,
        this.proxyOf.nodes[m],
        y
      ).reverse();
      m = this.index(t);
      for (let v of n) this.proxyOf.nodes.splice(m, 0, v);
      let g;
      for (let v in this.indexes)
        g = this.indexes[v], m <= g && (this.indexes[v] = g + n.length);
      return this.markDirty(), this;
    }
    normalize(t, c) {
      if (typeof t == "string")
        t = i(a(t).nodes);
      else if (typeof t > "u")
        t = [];
      else if (Array.isArray(t)) {
        t = t.slice(0);
        for (let y of t)
          y.parent && y.parent.removeChild(y, "ignore");
      } else if (t.type === "root" && this.type !== "document") {
        t = t.nodes.slice(0);
        for (let y of t)
          y.parent && y.parent.removeChild(y, "ignore");
      } else if (t.type)
        t = [t];
      else if (t.prop) {
        if (typeof t.value > "u")
          throw new Error("Value field is missed in node creation");
        typeof t.value != "string" && (t.value = String(t.value)), t = [new E(t)];
      } else if (t.selector || t.selectors)
        t = [new h(t)];
      else if (t.name)
        t = [new p(t)];
      else if (t.text)
        t = [new u(t)];
      else
        throw new Error("Unknown node type in node creation");
      return t.map((y) => (y[f] || s.rebuild(y), y = y.proxyOf, y.parent && y.parent.removeChild(y), y[l] && r(y), y.raws || (y.raws = {}), typeof y.raws.before > "u" && c && typeof c.raws.before < "u" && (y.raws.before = c.raws.before.replace(/\S/g, "")), y.parent = this.proxyOf, y));
    }
    prepend(...t) {
      t = t.reverse();
      for (let c of t) {
        let m = this.normalize(c, this.first, "prepend").reverse();
        for (let y of m) this.proxyOf.nodes.unshift(y);
        for (let y in this.indexes)
          this.indexes[y] = this.indexes[y] + m.length;
      }
      return this.markDirty(), this;
    }
    push(t) {
      return t.parent = this, this.proxyOf.nodes.push(t), this;
    }
    removeAll() {
      for (let t of this.proxyOf.nodes) t.parent = void 0;
      return this.proxyOf.nodes = [], this.markDirty(), this;
    }
    removeChild(t) {
      t = this.index(t), this.proxyOf.nodes[t].parent = void 0, this.proxyOf.nodes.splice(t, 1);
      let c;
      for (let m in this.indexes)
        c = this.indexes[m], c >= t && (this.indexes[m] = c - 1);
      return this.markDirty(), this;
    }
    replaceValues(t, c, m) {
      return m || (m = c, c = {}), this.walkDecls((y) => {
        c.props && !c.props.includes(y.prop) || c.fast && !y.value.includes(c.fast) || (y.value = y.value.replace(t, m));
      }), this.markDirty(), this;
    }
    some(t) {
      return this.nodes.some(t);
    }
    walk(t) {
      return this.each((c, m) => {
        let y;
        try {
          y = t(c, m);
        } catch (n) {
          throw c.addToError(n);
        }
        return y !== !1 && c.walk && (y = c.walk(t)), y;
      });
    }
    walkAtRules(t, c) {
      return c ? t instanceof RegExp ? this.walk((m, y) => {
        if (m.type === "atrule" && t.test(m.name))
          return c(m, y);
      }) : this.walk((m, y) => {
        if (m.type === "atrule" && m.name === t)
          return c(m, y);
      }) : (c = t, this.walk((m, y) => {
        if (m.type === "atrule")
          return c(m, y);
      }));
    }
    walkComments(t) {
      return this.walk((c, m) => {
        if (c.type === "comment")
          return t(c, m);
      });
    }
    walkDecls(t, c) {
      return c ? t instanceof RegExp ? this.walk((m, y) => {
        if (m.type === "decl" && t.test(m.prop))
          return c(m, y);
      }) : this.walk((m, y) => {
        if (m.type === "decl" && m.prop === t)
          return c(m, y);
      }) : (c = t, this.walk((m, y) => {
        if (m.type === "decl")
          return c(m, y);
      }));
    }
    walkRules(t, c) {
      return c ? t instanceof RegExp ? this.walk((m, y) => {
        if (m.type === "rule" && t.test(m.selector))
          return c(m, y);
      }) : this.walk((m, y) => {
        if (m.type === "rule" && m.selector === t)
          return c(m, y);
      }) : (c = t, this.walk((m, y) => {
        if (m.type === "rule")
          return c(m, y);
      }));
    }
  }
  return s.registerParse = (e) => {
    a = e;
  }, s.registerRule = (e) => {
    h = e;
  }, s.registerAtRule = (e) => {
    p = e;
  }, s.registerRoot = (e) => {
    d = e;
  }, Pt = s, s.default = s, s.rebuild = (e) => {
    e.type === "atrule" ? Object.setPrototypeOf(e, p.prototype) : e.type === "rule" ? Object.setPrototypeOf(e, h.prototype) : e.type === "decl" ? Object.setPrototypeOf(e, E.prototype) : e.type === "comment" ? Object.setPrototypeOf(e, u.prototype) : e.type === "root" && Object.setPrototypeOf(e, d.prototype), e[f] = !0, e.nodes && e.nodes.forEach((t) => {
      s.rebuild(t);
    });
  }, Pt;
}
var kt, pr;
function cu() {
  if (pr) return kt;
  pr = 1;
  let u = je();
  class E extends u {
    constructor(l) {
      super(l), this.type = "atrule";
    }
    append(...l) {
      return this.proxyOf.nodes || (this.nodes = []), super.append(...l);
    }
    prepend(...l) {
      return this.proxyOf.nodes || (this.nodes = []), super.prepend(...l);
    }
  }
  return kt = E, E.default = E, u.registerAtRule(E), kt;
}
var Mt, br;
function lu() {
  if (br) return Mt;
  br = 1;
  let u = je(), E, b;
  class l extends u {
    constructor(p) {
      super({ type: "document", ...p }), this.nodes || (this.nodes = []);
    }
    toResult(p = {}) {
      return new E(new b(), this, p).stringify();
    }
  }
  return l.registerLazyResult = (f) => {
    E = f;
  }, l.registerProcessor = (f) => {
    b = f;
  }, Mt = l, l.default = l, Mt;
}
var jt, mr;
function ki() {
  if (mr) return jt;
  mr = 1;
  let u = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
  return jt = { nanoid: (l = 21) => {
    let f = "", p = l | 0;
    for (; p--; )
      f += u[Math.random() * 64 | 0];
    return f;
  }, customAlphabet: (l, f = 21) => (p = f) => {
    let a = "", d = p | 0;
    for (; d--; )
      a += l[Math.random() * l.length | 0];
    return a;
  } }, jt;
}
var Bt, gr;
function Fr() {
  if (gr) return Bt;
  gr = 1;
  let { existsSync: u, readFileSync: E } = me, { dirname: b, join: l } = me, { SourceMapConsumer: f, SourceMapGenerator: p } = me;
  function a(h) {
    return Buffer ? Buffer.from(h, "base64").toString() : window.atob(h);
  }
  class d {
    constructor(i, r) {
      if (r.map === !1) return;
      this.loadAnnotation(i), this.inline = this.startWith(this.annotation, "data:");
      let s = r.map ? r.map.prev : void 0, e = this.loadMap(r.from, s);
      !this.mapFile && r.from && (this.mapFile = r.from), this.mapFile && (this.root = b(this.mapFile)), e && (this.text = e);
    }
    consumer() {
      return this.consumerCache || (this.consumerCache = new f(this.text)), this.consumerCache;
    }
    decodeInline(i) {
      let r = /^data:application\/json;charset=utf-?8;base64,/, s = /^data:application\/json;base64,/, e = /^data:application\/json;charset=utf-?8,/, t = /^data:application\/json,/, c = i.match(e) || i.match(t);
      if (c)
        return decodeURIComponent(i.substr(c[0].length));
      let m = i.match(r) || i.match(s);
      if (m)
        return a(i.substr(m[0].length));
      let y = i.match(/data:application\/json;([^,]+),/)[1];
      throw new Error("Unsupported source map encoding " + y);
    }
    getAnnotationURL(i) {
      return i.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(i) {
      return typeof i != "object" ? !1 : typeof i.mappings == "string" || typeof i._mappings == "string" || Array.isArray(i.sections);
    }
    loadAnnotation(i) {
      let r = i.match(/\/\*\s*# sourceMappingURL=/g);
      if (!r) return;
      let s = i.lastIndexOf(r.pop()), e = i.indexOf("*/", s);
      s > -1 && e > -1 && (this.annotation = this.getAnnotationURL(i.substring(s, e)));
    }
    loadFile(i) {
      if (this.root = b(i), u(i))
        return this.mapFile = i, E(i, "utf-8").toString().trim();
    }
    loadMap(i, r) {
      if (r === !1) return !1;
      if (r) {
        if (typeof r == "string")
          return r;
        if (typeof r == "function") {
          let s = r(i);
          if (s) {
            let e = this.loadFile(s);
            if (!e)
              throw new Error(
                "Unable to load previous source map: " + s.toString()
              );
            return e;
          }
        } else {
          if (r instanceof f)
            return p.fromSourceMap(r).toString();
          if (r instanceof p)
            return r.toString();
          if (this.isMap(r))
            return JSON.stringify(r);
          throw new Error(
            "Unsupported previous source map format: " + r.toString()
          );
        }
      } else {
        if (this.inline)
          return this.decodeInline(this.annotation);
        if (this.annotation) {
          let s = this.annotation;
          return i && (s = l(b(i), s)), this.loadFile(s);
        }
      }
    }
    startWith(i, r) {
      return i ? i.substr(0, r.length) === r : !1;
    }
    withContent() {
      return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
  }
  return Bt = d, d.default = d, Bt;
}
var Ut, vr;
function dt() {
  if (vr) return Ut;
  vr = 1;
  let { nanoid: u } = /* @__PURE__ */ ki(), { isAbsolute: E, resolve: b } = me, { SourceMapConsumer: l, SourceMapGenerator: f } = me, { fileURLToPath: p, pathToFileURL: a } = me, d = su(), h = Fr(), i = me, r = Symbol("fromOffsetCache"), s = !!(l && f), e = !!(b && E);
  class t {
    get from() {
      return this.file || this.id;
    }
    constructor(m, y = {}) {
      if (m === null || typeof m > "u" || typeof m == "object" && !m.toString)
        throw new Error(`PostCSS received ${m} instead of CSS string`);
      if (this.css = m.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, y.document && (this.document = y.document.toString()), y.from && (!e || /^\w+:\/\//.test(y.from) || E(y.from) ? this.file = y.from : this.file = b(y.from)), e && s) {
        let n = new h(this.css, y);
        if (n.text) {
          this.map = n;
          let g = n.consumer().file;
          !this.file && g && (this.file = this.mapResolve(g));
        }
      }
      this.file || (this.id = "<input css " + u(6) + ">"), this.map && (this.map.file = this.from);
    }
    error(m, y, n, g = {}) {
      let v, x, o;
      if (y && typeof y == "object") {
        let S = y, A = n;
        if (typeof S.offset == "number") {
          let C = this.fromOffset(S.offset);
          y = C.line, n = C.col;
        } else
          y = S.line, n = S.column;
        if (typeof A.offset == "number") {
          let C = this.fromOffset(A.offset);
          x = C.line, v = C.col;
        } else
          x = A.line, v = A.column;
      } else if (!n) {
        let S = this.fromOffset(y);
        y = S.line, n = S.col;
      }
      let w = this.origin(y, n, x, v);
      return w ? o = new d(
        m,
        w.endLine === void 0 ? w.line : { column: w.column, line: w.line },
        w.endLine === void 0 ? w.column : { column: w.endColumn, line: w.endLine },
        w.source,
        w.file,
        g.plugin
      ) : o = new d(
        m,
        x === void 0 ? y : { column: n, line: y },
        x === void 0 ? n : { column: v, line: x },
        this.css,
        this.file,
        g.plugin
      ), o.input = { column: n, endColumn: v, endLine: x, line: y, source: this.css }, this.file && (a && (o.input.url = a(this.file).toString()), o.input.file = this.file), o;
    }
    fromOffset(m) {
      let y, n;
      if (this[r])
        n = this[r];
      else {
        let v = this.css.split(`
`);
        n = new Array(v.length);
        let x = 0;
        for (let o = 0, w = v.length; o < w; o++)
          n[o] = x, x += v[o].length + 1;
        this[r] = n;
      }
      y = n[n.length - 1];
      let g = 0;
      if (m >= y)
        g = n.length - 1;
      else {
        let v = n.length - 2, x;
        for (; g < v; )
          if (x = g + (v - g >> 1), m < n[x])
            v = x - 1;
          else if (m >= n[x + 1])
            g = x + 1;
          else {
            g = x;
            break;
          }
      }
      return {
        col: m - n[g] + 1,
        line: g + 1
      };
    }
    mapResolve(m) {
      return /^\w+:\/\//.test(m) ? m : b(this.map.consumer().sourceRoot || this.map.root || ".", m);
    }
    origin(m, y, n, g) {
      if (!this.map) return !1;
      let v = this.map.consumer(), x = v.originalPositionFor({ column: y, line: m });
      if (!x.source) return !1;
      let o;
      typeof n == "number" && (o = v.originalPositionFor({ column: g, line: n }));
      let w;
      E(x.source) ? w = a(x.source) : w = new URL(
        x.source,
        this.map.consumer().sourceRoot || a(this.map.mapFile)
      );
      let S = {
        column: x.column,
        endColumn: o && o.column,
        endLine: o && o.line,
        line: x.line,
        url: w.toString()
      };
      if (w.protocol === "file:")
        if (p)
          S.file = p(w);
        else
          throw new Error("file: protocol is not available in this PostCSS build");
      let A = v.sourceContentFor(x.source);
      return A && (S.source = A), S;
    }
    toJSON() {
      let m = {};
      for (let y of ["hasBOM", "css", "file", "id"])
        this[y] != null && (m[y] = this[y]);
      return this.map && (m.map = { ...this.map }, m.map.consumerCache && (m.map.consumerCache = void 0)), m;
    }
  }
  return Ut = t, t.default = t, i && i.registerInput && i.registerInput(t), Ut;
}
var Ht, yr;
function Ye() {
  if (yr) return Ht;
  yr = 1;
  let u = je(), E, b;
  class l extends u {
    constructor(p) {
      super(p), this.type = "root", this.nodes || (this.nodes = []);
    }
    normalize(p, a, d) {
      let h = super.normalize(p);
      if (a) {
        if (d === "prepend")
          this.nodes.length > 1 ? a.raws.before = this.nodes[1].raws.before : delete a.raws.before;
        else if (this.first !== a)
          for (let i of h)
            i.raws.before = a.raws.before;
      }
      return h;
    }
    removeChild(p, a) {
      let d = this.index(p);
      return !a && d === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[d].raws.before), super.removeChild(p);
    }
    toResult(p = {}) {
      return new E(new b(), this, p).stringify();
    }
  }
  return l.registerLazyResult = (f) => {
    E = f;
  }, l.registerProcessor = (f) => {
    b = f;
  }, Ht = l, l.default = l, u.registerRoot(l), Ht;
}
var Vt, xr;
function zr() {
  if (xr) return Vt;
  xr = 1;
  let u = {
    comma(E) {
      return u.split(E, [","], !0);
    },
    space(E) {
      let b = [" ", `
`, "	"];
      return u.split(E, b);
    },
    split(E, b, l) {
      let f = [], p = "", a = !1, d = 0, h = !1, i = "", r = !1;
      for (let s of E)
        r ? r = !1 : s === "\\" ? r = !0 : h ? s === i && (h = !1) : s === '"' || s === "'" ? (h = !0, i = s) : s === "(" ? d += 1 : s === ")" ? d > 0 && (d -= 1) : d === 0 && b.includes(s) && (a = !0), a ? (p !== "" && f.push(p.trim()), p = "", a = !1) : p += s;
      return (l || p !== "") && f.push(p.trim()), f;
    }
  };
  return Vt = u, u.default = u, Vt;
}
var Ft, wr;
function fu() {
  if (wr) return Ft;
  wr = 1;
  let u = je(), E = zr();
  class b extends u {
    get selectors() {
      return E.comma(this.selector);
    }
    set selectors(f) {
      let p = this.selector ? this.selector.match(/,\s*/) : null, a = p ? p[0] : "," + this.raw("between", "beforeOpen");
      this.selector = f.join(a);
    }
    constructor(f) {
      super(f), this.type = "rule", this.nodes || (this.nodes = []);
    }
  }
  return Ft = b, b.default = b, u.registerRule(b), Ft;
}
var zt, Er;
function Mi() {
  if (Er) return zt;
  Er = 1;
  let u = cu(), E = lt(), b = ft(), l = dt(), f = Fr(), p = Ye(), a = fu();
  function d(h, i) {
    if (Array.isArray(h)) return h.map((e) => d(e));
    let { inputs: r, ...s } = h;
    if (r) {
      i = [];
      for (let e of r) {
        let t = { ...e, __proto__: l.prototype };
        t.map && (t.map = {
          ...t.map,
          __proto__: f.prototype
        }), i.push(t);
      }
    }
    if (s.nodes && (s.nodes = h.nodes.map((e) => d(e, i))), s.source) {
      let { inputId: e, ...t } = s.source;
      s.source = t, e != null && (s.source.input = i[e]);
    }
    if (s.type === "root")
      return new p(s);
    if (s.type === "decl")
      return new b(s);
    if (s.type === "rule")
      return new a(s);
    if (s.type === "comment")
      return new E(s);
    if (s.type === "atrule")
      return new u(s);
    throw new Error("Unknown node type: " + h.type);
  }
  return zt = d, d.default = d, zt;
}
var Gt, Sr;
function Gr() {
  if (Sr) return Gt;
  Sr = 1;
  let { dirname: u, relative: E, resolve: b, sep: l } = me, { SourceMapConsumer: f, SourceMapGenerator: p } = me, { pathToFileURL: a } = me, d = dt(), h = !!(f && p), i = !!(u && b && E && l);
  class r {
    constructor(e, t, c, m) {
      this.stringify = e, this.mapOpts = c.map || {}, this.root = t, this.opts = c, this.css = m, this.originalCSS = m, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
      let e;
      this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
      let t = `
`;
      this.css.includes(`\r
`) && (t = `\r
`), this.css += t + "/*# sourceMappingURL=" + e + " */";
    }
    applyPrevMaps() {
      for (let e of this.previous()) {
        let t = this.toUrl(this.path(e.file)), c = e.root || u(e.file), m;
        this.mapOpts.sourcesContent === !1 ? (m = new f(e.text), m.sourcesContent && (m.sourcesContent = null)) : m = e.consumer(), this.map.applySourceMap(m, t, this.toUrl(this.path(c)));
      }
    }
    clearAnnotation() {
      if (this.mapOpts.annotation !== !1)
        if (this.root) {
          let e;
          for (let t = this.root.nodes.length - 1; t >= 0; t--)
            e = this.root.nodes[t], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(t);
        } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
    }
    generate() {
      if (this.clearAnnotation(), i && h && this.isMap())
        return this.generateMap();
      {
        let e = "";
        return this.stringify(this.root, (t) => {
          e += t;
        }), [e];
      }
    }
    generateMap() {
      if (this.root)
        this.generateString();
      else if (this.previous().length === 1) {
        let e = this.previous()[0].consumer();
        e.file = this.outputFile(), this.map = p.fromSourceMap(e, {
          ignoreInvalidMapping: !0
        });
      } else
        this.map = new p({
          file: this.outputFile(),
          ignoreInvalidMapping: !0
        }), this.map.addMapping({
          generated: { column: 0, line: 1 },
          original: { column: 0, line: 1 },
          source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
        });
      return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
    }
    generateString() {
      this.css = "", this.map = new p({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      });
      let e = 1, t = 1, c = "<no source>", m = {
        generated: { column: 0, line: 0 },
        original: { column: 0, line: 0 },
        source: ""
      }, y, n;
      this.stringify(this.root, (g, v, x) => {
        if (this.css += g, v && x !== "end" && (m.generated.line = e, m.generated.column = t - 1, v.source && v.source.start ? (m.source = this.sourcePath(v), m.original.line = v.source.start.line, m.original.column = v.source.start.column - 1, this.map.addMapping(m)) : (m.source = c, m.original.line = 1, m.original.column = 0, this.map.addMapping(m))), n = g.match(/\n/g), n ? (e += n.length, y = g.lastIndexOf(`
`), t = g.length - y) : t += g.length, v && x !== "start") {
          let o = v.parent || { raws: {} };
          (!(v.type === "decl" || v.type === "atrule" && !v.nodes) || v !== o.last || o.raws.semicolon) && (v.source && v.source.end ? (m.source = this.sourcePath(v), m.original.line = v.source.end.line, m.original.column = v.source.end.column - 1, m.generated.line = e, m.generated.column = t - 2, this.map.addMapping(m)) : (m.source = c, m.original.line = 1, m.original.column = 0, m.generated.line = e, m.generated.column = t - 1, this.map.addMapping(m)));
        }
      });
    }
    isAnnotation() {
      return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
    }
    isInline() {
      if (typeof this.mapOpts.inline < "u")
        return this.mapOpts.inline;
      let e = this.mapOpts.annotation;
      return typeof e < "u" && e !== !0 ? !1 : this.previous().length ? this.previous().some((t) => t.inline) : !0;
    }
    isMap() {
      return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
    }
    isSourcesContent() {
      return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
    }
    outputFile() {
      return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
    }
    path(e) {
      if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e)) return e;
      let t = this.memoizedPaths.get(e);
      if (t) return t;
      let c = this.opts.to ? u(this.opts.to) : ".";
      typeof this.mapOpts.annotation == "string" && (c = u(b(c, this.mapOpts.annotation)));
      let m = E(c, e);
      return this.memoizedPaths.set(e, m), m;
    }
    previous() {
      if (!this.previousMaps)
        if (this.previousMaps = [], this.root)
          this.root.walk((e) => {
            if (e.source && e.source.input.map) {
              let t = e.source.input.map;
              this.previousMaps.includes(t) || this.previousMaps.push(t);
            }
          });
        else {
          let e = new d(this.originalCSS, this.opts);
          e.map && this.previousMaps.push(e.map);
        }
      return this.previousMaps;
    }
    setSourcesContent() {
      let e = {};
      if (this.root)
        this.root.walk((t) => {
          if (t.source) {
            let c = t.source.input.from;
            if (c && !e[c]) {
              e[c] = !0;
              let m = this.usesFileUrls ? this.toFileUrl(c) : this.toUrl(this.path(c));
              this.map.setSourceContent(m, t.source.input.css);
            }
          }
        });
      else if (this.css) {
        let t = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
        this.map.setSourceContent(t, this.css);
      }
    }
    sourcePath(e) {
      return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
    }
    toBase64(e) {
      return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
    }
    toFileUrl(e) {
      let t = this.memoizedFileURLs.get(e);
      if (t) return t;
      if (a) {
        let c = a(e).toString();
        return this.memoizedFileURLs.set(e, c), c;
      } else
        throw new Error(
          "`map.absolute` option is not available in this PostCSS build"
        );
    }
    toUrl(e) {
      let t = this.memoizedURLs.get(e);
      if (t) return t;
      l === "\\" && (e = e.replace(/\\/g, "/"));
      let c = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
      return this.memoizedURLs.set(e, c), c;
    }
  }
  return Gt = r, Gt;
}
var $t, Tr;
function ji() {
  if (Tr) return $t;
  Tr = 1;
  const u = 39, E = 34, b = 92, l = 47, f = 10, p = 32, a = 12, d = 9, h = 13, i = 91, r = 93, s = 40, e = 41, t = 123, c = 125, m = 59, y = 42, n = 58, g = 64, v = /[\t\n\f\r "#'()/;[\\\]{}]/g, x = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, o = /.[\r\n"'(/\\]/, w = /[\da-f]/i;
  return $t = function(A, C = {}) {
    let R = A.css.valueOf(), q = C.ignoreErrors, O, I, k, _, F, z, J, ee, te, oe, _e = R.length, B = 0, ce = [], ye = [];
    function Ne() {
      return B;
    }
    function xe(N) {
      throw A.error("Unclosed " + N, B);
    }
    function Re() {
      return ye.length === 0 && B >= _e;
    }
    function Le(N) {
      if (ye.length) return ye.pop();
      if (B >= _e) return;
      let P = N ? N.ignoreUnclosed : !1;
      switch (O = R.charCodeAt(B), O) {
        case f:
        case p:
        case d:
        case h:
        case a: {
          _ = B;
          do
            _ += 1, O = R.charCodeAt(_);
          while (O === p || O === f || O === d || O === h || O === a);
          z = ["space", R.slice(B, _)], B = _ - 1;
          break;
        }
        case i:
        case r:
        case t:
        case c:
        case n:
        case m:
        case e: {
          let D = String.fromCharCode(O);
          z = [D, D, B];
          break;
        }
        case s: {
          if (oe = ce.length ? ce.pop()[1] : "", te = R.charCodeAt(B + 1), oe === "url" && te !== u && te !== E && te !== p && te !== f && te !== d && te !== a && te !== h) {
            _ = B;
            do {
              if (J = !1, _ = R.indexOf(")", _ + 1), _ === -1)
                if (q || P) {
                  _ = B;
                  break;
                } else
                  xe("bracket");
              for (ee = _; R.charCodeAt(ee - 1) === b; )
                ee -= 1, J = !J;
            } while (J);
            z = ["brackets", R.slice(B, _ + 1), B, _], B = _;
          } else
            _ = R.indexOf(")", B + 1), I = R.slice(B, _ + 1), _ === -1 || o.test(I) ? z = ["(", "(", B] : (z = ["brackets", I, B, _], B = _);
          break;
        }
        case u:
        case E: {
          F = O === u ? "'" : '"', _ = B;
          do {
            if (J = !1, _ = R.indexOf(F, _ + 1), _ === -1)
              if (q || P) {
                _ = B + 1;
                break;
              } else
                xe("string");
            for (ee = _; R.charCodeAt(ee - 1) === b; )
              ee -= 1, J = !J;
          } while (J);
          z = ["string", R.slice(B, _ + 1), B, _], B = _;
          break;
        }
        case g: {
          v.lastIndex = B + 1, v.test(R), v.lastIndex === 0 ? _ = R.length - 1 : _ = v.lastIndex - 2, z = ["at-word", R.slice(B, _ + 1), B, _], B = _;
          break;
        }
        case b: {
          for (_ = B, k = !0; R.charCodeAt(_ + 1) === b; )
            _ += 1, k = !k;
          if (O = R.charCodeAt(_ + 1), k && O !== l && O !== p && O !== f && O !== d && O !== h && O !== a && (_ += 1, w.test(R.charAt(_)))) {
            for (; w.test(R.charAt(_ + 1)); )
              _ += 1;
            R.charCodeAt(_ + 1) === p && (_ += 1);
          }
          z = ["word", R.slice(B, _ + 1), B, _], B = _;
          break;
        }
        default: {
          O === l && R.charCodeAt(B + 1) === y ? (_ = R.indexOf("*/", B + 2) + 1, _ === 0 && (q || P ? _ = R.length : xe("comment")), z = ["comment", R.slice(B, _ + 1), B, _], B = _) : (x.lastIndex = B + 1, x.test(R), x.lastIndex === 0 ? _ = R.length - 1 : _ = x.lastIndex - 2, z = ["word", R.slice(B, _ + 1), B, _], ce.push(z), B = _);
          break;
        }
      }
      return B++, z;
    }
    function we(N) {
      ye.push(N);
    }
    return {
      back: we,
      endOfFile: Re,
      nextToken: Le,
      position: Ne
    };
  }, $t;
}
var Wt, Ar;
function Bi() {
  if (Ar) return Wt;
  Ar = 1;
  let u = cu(), E = lt(), b = ft(), l = Ye(), f = fu(), p = ji();
  const a = {
    empty: !0,
    space: !0
  };
  function d(i) {
    for (let r = i.length - 1; r >= 0; r--) {
      let s = i[r], e = s[3] || s[2];
      if (e) return e;
    }
  }
  class h {
    constructor(r) {
      this.input = r, this.root = new l(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: r, start: { column: 1, line: 1, offset: 0 } };
    }
    atrule(r) {
      let s = new u();
      s.name = r[1].slice(1), s.name === "" && this.unnamedAtrule(s, r), this.init(s, r[2]);
      let e, t, c, m = !1, y = !1, n = [], g = [];
      for (; !this.tokenizer.endOfFile(); ) {
        if (r = this.tokenizer.nextToken(), e = r[0], e === "(" || e === "[" ? g.push(e === "(" ? ")" : "]") : e === "{" && g.length > 0 ? g.push("}") : e === g[g.length - 1] && g.pop(), g.length === 0)
          if (e === ";") {
            s.source.end = this.getPosition(r[2]), s.source.end.offset++, this.semicolon = !0;
            break;
          } else if (e === "{") {
            y = !0;
            break;
          } else if (e === "}") {
            if (n.length > 0) {
              for (c = n.length - 1, t = n[c]; t && t[0] === "space"; )
                t = n[--c];
              t && (s.source.end = this.getPosition(t[3] || t[2]), s.source.end.offset++);
            }
            this.end(r);
            break;
          } else
            n.push(r);
        else
          n.push(r);
        if (this.tokenizer.endOfFile()) {
          m = !0;
          break;
        }
      }
      s.raws.between = this.spacesAndCommentsFromEnd(n), n.length ? (s.raws.afterName = this.spacesAndCommentsFromStart(n), this.raw(s, "params", n), m && (r = n[n.length - 1], s.source.end = this.getPosition(r[3] || r[2]), s.source.end.offset++, this.spaces = s.raws.between, s.raws.between = "")) : (s.raws.afterName = "", s.params = ""), y && (s.nodes = [], this.current = s);
    }
    checkMissedSemicolon(r) {
      let s = this.colon(r);
      if (s === !1) return;
      let e = 0, t;
      for (let c = s - 1; c >= 0 && (t = r[c], !(t[0] !== "space" && (e += 1, e === 2))); c--)
        ;
      throw this.input.error(
        "Missed semicolon",
        t[0] === "word" ? t[3] + 1 : t[2]
      );
    }
    colon(r) {
      let s = 0, e, t, c;
      for (let [m, y] of r.entries()) {
        if (t = y, c = t[0], c === "(" && (s += 1), c === ")" && (s -= 1), s === 0 && c === ":")
          if (!e)
            this.doubleColon(t);
          else {
            if (e[0] === "word" && e[1] === "progid")
              continue;
            return m;
          }
        e = t;
      }
      return !1;
    }
    comment(r) {
      let s = new E();
      this.init(s, r[2]), s.source.end = this.getPosition(r[3] || r[2]), s.source.end.offset++;
      let e = r[1].slice(2, -2);
      if (/^\s*$/.test(e))
        s.text = "", s.raws.left = e, s.raws.right = "";
      else {
        let t = e.match(/^(\s*)([^]*\S)(\s*)$/);
        s.text = t[2], s.raws.left = t[1], s.raws.right = t[3];
      }
    }
    createTokenizer() {
      this.tokenizer = p(this.input);
    }
    decl(r, s) {
      let e = new b();
      this.init(e, r[0][2]);
      let t = r[r.length - 1];
      for (t[0] === ";" && (this.semicolon = !0, r.pop()), e.source.end = this.getPosition(
        t[3] || t[2] || d(r)
      ), e.source.end.offset++; r[0][0] !== "word"; )
        r.length === 1 && this.unknownWord(r), e.raws.before += r.shift()[1];
      for (e.source.start = this.getPosition(r[0][2]), e.prop = ""; r.length; ) {
        let g = r[0][0];
        if (g === ":" || g === "space" || g === "comment")
          break;
        e.prop += r.shift()[1];
      }
      e.raws.between = "";
      let c;
      for (; r.length; )
        if (c = r.shift(), c[0] === ":") {
          e.raws.between += c[1];
          break;
        } else
          c[0] === "word" && /\w/.test(c[1]) && this.unknownWord([c]), e.raws.between += c[1];
      (e.prop[0] === "_" || e.prop[0] === "*") && (e.raws.before += e.prop[0], e.prop = e.prop.slice(1));
      let m = [], y;
      for (; r.length && (y = r[0][0], !(y !== "space" && y !== "comment")); )
        m.push(r.shift());
      this.precheckMissedSemicolon(r);
      for (let g = r.length - 1; g >= 0; g--) {
        if (c = r[g], c[1].toLowerCase() === "!important") {
          e.important = !0;
          let v = this.stringFrom(r, g);
          v = this.spacesFromEnd(r) + v, v !== " !important" && (e.raws.important = v);
          break;
        } else if (c[1].toLowerCase() === "important") {
          let v = r.slice(0), x = "";
          for (let o = g; o > 0; o--) {
            let w = v[o][0];
            if (x.trim().startsWith("!") && w !== "space")
              break;
            x = v.pop()[1] + x;
          }
          x.trim().startsWith("!") && (e.important = !0, e.raws.important = x, r = v);
        }
        if (c[0] !== "space" && c[0] !== "comment")
          break;
      }
      r.some((g) => g[0] !== "space" && g[0] !== "comment") && (e.raws.between += m.map((g) => g[1]).join(""), m = []), this.raw(e, "value", m.concat(r), s), e.value.includes(":") && !s && this.checkMissedSemicolon(r);
    }
    doubleColon(r) {
      throw this.input.error(
        "Double colon",
        { offset: r[2] },
        { offset: r[2] + r[1].length }
      );
    }
    emptyRule(r) {
      let s = new f();
      this.init(s, r[2]), s.selector = "", s.raws.between = "", this.current = s;
    }
    end(r) {
      this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(r[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(r);
    }
    endFile() {
      this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(r) {
      if (this.spaces += r[1], this.current.nodes) {
        let s = this.current.nodes[this.current.nodes.length - 1];
        s && s.type === "rule" && !s.raws.ownSemicolon && (s.raws.ownSemicolon = this.spaces, this.spaces = "", s.source.end = this.getPosition(r[2]), s.source.end.offset += s.raws.ownSemicolon.length);
      }
    }
    // Helpers
    getPosition(r) {
      let s = this.input.fromOffset(r);
      return {
        column: s.col,
        line: s.line,
        offset: r
      };
    }
    init(r, s) {
      this.current.push(r), r.source = {
        input: this.input,
        start: this.getPosition(s)
      }, r.raws.before = this.spaces, this.spaces = "", r.type !== "comment" && (this.semicolon = !1);
    }
    other(r) {
      let s = !1, e = null, t = !1, c = null, m = [], y = r[1].startsWith("--"), n = [], g = r;
      for (; g; ) {
        if (e = g[0], n.push(g), e === "(" || e === "[")
          c || (c = g), m.push(e === "(" ? ")" : "]");
        else if (y && t && e === "{")
          c || (c = g), m.push("}");
        else if (m.length === 0)
          if (e === ";")
            if (t) {
              this.decl(n, y);
              return;
            } else
              break;
          else if (e === "{") {
            this.rule(n);
            return;
          } else if (e === "}") {
            this.tokenizer.back(n.pop()), s = !0;
            break;
          } else e === ":" && (t = !0);
        else e === m[m.length - 1] && (m.pop(), m.length === 0 && (c = null));
        g = this.tokenizer.nextToken();
      }
      if (this.tokenizer.endOfFile() && (s = !0), m.length > 0 && this.unclosedBracket(c), s && t) {
        if (!y)
          for (; n.length && (g = n[n.length - 1][0], !(g !== "space" && g !== "comment")); )
            this.tokenizer.back(n.pop());
        this.decl(n, y);
      } else
        this.unknownWord(n);
    }
    parse() {
      let r;
      for (; !this.tokenizer.endOfFile(); )
        switch (r = this.tokenizer.nextToken(), r[0]) {
          case "space":
            this.spaces += r[1];
            break;
          case ";":
            this.freeSemicolon(r);
            break;
          case "}":
            this.end(r);
            break;
          case "comment":
            this.comment(r);
            break;
          case "at-word":
            this.atrule(r);
            break;
          case "{":
            this.emptyRule(r);
            break;
          default:
            this.other(r);
            break;
        }
      this.endFile();
    }
    precheckMissedSemicolon() {
    }
    raw(r, s, e, t) {
      let c, m, y = e.length, n = "", g = !0, v, x;
      for (let o = 0; o < y; o += 1)
        c = e[o], m = c[0], m === "space" && o === y - 1 && !t ? g = !1 : m === "comment" ? (x = e[o - 1] ? e[o - 1][0] : "empty", v = e[o + 1] ? e[o + 1][0] : "empty", !a[x] && !a[v] ? n.slice(-1) === "," ? g = !1 : n += c[1] : g = !1) : n += c[1];
      if (!g) {
        let o = e.reduce((w, S) => w + S[1], "");
        r.raws[s] = { raw: o, value: n };
      }
      r[s] = n;
    }
    rule(r) {
      r.pop();
      let s = new f();
      this.init(s, r[0][2]), s.raws.between = this.spacesAndCommentsFromEnd(r), this.raw(s, "selector", r), this.current = s;
    }
    spacesAndCommentsFromEnd(r) {
      let s, e = "";
      for (; r.length && (s = r[r.length - 1][0], !(s !== "space" && s !== "comment")); )
        e = r.pop()[1] + e;
      return e;
    }
    // Errors
    spacesAndCommentsFromStart(r) {
      let s, e = "";
      for (; r.length && (s = r[0][0], !(s !== "space" && s !== "comment")); )
        e += r.shift()[1];
      return e;
    }
    spacesFromEnd(r) {
      let s, e = "";
      for (; r.length && (s = r[r.length - 1][0], s === "space"); )
        e = r.pop()[1] + e;
      return e;
    }
    stringFrom(r, s) {
      let e = "";
      for (let t = s; t < r.length; t++)
        e += r[t][1];
      return r.splice(s, r.length - s), e;
    }
    unclosedBlock() {
      let r = this.current.source.start;
      throw this.input.error("Unclosed block", r.line, r.column);
    }
    unclosedBracket(r) {
      throw this.input.error(
        "Unclosed bracket",
        { offset: r[2] },
        { offset: r[2] + 1 }
      );
    }
    unexpectedClose(r) {
      throw this.input.error(
        "Unexpected }",
        { offset: r[2] },
        { offset: r[2] + 1 }
      );
    }
    unknownWord(r) {
      throw this.input.error(
        "Unknown word " + r[0][1],
        { offset: r[0][2] },
        { offset: r[0][2] + r[0][1].length }
      );
    }
    unnamedAtrule(r, s) {
      throw this.input.error(
        "At-rule without name",
        { offset: s[2] },
        { offset: s[2] + s[1].length }
      );
    }
  }
  return Wt = h, Wt;
}
var Yt, qr;
function du() {
  if (qr) return Yt;
  qr = 1;
  let u = je(), E = dt(), b = Bi();
  function l(f, p) {
    let a = new E(f, p), d = new b(a);
    try {
      d.parse();
    } catch (h) {
      throw process.env.NODE_ENV !== "production" && h.name === "CssSyntaxError" && p && p.from && (/\.scss$/i.test(p.from) ? h.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(p.from) ? h.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(p.from) && (h.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), h;
    }
    return d.root;
  }
  return Yt = l, l.default = l, u.registerParse(l), Yt;
}
var Jt, Or;
function $r() {
  if (Or) return Jt;
  Or = 1;
  class u {
    constructor(b, l = {}) {
      if (this.type = "warning", this.text = b, l.node && l.node.source) {
        let f = l.node.rangeBy(l);
        this.line = f.start.line, this.column = f.start.column, this.endLine = f.end.line, this.endColumn = f.end.column;
      }
      for (let f in l) this[f] = l[f];
    }
    toString() {
      return this.node ? this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
    }
  }
  return Jt = u, u.default = u, Jt;
}
var Zt, _r;
function hu() {
  if (_r) return Zt;
  _r = 1;
  let u = $r();
  class E {
    get content() {
      return this.css;
    }
    constructor(l, f, p) {
      this.processor = l, this.messages = [], this.root = f, this.opts = p, this.css = void 0, this.map = void 0;
    }
    toString() {
      return this.css;
    }
    warn(l, f = {}) {
      f.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (f.plugin = this.lastPlugin.postcssPlugin);
      let p = new u(l, f);
      return this.messages.push(p), p;
    }
    warnings() {
      return this.messages.filter((l) => l.type === "warning");
    }
  }
  return Zt = E, E.default = E, Zt;
}
var Xt, Nr;
function Wr() {
  if (Nr) return Xt;
  Nr = 1;
  let u = {};
  return Xt = function(b) {
    u[b] || (u[b] = !0, typeof console < "u" && console.warn && console.warn(b));
  }, Xt;
}
var Qt, Rr;
function Yr() {
  if (Rr) return Qt;
  Rr = 1;
  let u = je(), E = lu(), b = Gr(), l = du(), f = hu(), p = Ye(), a = ot(), { isClean: d, my: h } = ou(), i = Wr();
  const r = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
  }, s = {
    AtRule: !0,
    AtRuleExit: !0,
    Comment: !0,
    CommentExit: !0,
    Declaration: !0,
    DeclarationExit: !0,
    Document: !0,
    DocumentExit: !0,
    Once: !0,
    OnceExit: !0,
    postcssPlugin: !0,
    prepare: !0,
    Root: !0,
    RootExit: !0,
    Rule: !0,
    RuleExit: !0
  }, e = {
    Once: !0,
    postcssPlugin: !0,
    prepare: !0
  }, t = 0;
  function c(x) {
    return typeof x == "object" && typeof x.then == "function";
  }
  function m(x) {
    let o = !1, w = r[x.type];
    return x.type === "decl" ? o = x.prop.toLowerCase() : x.type === "atrule" && (o = x.name.toLowerCase()), o && x.append ? [
      w,
      w + "-" + o,
      t,
      w + "Exit",
      w + "Exit-" + o
    ] : o ? [w, w + "-" + o, w + "Exit", w + "Exit-" + o] : x.append ? [w, t, w + "Exit"] : [w, w + "Exit"];
  }
  function y(x) {
    let o;
    return x.type === "document" ? o = ["Document", t, "DocumentExit"] : x.type === "root" ? o = ["Root", t, "RootExit"] : o = m(x), {
      eventIndex: 0,
      events: o,
      iterator: 0,
      node: x,
      visitorIndex: 0,
      visitors: []
    };
  }
  function n(x) {
    return x[d] = !1, x.nodes && x.nodes.forEach((o) => n(o)), x;
  }
  let g = {};
  class v {
    get content() {
      return this.stringify().content;
    }
    get css() {
      return this.stringify().css;
    }
    get map() {
      return this.stringify().map;
    }
    get messages() {
      return this.sync().messages;
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      return this.sync().root;
    }
    get [Symbol.toStringTag]() {
      return "LazyResult";
    }
    constructor(o, w, S) {
      this.stringified = !1, this.processed = !1;
      let A;
      if (typeof w == "object" && w !== null && (w.type === "root" || w.type === "document"))
        A = n(w);
      else if (w instanceof v || w instanceof f)
        A = n(w.root), w.map && (typeof S.map > "u" && (S.map = {}), S.map.inline || (S.map.inline = !1), S.map.prev = w.map);
      else {
        let C = l;
        S.syntax && (C = S.syntax.parse), S.parser && (C = S.parser), C.parse && (C = C.parse);
        try {
          A = C(w, S);
        } catch (R) {
          this.processed = !0, this.error = R;
        }
        A && !A[h] && u.rebuild(A);
      }
      this.result = new f(o, A, S), this.helpers = { ...g, postcss: g, result: this.result }, this.plugins = this.processor.plugins.map((C) => typeof C == "object" && C.prepare ? { ...C, ...C.prepare(this.result) } : C);
    }
    async() {
      return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
    }
    catch(o) {
      return this.async().catch(o);
    }
    finally(o) {
      return this.async().then(o, o);
    }
    getAsyncError() {
      throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(o, w) {
      let S = this.result.lastPlugin;
      try {
        if (w && w.addToError(o), this.error = o, o.name === "CssSyntaxError" && !o.plugin)
          o.plugin = S.postcssPlugin, o.setMessage();
        else if (S.postcssVersion && process.env.NODE_ENV !== "production") {
          let A = S.postcssPlugin, C = S.postcssVersion, R = this.result.processor.version, q = C.split("."), O = R.split(".");
          (q[0] !== O[0] || parseInt(q[1]) > parseInt(O[1])) && console.error(
            "Unknown error from PostCSS plugin. Your current PostCSS version is " + R + ", but " + A + " uses " + C + ". Perhaps this is the source of the error below."
          );
        }
      } catch (A) {
        console && console.error && console.error(A);
      }
      return o;
    }
    prepareVisitors() {
      this.listeners = {};
      let o = (w, S, A) => {
        this.listeners[S] || (this.listeners[S] = []), this.listeners[S].push([w, A]);
      };
      for (let w of this.plugins)
        if (typeof w == "object")
          for (let S in w) {
            if (!s[S] && /^[A-Z]/.test(S))
              throw new Error(
                `Unknown event ${S} in ${w.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
              );
            if (!e[S])
              if (typeof w[S] == "object")
                for (let A in w[S])
                  A === "*" ? o(w, S, w[S][A]) : o(
                    w,
                    S + "-" + A.toLowerCase(),
                    w[S][A]
                  );
              else typeof w[S] == "function" && o(w, S, w[S]);
          }
      this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
      this.plugin = 0;
      for (let o = 0; o < this.plugins.length; o++) {
        let w = this.plugins[o], S = this.runOnRoot(w);
        if (c(S))
          try {
            await S;
          } catch (A) {
            throw this.handleError(A);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let o = this.result.root;
        for (; !o[d]; ) {
          o[d] = !0;
          let w = [y(o)];
          for (; w.length > 0; ) {
            let S = this.visitTick(w);
            if (c(S))
              try {
                await S;
              } catch (A) {
                let C = w[w.length - 1].node;
                throw this.handleError(A, C);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [w, S] of this.listeners.OnceExit) {
            this.result.lastPlugin = w;
            try {
              if (o.type === "document") {
                let A = o.nodes.map(
                  (C) => S(C, this.helpers)
                );
                await Promise.all(A);
              } else
                await S(o, this.helpers);
            } catch (A) {
              throw this.handleError(A);
            }
          }
      }
      return this.processed = !0, this.stringify();
    }
    runOnRoot(o) {
      this.result.lastPlugin = o;
      try {
        if (typeof o == "object" && o.Once) {
          if (this.result.root.type === "document") {
            let w = this.result.root.nodes.map(
              (S) => o.Once(S, this.helpers)
            );
            return c(w[0]) ? Promise.all(w) : w;
          }
          return o.Once(this.result.root, this.helpers);
        } else if (typeof o == "function")
          return o(this.result.root, this.result);
      } catch (w) {
        throw this.handleError(w);
      }
    }
    stringify() {
      if (this.error) throw this.error;
      if (this.stringified) return this.result;
      this.stringified = !0, this.sync();
      let o = this.result.opts, w = a;
      o.syntax && (w = o.syntax.stringify), o.stringifier && (w = o.stringifier), w.stringify && (w = w.stringify);
      let A = new b(w, this.result.root, this.result.opts).generate();
      return this.result.css = A[0], this.result.map = A[1], this.result;
    }
    sync() {
      if (this.error) throw this.error;
      if (this.processed) return this.result;
      if (this.processed = !0, this.processing)
        throw this.getAsyncError();
      for (let o of this.plugins) {
        let w = this.runOnRoot(o);
        if (c(w))
          throw this.getAsyncError();
      }
      if (this.prepareVisitors(), this.hasListener) {
        let o = this.result.root;
        for (; !o[d]; )
          o[d] = !0, this.walkSync(o);
        if (this.listeners.OnceExit)
          if (o.type === "document")
            for (let w of o.nodes)
              this.visitSync(this.listeners.OnceExit, w);
          else
            this.visitSync(this.listeners.OnceExit, o);
      }
      return this.result;
    }
    then(o, w) {
      return process.env.NODE_ENV !== "production" && ("from" in this.opts || i(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(o, w);
    }
    toString() {
      return this.css;
    }
    visitSync(o, w) {
      for (let [S, A] of o) {
        this.result.lastPlugin = S;
        let C;
        try {
          C = A(w, this.helpers);
        } catch (R) {
          throw this.handleError(R, w.proxyOf);
        }
        if (w.type !== "root" && w.type !== "document" && !w.parent)
          return !0;
        if (c(C))
          throw this.getAsyncError();
      }
    }
    visitTick(o) {
      let w = o[o.length - 1], { node: S, visitors: A } = w;
      if (S.type !== "root" && S.type !== "document" && !S.parent) {
        o.pop();
        return;
      }
      if (A.length > 0 && w.visitorIndex < A.length) {
        let [R, q] = A[w.visitorIndex];
        w.visitorIndex += 1, w.visitorIndex === A.length && (w.visitors = [], w.visitorIndex = 0), this.result.lastPlugin = R;
        try {
          return q(S.toProxy(), this.helpers);
        } catch (O) {
          throw this.handleError(O, S);
        }
      }
      if (w.iterator !== 0) {
        let R = w.iterator, q;
        for (; q = S.nodes[S.indexes[R]]; )
          if (S.indexes[R] += 1, !q[d]) {
            q[d] = !0, o.push(y(q));
            return;
          }
        w.iterator = 0, delete S.indexes[R];
      }
      let C = w.events;
      for (; w.eventIndex < C.length; ) {
        let R = C[w.eventIndex];
        if (w.eventIndex += 1, R === t) {
          S.nodes && S.nodes.length && (S[d] = !0, w.iterator = S.getIterator());
          return;
        } else if (this.listeners[R]) {
          w.visitors = this.listeners[R];
          return;
        }
      }
      o.pop();
    }
    walkSync(o) {
      o[d] = !0;
      let w = m(o);
      for (let S of w)
        if (S === t)
          o.nodes && o.each((A) => {
            A[d] || this.walkSync(A);
          });
        else {
          let A = this.listeners[S];
          if (A && this.visitSync(A, o.toProxy()))
            return;
        }
    }
    warnings() {
      return this.sync().warnings();
    }
  }
  return v.registerPostcss = (x) => {
    g = x;
  }, Qt = v, v.default = v, p.registerLazyResult(v), E.registerLazyResult(v), Qt;
}
var Kt, Cr;
function Ui() {
  if (Cr) return Kt;
  Cr = 1;
  let u = Gr(), E = du();
  const b = hu();
  let l = ot(), f = Wr();
  class p {
    get content() {
      return this.result.css;
    }
    get css() {
      return this.result.css;
    }
    get map() {
      return this.result.map;
    }
    get messages() {
      return [];
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      if (this._root)
        return this._root;
      let d, h = E;
      try {
        d = h(this._css, this._opts);
      } catch (i) {
        this.error = i;
      }
      if (this.error)
        throw this.error;
      return this._root = d, d;
    }
    get [Symbol.toStringTag]() {
      return "NoWorkResult";
    }
    constructor(d, h, i) {
      h = h.toString(), this.stringified = !1, this._processor = d, this._css = h, this._opts = i, this._map = void 0;
      let r, s = l;
      this.result = new b(this._processor, r, this._opts), this.result.css = h;
      let e = this;
      Object.defineProperty(this.result, "root", {
        get() {
          return e.root;
        }
      });
      let t = new u(s, r, this._opts, h);
      if (t.isMap()) {
        let [c, m] = t.generate();
        c && (this.result.css = c), m && (this.result.map = m);
      } else
        t.clearAnnotation(), this.result.css = t.css;
    }
    async() {
      return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
    }
    catch(d) {
      return this.async().catch(d);
    }
    finally(d) {
      return this.async().then(d, d);
    }
    sync() {
      if (this.error) throw this.error;
      return this.result;
    }
    then(d, h) {
      return process.env.NODE_ENV !== "production" && ("from" in this._opts || f(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(d, h);
    }
    toString() {
      return this._css;
    }
    warnings() {
      return [];
    }
  }
  return Kt = p, p.default = p, Kt;
}
var eu, Dr;
function Hi() {
  if (Dr) return eu;
  Dr = 1;
  let u = lu(), E = Yr(), b = Ui(), l = Ye();
  class f {
    constructor(a = []) {
      this.version = "8.5.3", this.plugins = this.normalize(a);
    }
    normalize(a) {
      let d = [];
      for (let h of a)
        if (h.postcss === !0 ? h = h() : h.postcss && (h = h.postcss), typeof h == "object" && Array.isArray(h.plugins))
          d = d.concat(h.plugins);
        else if (typeof h == "object" && h.postcssPlugin)
          d.push(h);
        else if (typeof h == "function")
          d.push(h);
        else if (typeof h == "object" && (h.parse || h.stringify)) {
          if (process.env.NODE_ENV !== "production")
            throw new Error(
              "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
            );
        } else
          throw new Error(h + " is not a PostCSS plugin");
      return d;
    }
    process(a, d = {}) {
      return !this.plugins.length && !d.parser && !d.stringifier && !d.syntax ? new b(this, a, d) : new E(this, a, d);
    }
    use(a) {
      return this.plugins = this.plugins.concat(this.normalize([a])), this;
    }
  }
  return eu = f, f.default = f, l.registerProcessor(f), u.registerProcessor(f), eu;
}
var tu, Lr;
function Vi() {
  if (Lr) return tu;
  Lr = 1;
  let u = cu(), E = lt(), b = je(), l = su(), f = ft(), p = lu(), a = Mi(), d = dt(), h = Yr(), i = zr(), r = ct(), s = du(), e = Hi(), t = hu(), c = Ye(), m = fu(), y = ot(), n = $r();
  function g(...v) {
    return v.length === 1 && Array.isArray(v[0]) && (v = v[0]), new e(v);
  }
  return g.plugin = function(x, o) {
    let w = !1;
    function S(...C) {
      console && console.warn && !w && (w = !0, console.warn(
        x + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
      ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
        x + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
      ));
      let R = o(...C);
      return R.postcssPlugin = x, R.postcssVersion = new e().version, R;
    }
    let A;
    return Object.defineProperty(S, "postcss", {
      get() {
        return A || (A = S()), A;
      }
    }), S.process = function(C, R, q) {
      return g([S(q)]).process(C, R);
    }, S;
  }, g.stringify = y, g.parse = s, g.fromJSON = a, g.list = i, g.comment = (v) => new E(v), g.atRule = (v) => new u(v), g.decl = (v) => new f(v), g.rule = (v) => new m(v), g.root = (v) => new c(v), g.document = (v) => new p(v), g.CssSyntaxError = l, g.Declaration = f, g.Container = b, g.Processor = e, g.Document = p, g.Comment = E, g.Warning = n, g.AtRule = u, g.Result = t, g.Input = d, g.Rule = m, g.Root = c, g.Node = r, h.registerPostcss(g), tu = g, g.default = g, tu;
}
var uu, Ir;
function Fi() {
  if (Ir) return uu;
  Ir = 1;
  const u = /* @__PURE__ */ Oi(), E = _i(), { isPlainObject: b } = Ni(), l = Ri(), f = Di(), { parse: p } = Vi(), a = [
    "img",
    "audio",
    "video",
    "picture",
    "svg",
    "object",
    "map",
    "iframe",
    "embed"
  ], d = ["script", "style"];
  function h(y, n) {
    y && Object.keys(y).forEach(function(g) {
      n(y[g], g);
    });
  }
  function i(y, n) {
    return {}.hasOwnProperty.call(y, n);
  }
  function r(y, n) {
    const g = [];
    return h(y, function(v) {
      n(v) && g.push(v);
    }), g;
  }
  function s(y) {
    for (const n in y)
      if (i(y, n))
        return !1;
    return !0;
  }
  function e(y) {
    return y.map(function(n) {
      if (!n.url)
        throw new Error("URL missing");
      return n.url + (n.w ? ` ${n.w}w` : "") + (n.h ? ` ${n.h}h` : "") + (n.d ? ` ${n.d}x` : "");
    }).join(", ");
  }
  uu = c;
  const t = /^[^\0\t\n\f\r /<=>]+$/;
  function c(y, n, g) {
    if (y == null)
      return "";
    typeof y == "number" && (y = y.toString());
    let v = "", x = "";
    function o(N, P) {
      const D = this;
      this.tag = N, this.attribs = P || {}, this.tagPosition = v.length, this.text = "", this.openingTagLength = 0, this.mediaChildren = [], this.updateParentNodeText = function() {
        if (F.length) {
          const H = F[F.length - 1];
          H.text += D.text;
        }
      }, this.updateParentNodeMediaChildren = function() {
        F.length && a.includes(this.tag) && F[F.length - 1].mediaChildren.push(this.tag);
      };
    }
    n = Object.assign({}, c.defaults, n), n.parser = Object.assign({}, m, n.parser);
    const w = function(N) {
      return n.allowedTags === !1 || (n.allowedTags || []).indexOf(N) > -1;
    };
    d.forEach(function(N) {
      w(N) && !n.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${N}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
    });
    const S = n.nonTextTags || [
      "script",
      "style",
      "textarea",
      "option"
    ];
    let A, C;
    n.allowedAttributes && (A = {}, C = {}, h(n.allowedAttributes, function(N, P) {
      A[P] = [];
      const D = [];
      N.forEach(function(H) {
        typeof H == "string" && H.indexOf("*") >= 0 ? D.push(E(H).replace(/\\\*/g, ".*")) : A[P].push(H);
      }), D.length && (C[P] = new RegExp("^(" + D.join("|") + ")$"));
    }));
    const R = {}, q = {}, O = {};
    h(n.allowedClasses, function(N, P) {
      if (A && (i(A, P) || (A[P] = []), A[P].push("class")), R[P] = N, Array.isArray(N)) {
        const D = [];
        R[P] = [], O[P] = [], N.forEach(function(H) {
          typeof H == "string" && H.indexOf("*") >= 0 ? D.push(E(H).replace(/\\\*/g, ".*")) : H instanceof RegExp ? O[P].push(H) : R[P].push(H);
        }), D.length && (q[P] = new RegExp("^(" + D.join("|") + ")$"));
      }
    });
    const I = {};
    let k;
    h(n.transformTags, function(N, P) {
      let D;
      typeof N == "function" ? D = N : typeof N == "string" && (D = c.simpleTransform(N)), P === "*" ? k = D : I[P] = D;
    });
    let _, F, z, J, ee, te, oe = !1;
    B();
    const _e = new u.Parser({
      onopentag: function(N, P) {
        if (n.onOpenTag && n.onOpenTag(N, P), n.enforceHtmlBoundary && N === "html" && B(), ee) {
          te++;
          return;
        }
        const D = new o(N, P);
        F.push(D);
        let H = !1;
        const ue = !!D.text;
        let ne;
        if (i(I, N) && (ne = I[N](N, P), D.attribs = P = ne.attribs, ne.text !== void 0 && (D.innerText = ne.text), N !== ne.tagName && (D.name = N = ne.tagName, J[_] = ne.tagName)), k && (ne = k(N, P), D.attribs = P = ne.attribs, N !== ne.tagName && (D.name = N = ne.tagName, J[_] = ne.tagName)), (!w(N) || n.disallowedTagsMode === "recursiveEscape" && !s(z) || n.nestingLimit != null && _ >= n.nestingLimit) && (H = !0, z[_] = !0, (n.disallowedTagsMode === "discard" || n.disallowedTagsMode === "completelyDiscard") && S.indexOf(N) !== -1 && (ee = !0, te = 1)), _++, H) {
          if (n.disallowedTagsMode === "discard" || n.disallowedTagsMode === "completelyDiscard") {
            if (D.innerText && !ue) {
              const X = ce(D.innerText);
              n.textFilter ? v += n.textFilter(X, N) : v += X, oe = !0;
            }
            return;
          }
          x = v, v = "";
        }
        v += "<" + N, N === "script" && (n.allowedScriptHostnames || n.allowedScriptDomains) && (D.innerText = ""), H && (n.disallowedTagsMode === "escape" || n.disallowedTagsMode === "recursiveEscape") && n.preserveEscapedAttributes ? h(P, function(X, $) {
          v += " " + $ + '="' + ce(X || "", !0) + '"';
        }) : (!A || i(A, N) || A["*"]) && h(P, function(X, $) {
          if (!t.test($)) {
            delete D.attribs[$];
            return;
          }
          if (X === "" && !n.allowedEmptyAttributes.includes($) && (n.nonBooleanAttributes.includes($) || n.nonBooleanAttributes.includes("*"))) {
            delete D.attribs[$];
            return;
          }
          let Ie = !1;
          if (!A || i(A, N) && A[N].indexOf($) !== -1 || A["*"] && A["*"].indexOf($) !== -1 || i(C, N) && C[N].test($) || C["*"] && C["*"].test($))
            Ie = !0;
          else if (A && A[N]) {
            for (const Z of A[N])
              if (b(Z) && Z.name && Z.name === $) {
                Ie = !0;
                let Y = "";
                if (Z.multiple === !0) {
                  const ge = X.split(" ");
                  for (const fe of ge)
                    Z.values.indexOf(fe) !== -1 && (Y === "" ? Y = fe : Y += " " + fe);
                } else Z.values.indexOf(X) >= 0 && (Y = X);
                X = Y;
              }
          }
          if (Ie) {
            if (n.allowedSchemesAppliedToAttributes.indexOf($) !== -1 && ye(N, X)) {
              delete D.attribs[$];
              return;
            }
            if (N === "script" && $ === "src") {
              let Z = !0;
              try {
                const Y = Ne(X);
                if (n.allowedScriptHostnames || n.allowedScriptDomains) {
                  const ge = (n.allowedScriptHostnames || []).find(function(le) {
                    return le === Y.url.hostname;
                  }), fe = (n.allowedScriptDomains || []).find(function(le) {
                    return Y.url.hostname === le || Y.url.hostname.endsWith(`.${le}`);
                  });
                  Z = ge || fe;
                }
              } catch {
                Z = !1;
              }
              if (!Z) {
                delete D.attribs[$];
                return;
              }
            }
            if (N === "iframe" && $ === "src") {
              let Z = !0;
              try {
                const Y = Ne(X);
                if (Y.isRelativeUrl)
                  Z = i(n, "allowIframeRelativeUrls") ? n.allowIframeRelativeUrls : !n.allowedIframeHostnames && !n.allowedIframeDomains;
                else if (n.allowedIframeHostnames || n.allowedIframeDomains) {
                  const ge = (n.allowedIframeHostnames || []).find(function(le) {
                    return le === Y.url.hostname;
                  }), fe = (n.allowedIframeDomains || []).find(function(le) {
                    return Y.url.hostname === le || Y.url.hostname.endsWith(`.${le}`);
                  });
                  Z = ge || fe;
                }
              } catch {
                Z = !1;
              }
              if (!Z) {
                delete D.attribs[$];
                return;
              }
            }
            if ($ === "srcset")
              try {
                let Z = f(X);
                if (Z.forEach(function(Y) {
                  ye("srcset", Y.url) && (Y.evil = !0);
                }), Z = r(Z, function(Y) {
                  return !Y.evil;
                }), Z.length)
                  X = e(r(Z, function(Y) {
                    return !Y.evil;
                  })), D.attribs[$] = X;
                else {
                  delete D.attribs[$];
                  return;
                }
              } catch {
                delete D.attribs[$];
                return;
              }
            if ($ === "class") {
              const Z = R[N], Y = R["*"], ge = q[N], fe = O[N], le = O["*"], pt = q["*"], Ze = [
                ge,
                pt
              ].concat(fe, le).filter(function(bt) {
                return bt;
              });
              if (Z && Y ? X = we(X, l(Z, Y), Ze) : X = we(X, Z || Y, Ze), !X.length) {
                delete D.attribs[$];
                return;
              }
            }
            if ($ === "style") {
              if (n.parseStyleAttributes)
                try {
                  const Z = p(N + " {" + X + "}", { map: !1 }), Y = xe(Z, n.allowedStyles);
                  if (X = Re(Y), X.length === 0) {
                    delete D.attribs[$];
                    return;
                  }
                } catch {
                  typeof window < "u" && console.warn('Failed to parse "' + N + " {" + X + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete D.attribs[$];
                  return;
                }
              else if (n.allowedStyles)
                throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
            }
            v += " " + $, X && X.length ? v += '="' + ce(X, !0) + '"' : n.allowedEmptyAttributes.includes($) && (v += '=""');
          } else
            delete D.attribs[$];
        }), n.selfClosing.indexOf(N) !== -1 ? v += " />" : (v += ">", D.innerText && !ue && !n.textFilter && (v += ce(D.innerText), oe = !0)), H && (v = x + ce(v), x = ""), D.openingTagLength = v.length - D.tagPosition;
      },
      ontext: function(N) {
        if (ee)
          return;
        const P = F[F.length - 1];
        let D;
        if (P && (D = P.tag, N = P.innerText !== void 0 ? P.innerText : N), n.disallowedTagsMode === "completelyDiscard" && !w(D))
          N = "";
        else if ((n.disallowedTagsMode === "discard" || n.disallowedTagsMode === "completelyDiscard") && (D === "script" || D === "style"))
          v += N;
        else if (!oe) {
          const H = ce(N, !1);
          n.textFilter ? v += n.textFilter(H, D) : v += H;
        }
        if (F.length) {
          const H = F[F.length - 1];
          H.text += N;
        }
      },
      onclosetag: function(N, P) {
        if (n.onCloseTag && n.onCloseTag(N, P), ee)
          if (te--, !te)
            ee = !1;
          else
            return;
        const D = F.pop();
        if (!D)
          return;
        if (D.tag !== N) {
          F.push(D);
          return;
        }
        ee = n.enforceHtmlBoundary ? N === "html" : !1, _--;
        const H = z[_];
        if (H) {
          if (delete z[_], n.disallowedTagsMode === "discard" || n.disallowedTagsMode === "completelyDiscard") {
            D.updateParentNodeText();
            return;
          }
          x = v, v = "";
        }
        if (J[_] && (N = J[_], delete J[_]), n.exclusiveFilter) {
          const ue = n.exclusiveFilter(D);
          if (ue === "excludeTag") {
            H && (v = x, x = ""), v = v.substring(0, D.tagPosition) + v.substring(D.tagPosition + D.openingTagLength);
            return;
          } else if (ue) {
            v = v.substring(0, D.tagPosition);
            return;
          }
        }
        if (D.updateParentNodeMediaChildren(), D.updateParentNodeText(), // Already output />
        n.selfClosing.indexOf(N) !== -1 || // Escaped tag, closing tag is implied
        P && !w(N) && ["escape", "recursiveEscape"].indexOf(n.disallowedTagsMode) >= 0) {
          H && (v = x, x = "");
          return;
        }
        v += "</" + N + ">", H && (v = x + ce(v), x = ""), oe = !1;
      }
    }, n.parser);
    return _e.write(y), _e.end(), v;
    function B() {
      v = "", _ = 0, F = [], z = {}, J = {}, ee = !1, te = 0;
    }
    function ce(N, P) {
      return typeof N != "string" && (N = N + ""), n.parser.decodeEntities && (N = N.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), P && (N = N.replace(/"/g, "&quot;"))), N = N.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), P && (N = N.replace(/"/g, "&quot;")), N;
    }
    function ye(N, P) {
      for (P = P.replace(/[\x00-\x20]+/g, ""); ; ) {
        const ue = P.indexOf("<!--");
        if (ue === -1)
          break;
        const ne = P.indexOf("-->", ue + 4);
        if (ne === -1)
          break;
        P = P.substring(0, ue) + P.substring(ne + 3);
      }
      const D = P.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
      if (!D)
        return P.match(/^[/\\]{2}/) ? !n.allowProtocolRelative : !1;
      const H = D[1].toLowerCase();
      return i(n.allowedSchemesByTag, N) ? n.allowedSchemesByTag[N].indexOf(H) === -1 : !n.allowedSchemes || n.allowedSchemes.indexOf(H) === -1;
    }
    function Ne(N) {
      if (N = N.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), N.startsWith("relative:"))
        throw new Error("relative: exploit attempt");
      let P = "relative://relative-site";
      for (let ue = 0; ue < 100; ue++)
        P += `/${ue}`;
      const D = new URL(N, P);
      return {
        isRelativeUrl: D && D.hostname === "relative-site" && D.protocol === "relative:",
        url: D
      };
    }
    function xe(N, P) {
      if (!P)
        return N;
      const D = N.nodes[0];
      let H;
      return P[D.selector] && P["*"] ? H = l(
        P[D.selector],
        P["*"]
      ) : H = P[D.selector] || P["*"], H && (N.nodes[0].nodes = D.nodes.reduce(Le(H), [])), N;
    }
    function Re(N) {
      return N.nodes[0].nodes.reduce(function(P, D) {
        return P.push(
          `${D.prop}:${D.value}${D.important ? " !important" : ""}`
        ), P;
      }, []).join(";");
    }
    function Le(N) {
      return function(P, D) {
        return i(N, D.prop) && N[D.prop].some(function(ue) {
          return ue.test(D.value);
        }) && P.push(D), P;
      };
    }
    function we(N, P, D) {
      return P ? (N = N.split(/\s+/), N.filter(function(H) {
        return P.indexOf(H) !== -1 || D.some(function(ue) {
          return ue.test(H);
        });
      }).join(" ")) : N;
    }
  }
  const m = {
    decodeEntities: !0
  };
  return c.defaults = {
    allowedTags: [
      // Sections derived from MDN element categories and limited to the more
      // benign categories.
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
      // Content sectioning
      "address",
      "article",
      "aside",
      "footer",
      "header",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hgroup",
      "main",
      "nav",
      "section",
      // Text content
      "blockquote",
      "dd",
      "div",
      "dl",
      "dt",
      "figcaption",
      "figure",
      "hr",
      "li",
      "menu",
      "ol",
      "p",
      "pre",
      "ul",
      // Inline text semantics
      "a",
      "abbr",
      "b",
      "bdi",
      "bdo",
      "br",
      "cite",
      "code",
      "data",
      "dfn",
      "em",
      "i",
      "kbd",
      "mark",
      "q",
      "rb",
      "rp",
      "rt",
      "rtc",
      "ruby",
      "s",
      "samp",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "time",
      "u",
      "var",
      "wbr",
      // Table content
      "caption",
      "col",
      "colgroup",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr"
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
      "abbr",
      "accept",
      "accept-charset",
      "accesskey",
      "action",
      "allow",
      "alt",
      "as",
      "autocapitalize",
      "autocomplete",
      "blocking",
      "charset",
      "cite",
      "class",
      "color",
      "cols",
      "colspan",
      "content",
      "contenteditable",
      "coords",
      "crossorigin",
      "data",
      "datetime",
      "decoding",
      "dir",
      "dirname",
      "download",
      "draggable",
      "enctype",
      "enterkeyhint",
      "fetchpriority",
      "for",
      "form",
      "formaction",
      "formenctype",
      "formmethod",
      "formtarget",
      "headers",
      "height",
      "hidden",
      "high",
      "href",
      "hreflang",
      "http-equiv",
      "id",
      "imagesizes",
      "imagesrcset",
      "inputmode",
      "integrity",
      "is",
      "itemid",
      "itemprop",
      "itemref",
      "itemtype",
      "kind",
      "label",
      "lang",
      "list",
      "loading",
      "low",
      "max",
      "maxlength",
      "media",
      "method",
      "min",
      "minlength",
      "name",
      "nonce",
      "optimum",
      "pattern",
      "ping",
      "placeholder",
      "popover",
      "popovertarget",
      "popovertargetaction",
      "poster",
      "preload",
      "referrerpolicy",
      "rel",
      "rows",
      "rowspan",
      "sandbox",
      "scope",
      "shape",
      "size",
      "sizes",
      "slot",
      "span",
      "spellcheck",
      "src",
      "srcdoc",
      "srclang",
      "srcset",
      "start",
      "step",
      "style",
      "tabindex",
      "target",
      "title",
      "translate",
      "type",
      "usemap",
      "value",
      "width",
      "wrap",
      // Event handlers
      "onauxclick",
      "onafterprint",
      "onbeforematch",
      "onbeforeprint",
      "onbeforeunload",
      "onbeforetoggle",
      "onblur",
      "oncancel",
      "oncanplay",
      "oncanplaythrough",
      "onchange",
      "onclick",
      "onclose",
      "oncontextlost",
      "oncontextmenu",
      "oncontextrestored",
      "oncopy",
      "oncuechange",
      "oncut",
      "ondblclick",
      "ondrag",
      "ondragend",
      "ondragenter",
      "ondragleave",
      "ondragover",
      "ondragstart",
      "ondrop",
      "ondurationchange",
      "onemptied",
      "onended",
      "onerror",
      "onfocus",
      "onformdata",
      "onhashchange",
      "oninput",
      "oninvalid",
      "onkeydown",
      "onkeypress",
      "onkeyup",
      "onlanguagechange",
      "onload",
      "onloadeddata",
      "onloadedmetadata",
      "onloadstart",
      "onmessage",
      "onmessageerror",
      "onmousedown",
      "onmouseenter",
      "onmouseleave",
      "onmousemove",
      "onmouseout",
      "onmouseover",
      "onmouseup",
      "onoffline",
      "ononline",
      "onpagehide",
      "onpageshow",
      "onpaste",
      "onpause",
      "onplay",
      "onplaying",
      "onpopstate",
      "onprogress",
      "onratechange",
      "onreset",
      "onresize",
      "onrejectionhandled",
      "onscroll",
      "onscrollend",
      "onsecuritypolicyviolation",
      "onseeked",
      "onseeking",
      "onselect",
      "onslotchange",
      "onstalled",
      "onstorage",
      "onsubmit",
      "onsuspend",
      "ontimeupdate",
      "ontoggle",
      "onunhandledrejection",
      "onunload",
      "onvolumechange",
      "onwaiting",
      "onwheel"
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
      a: ["href", "name", "target"],
      // We don't currently allow img itself by default, but
      // these attributes would make sense if we did.
      img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
    },
    allowedEmptyAttributes: [
      "alt"
    ],
    // Lots of these won't come up by default because we don't allow them
    selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
    // URL schemes we permit
    allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
    allowProtocolRelative: !0,
    enforceHtmlBoundary: !1,
    parseStyleAttributes: !0,
    preserveEscapedAttributes: !1
  }, c.simpleTransform = function(y, n, g) {
    return g = g === void 0 ? !0 : g, n = n || {}, function(v, x) {
      let o;
      if (g)
        for (o in n)
          x[o] = n[o];
      else
        x = n;
      return {
        tagName: y,
        attribs: x
      };
    };
  }, uu;
}
var zi = /* @__PURE__ */ Fi();
const Gi = /* @__PURE__ */ di(zi), st = ({ value: u, as: E = "span", ...b }) => {
  const l = E, f = fi(() => u ? Gi(u) : "", [u]);
  return /* @__PURE__ */ M.jsx(l, { dangerouslySetInnerHTML: { __html: f }, ...b });
};
var Fe = function() {
  return Fe = Object.assign || function(u) {
    for (var E, b = 1, l = arguments.length; b < l; b++) {
      E = arguments[b];
      for (var f in E) Object.prototype.hasOwnProperty.call(E, f) && (u[f] = E[f]);
    }
    return u;
  }, Fe.apply(this, arguments);
}, $i = "~", Wi = "~~";
function pu(u, E) {
  for (var b = {}, l = {}, f = u.split(Wi), p = !1, a = 0; f.length > a; a++) {
    for (var d = f[a].split($i), h = 0; h < d.length; h += 2) {
      var i = d[h], r = d[h + 1], s = "&" + i + ";";
      b[s] = r, p && (b["&" + i] = r), l[r] = s;
    }
    p = !0;
  }
  return E ? { entities: Fe(Fe({}, b), E.entities), characters: Fe(Fe({}, l), E.characters) } : { entities: b, characters: l };
}
var ru = {
  xml: /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
  html4: /&notin;|&(?:nbsp|iexcl|cent|pound|curren|yen|brvbar|sect|uml|copy|ordf|laquo|not|shy|reg|macr|deg|plusmn|sup2|sup3|acute|micro|para|middot|cedil|sup1|ordm|raquo|frac14|frac12|frac34|iquest|Agrave|Aacute|Acirc|Atilde|Auml|Aring|AElig|Ccedil|Egrave|Eacute|Ecirc|Euml|Igrave|Iacute|Icirc|Iuml|ETH|Ntilde|Ograve|Oacute|Ocirc|Otilde|Ouml|times|Oslash|Ugrave|Uacute|Ucirc|Uuml|Yacute|THORN|szlig|agrave|aacute|acirc|atilde|auml|aring|aelig|ccedil|egrave|eacute|ecirc|euml|igrave|iacute|icirc|iuml|eth|ntilde|ograve|oacute|ocirc|otilde|ouml|divide|oslash|ugrave|uacute|ucirc|uuml|yacute|thorn|yuml|quot|amp|lt|gt|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
  html5: /&centerdot;|&copysr;|&divideontimes;|&gtcc;|&gtcir;|&gtdot;|&gtlPar;|&gtquest;|&gtrapprox;|&gtrarr;|&gtrdot;|&gtreqless;|&gtreqqless;|&gtrless;|&gtrsim;|&ltcc;|&ltcir;|&ltdot;|&lthree;|&ltimes;|&ltlarr;|&ltquest;|&ltrPar;|&ltri;|&ltrie;|&ltrif;|&notin;|&notinE;|&notindot;|&notinva;|&notinvb;|&notinvc;|&notni;|&notniva;|&notnivb;|&notnivc;|&parallel;|&timesb;|&timesbar;|&timesd;|&(?:AElig|AMP|Aacute|Acirc|Agrave|Aring|Atilde|Auml|COPY|Ccedil|ETH|Eacute|Ecirc|Egrave|Euml|GT|Iacute|Icirc|Igrave|Iuml|LT|Ntilde|Oacute|Ocirc|Ograve|Oslash|Otilde|Ouml|QUOT|REG|THORN|Uacute|Ucirc|Ugrave|Uuml|Yacute|aacute|acirc|acute|aelig|agrave|amp|aring|atilde|auml|brvbar|ccedil|cedil|cent|copy|curren|deg|divide|eacute|ecirc|egrave|eth|euml|frac12|frac14|frac34|gt|iacute|icirc|iexcl|igrave|iquest|iuml|laquo|lt|macr|micro|middot|nbsp|not|ntilde|oacute|ocirc|ograve|ordf|ordm|oslash|otilde|ouml|para|plusmn|pound|quot|raquo|reg|sect|shy|sup1|sup2|sup3|szlig|thorn|times|uacute|ucirc|ugrave|uml|uuml|yacute|yen|yuml|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g
}, ze = {};
ze.xml = pu(`lt~<~gt~>~quot~"~apos~'~amp~&`);
ze.html4 = pu(`apos~'~OElig~Œ~oelig~œ~Scaron~Š~scaron~š~Yuml~Ÿ~circ~ˆ~tilde~˜~ensp~ ~emsp~ ~thinsp~ ~zwnj~‌~zwj~‍~lrm~‎~rlm~‏~ndash~–~mdash~—~lsquo~‘~rsquo~’~sbquo~‚~ldquo~“~rdquo~”~bdquo~„~dagger~†~Dagger~‡~permil~‰~lsaquo~‹~rsaquo~›~euro~€~fnof~ƒ~Alpha~Α~Beta~Β~Gamma~Γ~Delta~Δ~Epsilon~Ε~Zeta~Ζ~Eta~Η~Theta~Θ~Iota~Ι~Kappa~Κ~Lambda~Λ~Mu~Μ~Nu~Ν~Xi~Ξ~Omicron~Ο~Pi~Π~Rho~Ρ~Sigma~Σ~Tau~Τ~Upsilon~Υ~Phi~Φ~Chi~Χ~Psi~Ψ~Omega~Ω~alpha~α~beta~β~gamma~γ~delta~δ~epsilon~ε~zeta~ζ~eta~η~theta~θ~iota~ι~kappa~κ~lambda~λ~mu~μ~nu~ν~xi~ξ~omicron~ο~pi~π~rho~ρ~sigmaf~ς~sigma~σ~tau~τ~upsilon~υ~phi~φ~chi~χ~psi~ψ~omega~ω~thetasym~ϑ~upsih~ϒ~piv~ϖ~bull~•~hellip~…~prime~′~Prime~″~oline~‾~frasl~⁄~weierp~℘~image~ℑ~real~ℜ~trade~™~alefsym~ℵ~larr~←~uarr~↑~rarr~→~darr~↓~harr~↔~crarr~↵~lArr~⇐~uArr~⇑~rArr~⇒~dArr~⇓~hArr~⇔~forall~∀~part~∂~exist~∃~empty~∅~nabla~∇~isin~∈~notin~∉~ni~∋~prod~∏~sum~∑~minus~−~lowast~∗~radic~√~prop~∝~infin~∞~ang~∠~and~∧~or~∨~cap~∩~cup~∪~int~∫~there4~∴~sim~∼~cong~≅~asymp~≈~ne~≠~equiv~≡~le~≤~ge~≥~sub~⊂~sup~⊃~nsub~⊄~sube~⊆~supe~⊇~oplus~⊕~otimes~⊗~perp~⊥~sdot~⋅~lceil~⌈~rceil~⌉~lfloor~⌊~rfloor~⌋~lang~〈~rang~〉~loz~◊~spades~♠~clubs~♣~hearts~♥~diams~♦~~nbsp~ ~iexcl~¡~cent~¢~pound~£~curren~¤~yen~¥~brvbar~¦~sect~§~uml~¨~copy~©~ordf~ª~laquo~«~not~¬~shy~­~reg~®~macr~¯~deg~°~plusmn~±~sup2~²~sup3~³~acute~´~micro~µ~para~¶~middot~·~cedil~¸~sup1~¹~ordm~º~raquo~»~frac14~¼~frac12~½~frac34~¾~iquest~¿~Agrave~À~Aacute~Á~Acirc~Â~Atilde~Ã~Auml~Ä~Aring~Å~AElig~Æ~Ccedil~Ç~Egrave~È~Eacute~É~Ecirc~Ê~Euml~Ë~Igrave~Ì~Iacute~Í~Icirc~Î~Iuml~Ï~ETH~Ð~Ntilde~Ñ~Ograve~Ò~Oacute~Ó~Ocirc~Ô~Otilde~Õ~Ouml~Ö~times~×~Oslash~Ø~Ugrave~Ù~Uacute~Ú~Ucirc~Û~Uuml~Ü~Yacute~Ý~THORN~Þ~szlig~ß~agrave~à~aacute~á~acirc~â~atilde~ã~auml~ä~aring~å~aelig~æ~ccedil~ç~egrave~è~eacute~é~ecirc~ê~euml~ë~igrave~ì~iacute~í~icirc~î~iuml~ï~eth~ð~ntilde~ñ~ograve~ò~oacute~ó~ocirc~ô~otilde~õ~ouml~ö~divide~÷~oslash~ø~ugrave~ù~uacute~ú~ucirc~û~uuml~ü~yacute~ý~thorn~þ~yuml~ÿ~quot~"~amp~&~lt~<~gt~>`);
ze.html5 = pu('Abreve~Ă~Acy~А~Afr~𝔄~Amacr~Ā~And~⩓~Aogon~Ą~Aopf~𝔸~ApplyFunction~⁡~Ascr~𝒜~Assign~≔~Backslash~∖~Barv~⫧~Barwed~⌆~Bcy~Б~Because~∵~Bernoullis~ℬ~Bfr~𝔅~Bopf~𝔹~Breve~˘~Bscr~ℬ~Bumpeq~≎~CHcy~Ч~Cacute~Ć~Cap~⋒~CapitalDifferentialD~ⅅ~Cayleys~ℭ~Ccaron~Č~Ccirc~Ĉ~Cconint~∰~Cdot~Ċ~Cedilla~¸~CenterDot~·~Cfr~ℭ~CircleDot~⊙~CircleMinus~⊖~CirclePlus~⊕~CircleTimes~⊗~ClockwiseContourIntegral~∲~CloseCurlyDoubleQuote~”~CloseCurlyQuote~’~Colon~∷~Colone~⩴~Congruent~≡~Conint~∯~ContourIntegral~∮~Copf~ℂ~Coproduct~∐~CounterClockwiseContourIntegral~∳~Cross~⨯~Cscr~𝒞~Cup~⋓~CupCap~≍~DD~ⅅ~DDotrahd~⤑~DJcy~Ђ~DScy~Ѕ~DZcy~Џ~Darr~↡~Dashv~⫤~Dcaron~Ď~Dcy~Д~Del~∇~Dfr~𝔇~DiacriticalAcute~´~DiacriticalDot~˙~DiacriticalDoubleAcute~˝~DiacriticalGrave~`~DiacriticalTilde~˜~Diamond~⋄~DifferentialD~ⅆ~Dopf~𝔻~Dot~¨~DotDot~⃜~DotEqual~≐~DoubleContourIntegral~∯~DoubleDot~¨~DoubleDownArrow~⇓~DoubleLeftArrow~⇐~DoubleLeftRightArrow~⇔~DoubleLeftTee~⫤~DoubleLongLeftArrow~⟸~DoubleLongLeftRightArrow~⟺~DoubleLongRightArrow~⟹~DoubleRightArrow~⇒~DoubleRightTee~⊨~DoubleUpArrow~⇑~DoubleUpDownArrow~⇕~DoubleVerticalBar~∥~DownArrow~↓~DownArrowBar~⤓~DownArrowUpArrow~⇵~DownBreve~̑~DownLeftRightVector~⥐~DownLeftTeeVector~⥞~DownLeftVector~↽~DownLeftVectorBar~⥖~DownRightTeeVector~⥟~DownRightVector~⇁~DownRightVectorBar~⥗~DownTee~⊤~DownTeeArrow~↧~Downarrow~⇓~Dscr~𝒟~Dstrok~Đ~ENG~Ŋ~Ecaron~Ě~Ecy~Э~Edot~Ė~Efr~𝔈~Element~∈~Emacr~Ē~EmptySmallSquare~◻~EmptyVerySmallSquare~▫~Eogon~Ę~Eopf~𝔼~Equal~⩵~EqualTilde~≂~Equilibrium~⇌~Escr~ℰ~Esim~⩳~Exists~∃~ExponentialE~ⅇ~Fcy~Ф~Ffr~𝔉~FilledSmallSquare~◼~FilledVerySmallSquare~▪~Fopf~𝔽~ForAll~∀~Fouriertrf~ℱ~Fscr~ℱ~GJcy~Ѓ~Gammad~Ϝ~Gbreve~Ğ~Gcedil~Ģ~Gcirc~Ĝ~Gcy~Г~Gdot~Ġ~Gfr~𝔊~Gg~⋙~Gopf~𝔾~GreaterEqual~≥~GreaterEqualLess~⋛~GreaterFullEqual~≧~GreaterGreater~⪢~GreaterLess~≷~GreaterSlantEqual~⩾~GreaterTilde~≳~Gscr~𝒢~Gt~≫~HARDcy~Ъ~Hacek~ˇ~Hat~^~Hcirc~Ĥ~Hfr~ℌ~HilbertSpace~ℋ~Hopf~ℍ~HorizontalLine~─~Hscr~ℋ~Hstrok~Ħ~HumpDownHump~≎~HumpEqual~≏~IEcy~Е~IJlig~Ĳ~IOcy~Ё~Icy~И~Idot~İ~Ifr~ℑ~Im~ℑ~Imacr~Ī~ImaginaryI~ⅈ~Implies~⇒~Int~∬~Integral~∫~Intersection~⋂~InvisibleComma~⁣~InvisibleTimes~⁢~Iogon~Į~Iopf~𝕀~Iscr~ℐ~Itilde~Ĩ~Iukcy~І~Jcirc~Ĵ~Jcy~Й~Jfr~𝔍~Jopf~𝕁~Jscr~𝒥~Jsercy~Ј~Jukcy~Є~KHcy~Х~KJcy~Ќ~Kcedil~Ķ~Kcy~К~Kfr~𝔎~Kopf~𝕂~Kscr~𝒦~LJcy~Љ~Lacute~Ĺ~Lang~⟪~Laplacetrf~ℒ~Larr~↞~Lcaron~Ľ~Lcedil~Ļ~Lcy~Л~LeftAngleBracket~⟨~LeftArrow~←~LeftArrowBar~⇤~LeftArrowRightArrow~⇆~LeftCeiling~⌈~LeftDoubleBracket~⟦~LeftDownTeeVector~⥡~LeftDownVector~⇃~LeftDownVectorBar~⥙~LeftFloor~⌊~LeftRightArrow~↔~LeftRightVector~⥎~LeftTee~⊣~LeftTeeArrow~↤~LeftTeeVector~⥚~LeftTriangle~⊲~LeftTriangleBar~⧏~LeftTriangleEqual~⊴~LeftUpDownVector~⥑~LeftUpTeeVector~⥠~LeftUpVector~↿~LeftUpVectorBar~⥘~LeftVector~↼~LeftVectorBar~⥒~Leftarrow~⇐~Leftrightarrow~⇔~LessEqualGreater~⋚~LessFullEqual~≦~LessGreater~≶~LessLess~⪡~LessSlantEqual~⩽~LessTilde~≲~Lfr~𝔏~Ll~⋘~Lleftarrow~⇚~Lmidot~Ŀ~LongLeftArrow~⟵~LongLeftRightArrow~⟷~LongRightArrow~⟶~Longleftarrow~⟸~Longleftrightarrow~⟺~Longrightarrow~⟹~Lopf~𝕃~LowerLeftArrow~↙~LowerRightArrow~↘~Lscr~ℒ~Lsh~↰~Lstrok~Ł~Lt~≪~Map~⤅~Mcy~М~MediumSpace~ ~Mellintrf~ℳ~Mfr~𝔐~MinusPlus~∓~Mopf~𝕄~Mscr~ℳ~NJcy~Њ~Nacute~Ń~Ncaron~Ň~Ncedil~Ņ~Ncy~Н~NegativeMediumSpace~​~NegativeThickSpace~​~NegativeThinSpace~​~NegativeVeryThinSpace~​~NestedGreaterGreater~≫~NestedLessLess~≪~NewLine~\n~Nfr~𝔑~NoBreak~⁠~NonBreakingSpace~ ~Nopf~ℕ~Not~⫬~NotCongruent~≢~NotCupCap~≭~NotDoubleVerticalBar~∦~NotElement~∉~NotEqual~≠~NotEqualTilde~≂̸~NotExists~∄~NotGreater~≯~NotGreaterEqual~≱~NotGreaterFullEqual~≧̸~NotGreaterGreater~≫̸~NotGreaterLess~≹~NotGreaterSlantEqual~⩾̸~NotGreaterTilde~≵~NotHumpDownHump~≎̸~NotHumpEqual~≏̸~NotLeftTriangle~⋪~NotLeftTriangleBar~⧏̸~NotLeftTriangleEqual~⋬~NotLess~≮~NotLessEqual~≰~NotLessGreater~≸~NotLessLess~≪̸~NotLessSlantEqual~⩽̸~NotLessTilde~≴~NotNestedGreaterGreater~⪢̸~NotNestedLessLess~⪡̸~NotPrecedes~⊀~NotPrecedesEqual~⪯̸~NotPrecedesSlantEqual~⋠~NotReverseElement~∌~NotRightTriangle~⋫~NotRightTriangleBar~⧐̸~NotRightTriangleEqual~⋭~NotSquareSubset~⊏̸~NotSquareSubsetEqual~⋢~NotSquareSuperset~⊐̸~NotSquareSupersetEqual~⋣~NotSubset~⊂⃒~NotSubsetEqual~⊈~NotSucceeds~⊁~NotSucceedsEqual~⪰̸~NotSucceedsSlantEqual~⋡~NotSucceedsTilde~≿̸~NotSuperset~⊃⃒~NotSupersetEqual~⊉~NotTilde~≁~NotTildeEqual~≄~NotTildeFullEqual~≇~NotTildeTilde~≉~NotVerticalBar~∤~Nscr~𝒩~Ocy~О~Odblac~Ő~Ofr~𝔒~Omacr~Ō~Oopf~𝕆~OpenCurlyDoubleQuote~“~OpenCurlyQuote~‘~Or~⩔~Oscr~𝒪~Otimes~⨷~OverBar~‾~OverBrace~⏞~OverBracket~⎴~OverParenthesis~⏜~PartialD~∂~Pcy~П~Pfr~𝔓~PlusMinus~±~Poincareplane~ℌ~Popf~ℙ~Pr~⪻~Precedes~≺~PrecedesEqual~⪯~PrecedesSlantEqual~≼~PrecedesTilde~≾~Product~∏~Proportion~∷~Proportional~∝~Pscr~𝒫~Qfr~𝔔~Qopf~ℚ~Qscr~𝒬~RBarr~⤐~Racute~Ŕ~Rang~⟫~Rarr~↠~Rarrtl~⤖~Rcaron~Ř~Rcedil~Ŗ~Rcy~Р~Re~ℜ~ReverseElement~∋~ReverseEquilibrium~⇋~ReverseUpEquilibrium~⥯~Rfr~ℜ~RightAngleBracket~⟩~RightArrow~→~RightArrowBar~⇥~RightArrowLeftArrow~⇄~RightCeiling~⌉~RightDoubleBracket~⟧~RightDownTeeVector~⥝~RightDownVector~⇂~RightDownVectorBar~⥕~RightFloor~⌋~RightTee~⊢~RightTeeArrow~↦~RightTeeVector~⥛~RightTriangle~⊳~RightTriangleBar~⧐~RightTriangleEqual~⊵~RightUpDownVector~⥏~RightUpTeeVector~⥜~RightUpVector~↾~RightUpVectorBar~⥔~RightVector~⇀~RightVectorBar~⥓~Rightarrow~⇒~Ropf~ℝ~RoundImplies~⥰~Rrightarrow~⇛~Rscr~ℛ~Rsh~↱~RuleDelayed~⧴~SHCHcy~Щ~SHcy~Ш~SOFTcy~Ь~Sacute~Ś~Sc~⪼~Scedil~Ş~Scirc~Ŝ~Scy~С~Sfr~𝔖~ShortDownArrow~↓~ShortLeftArrow~←~ShortRightArrow~→~ShortUpArrow~↑~SmallCircle~∘~Sopf~𝕊~Sqrt~√~Square~□~SquareIntersection~⊓~SquareSubset~⊏~SquareSubsetEqual~⊑~SquareSuperset~⊐~SquareSupersetEqual~⊒~SquareUnion~⊔~Sscr~𝒮~Star~⋆~Sub~⋐~Subset~⋐~SubsetEqual~⊆~Succeeds~≻~SucceedsEqual~⪰~SucceedsSlantEqual~≽~SucceedsTilde~≿~SuchThat~∋~Sum~∑~Sup~⋑~Superset~⊃~SupersetEqual~⊇~Supset~⋑~TRADE~™~TSHcy~Ћ~TScy~Ц~Tab~	~Tcaron~Ť~Tcedil~Ţ~Tcy~Т~Tfr~𝔗~Therefore~∴~ThickSpace~  ~ThinSpace~ ~Tilde~∼~TildeEqual~≃~TildeFullEqual~≅~TildeTilde~≈~Topf~𝕋~TripleDot~⃛~Tscr~𝒯~Tstrok~Ŧ~Uarr~↟~Uarrocir~⥉~Ubrcy~Ў~Ubreve~Ŭ~Ucy~У~Udblac~Ű~Ufr~𝔘~Umacr~Ū~UnderBar~_~UnderBrace~⏟~UnderBracket~⎵~UnderParenthesis~⏝~Union~⋃~UnionPlus~⊎~Uogon~Ų~Uopf~𝕌~UpArrow~↑~UpArrowBar~⤒~UpArrowDownArrow~⇅~UpDownArrow~↕~UpEquilibrium~⥮~UpTee~⊥~UpTeeArrow~↥~Uparrow~⇑~Updownarrow~⇕~UpperLeftArrow~↖~UpperRightArrow~↗~Upsi~ϒ~Uring~Ů~Uscr~𝒰~Utilde~Ũ~VDash~⊫~Vbar~⫫~Vcy~В~Vdash~⊩~Vdashl~⫦~Vee~⋁~Verbar~‖~Vert~‖~VerticalBar~∣~VerticalLine~|~VerticalSeparator~❘~VerticalTilde~≀~VeryThinSpace~ ~Vfr~𝔙~Vopf~𝕍~Vscr~𝒱~Vvdash~⊪~Wcirc~Ŵ~Wedge~⋀~Wfr~𝔚~Wopf~𝕎~Wscr~𝒲~Xfr~𝔛~Xopf~𝕏~Xscr~𝒳~YAcy~Я~YIcy~Ї~YUcy~Ю~Ycirc~Ŷ~Ycy~Ы~Yfr~𝔜~Yopf~𝕐~Yscr~𝒴~ZHcy~Ж~Zacute~Ź~Zcaron~Ž~Zcy~З~Zdot~Ż~ZeroWidthSpace~​~Zfr~ℨ~Zopf~ℤ~Zscr~𝒵~abreve~ă~ac~∾~acE~∾̳~acd~∿~acy~а~af~⁡~afr~𝔞~aleph~ℵ~amacr~ā~amalg~⨿~andand~⩕~andd~⩜~andslope~⩘~andv~⩚~ange~⦤~angle~∠~angmsd~∡~angmsdaa~⦨~angmsdab~⦩~angmsdac~⦪~angmsdad~⦫~angmsdae~⦬~angmsdaf~⦭~angmsdag~⦮~angmsdah~⦯~angrt~∟~angrtvb~⊾~angrtvbd~⦝~angsph~∢~angst~Å~angzarr~⍼~aogon~ą~aopf~𝕒~ap~≈~apE~⩰~apacir~⩯~ape~≊~apid~≋~approx~≈~approxeq~≊~ascr~𝒶~ast~*~asympeq~≍~awconint~∳~awint~⨑~bNot~⫭~backcong~≌~backepsilon~϶~backprime~‵~backsim~∽~backsimeq~⋍~barvee~⊽~barwed~⌅~barwedge~⌅~bbrk~⎵~bbrktbrk~⎶~bcong~≌~bcy~б~becaus~∵~because~∵~bemptyv~⦰~bepsi~϶~bernou~ℬ~beth~ℶ~between~≬~bfr~𝔟~bigcap~⋂~bigcirc~◯~bigcup~⋃~bigodot~⨀~bigoplus~⨁~bigotimes~⨂~bigsqcup~⨆~bigstar~★~bigtriangledown~▽~bigtriangleup~△~biguplus~⨄~bigvee~⋁~bigwedge~⋀~bkarow~⤍~blacklozenge~⧫~blacksquare~▪~blacktriangle~▴~blacktriangledown~▾~blacktriangleleft~◂~blacktriangleright~▸~blank~␣~blk12~▒~blk14~░~blk34~▓~block~█~bne~=⃥~bnequiv~≡⃥~bnot~⌐~bopf~𝕓~bot~⊥~bottom~⊥~bowtie~⋈~boxDL~╗~boxDR~╔~boxDl~╖~boxDr~╓~boxH~═~boxHD~╦~boxHU~╩~boxHd~╤~boxHu~╧~boxUL~╝~boxUR~╚~boxUl~╜~boxUr~╙~boxV~║~boxVH~╬~boxVL~╣~boxVR~╠~boxVh~╫~boxVl~╢~boxVr~╟~boxbox~⧉~boxdL~╕~boxdR~╒~boxdl~┐~boxdr~┌~boxh~─~boxhD~╥~boxhU~╨~boxhd~┬~boxhu~┴~boxminus~⊟~boxplus~⊞~boxtimes~⊠~boxuL~╛~boxuR~╘~boxul~┘~boxur~└~boxv~│~boxvH~╪~boxvL~╡~boxvR~╞~boxvh~┼~boxvl~┤~boxvr~├~bprime~‵~breve~˘~bscr~𝒷~bsemi~⁏~bsim~∽~bsime~⋍~bsol~\\~bsolb~⧅~bsolhsub~⟈~bullet~•~bump~≎~bumpE~⪮~bumpe~≏~bumpeq~≏~cacute~ć~capand~⩄~capbrcup~⩉~capcap~⩋~capcup~⩇~capdot~⩀~caps~∩︀~caret~⁁~caron~ˇ~ccaps~⩍~ccaron~č~ccirc~ĉ~ccups~⩌~ccupssm~⩐~cdot~ċ~cemptyv~⦲~centerdot~·~cfr~𝔠~chcy~ч~check~✓~checkmark~✓~cir~○~cirE~⧃~circeq~≗~circlearrowleft~↺~circlearrowright~↻~circledR~®~circledS~Ⓢ~circledast~⊛~circledcirc~⊚~circleddash~⊝~cire~≗~cirfnint~⨐~cirmid~⫯~cirscir~⧂~clubsuit~♣~colon~:~colone~≔~coloneq~≔~comma~,~commat~@~comp~∁~compfn~∘~complement~∁~complexes~ℂ~congdot~⩭~conint~∮~copf~𝕔~coprod~∐~copysr~℗~cross~✗~cscr~𝒸~csub~⫏~csube~⫑~csup~⫐~csupe~⫒~ctdot~⋯~cudarrl~⤸~cudarrr~⤵~cuepr~⋞~cuesc~⋟~cularr~↶~cularrp~⤽~cupbrcap~⩈~cupcap~⩆~cupcup~⩊~cupdot~⊍~cupor~⩅~cups~∪︀~curarr~↷~curarrm~⤼~curlyeqprec~⋞~curlyeqsucc~⋟~curlyvee~⋎~curlywedge~⋏~curvearrowleft~↶~curvearrowright~↷~cuvee~⋎~cuwed~⋏~cwconint~∲~cwint~∱~cylcty~⌭~dHar~⥥~daleth~ℸ~dash~‐~dashv~⊣~dbkarow~⤏~dblac~˝~dcaron~ď~dcy~д~dd~ⅆ~ddagger~‡~ddarr~⇊~ddotseq~⩷~demptyv~⦱~dfisht~⥿~dfr~𝔡~dharl~⇃~dharr~⇂~diam~⋄~diamond~⋄~diamondsuit~♦~die~¨~digamma~ϝ~disin~⋲~div~÷~divideontimes~⋇~divonx~⋇~djcy~ђ~dlcorn~⌞~dlcrop~⌍~dollar~$~dopf~𝕕~dot~˙~doteq~≐~doteqdot~≑~dotminus~∸~dotplus~∔~dotsquare~⊡~doublebarwedge~⌆~downarrow~↓~downdownarrows~⇊~downharpoonleft~⇃~downharpoonright~⇂~drbkarow~⤐~drcorn~⌟~drcrop~⌌~dscr~𝒹~dscy~ѕ~dsol~⧶~dstrok~đ~dtdot~⋱~dtri~▿~dtrif~▾~duarr~⇵~duhar~⥯~dwangle~⦦~dzcy~џ~dzigrarr~⟿~eDDot~⩷~eDot~≑~easter~⩮~ecaron~ě~ecir~≖~ecolon~≕~ecy~э~edot~ė~ee~ⅇ~efDot~≒~efr~𝔢~eg~⪚~egs~⪖~egsdot~⪘~el~⪙~elinters~⏧~ell~ℓ~els~⪕~elsdot~⪗~emacr~ē~emptyset~∅~emptyv~∅~emsp13~ ~emsp14~ ~eng~ŋ~eogon~ę~eopf~𝕖~epar~⋕~eparsl~⧣~eplus~⩱~epsi~ε~epsiv~ϵ~eqcirc~≖~eqcolon~≕~eqsim~≂~eqslantgtr~⪖~eqslantless~⪕~equals~=~equest~≟~equivDD~⩸~eqvparsl~⧥~erDot~≓~erarr~⥱~escr~ℯ~esdot~≐~esim~≂~excl~!~expectation~ℰ~exponentiale~ⅇ~fallingdotseq~≒~fcy~ф~female~♀~ffilig~ﬃ~fflig~ﬀ~ffllig~ﬄ~ffr~𝔣~filig~ﬁ~fjlig~fj~flat~♭~fllig~ﬂ~fltns~▱~fopf~𝕗~fork~⋔~forkv~⫙~fpartint~⨍~frac13~⅓~frac15~⅕~frac16~⅙~frac18~⅛~frac23~⅔~frac25~⅖~frac35~⅗~frac38~⅜~frac45~⅘~frac56~⅚~frac58~⅝~frac78~⅞~frown~⌢~fscr~𝒻~gE~≧~gEl~⪌~gacute~ǵ~gammad~ϝ~gap~⪆~gbreve~ğ~gcirc~ĝ~gcy~г~gdot~ġ~gel~⋛~geq~≥~geqq~≧~geqslant~⩾~ges~⩾~gescc~⪩~gesdot~⪀~gesdoto~⪂~gesdotol~⪄~gesl~⋛︀~gesles~⪔~gfr~𝔤~gg~≫~ggg~⋙~gimel~ℷ~gjcy~ѓ~gl~≷~glE~⪒~gla~⪥~glj~⪤~gnE~≩~gnap~⪊~gnapprox~⪊~gne~⪈~gneq~⪈~gneqq~≩~gnsim~⋧~gopf~𝕘~grave~`~gscr~ℊ~gsim~≳~gsime~⪎~gsiml~⪐~gtcc~⪧~gtcir~⩺~gtdot~⋗~gtlPar~⦕~gtquest~⩼~gtrapprox~⪆~gtrarr~⥸~gtrdot~⋗~gtreqless~⋛~gtreqqless~⪌~gtrless~≷~gtrsim~≳~gvertneqq~≩︀~gvnE~≩︀~hairsp~ ~half~½~hamilt~ℋ~hardcy~ъ~harrcir~⥈~harrw~↭~hbar~ℏ~hcirc~ĥ~heartsuit~♥~hercon~⊹~hfr~𝔥~hksearow~⤥~hkswarow~⤦~hoarr~⇿~homtht~∻~hookleftarrow~↩~hookrightarrow~↪~hopf~𝕙~horbar~―~hscr~𝒽~hslash~ℏ~hstrok~ħ~hybull~⁃~hyphen~‐~ic~⁣~icy~и~iecy~е~iff~⇔~ifr~𝔦~ii~ⅈ~iiiint~⨌~iiint~∭~iinfin~⧜~iiota~℩~ijlig~ĳ~imacr~ī~imagline~ℐ~imagpart~ℑ~imath~ı~imof~⊷~imped~Ƶ~in~∈~incare~℅~infintie~⧝~inodot~ı~intcal~⊺~integers~ℤ~intercal~⊺~intlarhk~⨗~intprod~⨼~iocy~ё~iogon~į~iopf~𝕚~iprod~⨼~iscr~𝒾~isinE~⋹~isindot~⋵~isins~⋴~isinsv~⋳~isinv~∈~it~⁢~itilde~ĩ~iukcy~і~jcirc~ĵ~jcy~й~jfr~𝔧~jmath~ȷ~jopf~𝕛~jscr~𝒿~jsercy~ј~jukcy~є~kappav~ϰ~kcedil~ķ~kcy~к~kfr~𝔨~kgreen~ĸ~khcy~х~kjcy~ќ~kopf~𝕜~kscr~𝓀~lAarr~⇚~lAtail~⤛~lBarr~⤎~lE~≦~lEg~⪋~lHar~⥢~lacute~ĺ~laemptyv~⦴~lagran~ℒ~langd~⦑~langle~⟨~lap~⪅~larrb~⇤~larrbfs~⤟~larrfs~⤝~larrhk~↩~larrlp~↫~larrpl~⤹~larrsim~⥳~larrtl~↢~lat~⪫~latail~⤙~late~⪭~lates~⪭︀~lbarr~⤌~lbbrk~❲~lbrace~{~lbrack~[~lbrke~⦋~lbrksld~⦏~lbrkslu~⦍~lcaron~ľ~lcedil~ļ~lcub~{~lcy~л~ldca~⤶~ldquor~„~ldrdhar~⥧~ldrushar~⥋~ldsh~↲~leftarrow~←~leftarrowtail~↢~leftharpoondown~↽~leftharpoonup~↼~leftleftarrows~⇇~leftrightarrow~↔~leftrightarrows~⇆~leftrightharpoons~⇋~leftrightsquigarrow~↭~leftthreetimes~⋋~leg~⋚~leq~≤~leqq~≦~leqslant~⩽~les~⩽~lescc~⪨~lesdot~⩿~lesdoto~⪁~lesdotor~⪃~lesg~⋚︀~lesges~⪓~lessapprox~⪅~lessdot~⋖~lesseqgtr~⋚~lesseqqgtr~⪋~lessgtr~≶~lesssim~≲~lfisht~⥼~lfr~𝔩~lg~≶~lgE~⪑~lhard~↽~lharu~↼~lharul~⥪~lhblk~▄~ljcy~љ~ll~≪~llarr~⇇~llcorner~⌞~llhard~⥫~lltri~◺~lmidot~ŀ~lmoust~⎰~lmoustache~⎰~lnE~≨~lnap~⪉~lnapprox~⪉~lne~⪇~lneq~⪇~lneqq~≨~lnsim~⋦~loang~⟬~loarr~⇽~lobrk~⟦~longleftarrow~⟵~longleftrightarrow~⟷~longmapsto~⟼~longrightarrow~⟶~looparrowleft~↫~looparrowright~↬~lopar~⦅~lopf~𝕝~loplus~⨭~lotimes~⨴~lowbar~_~lozenge~◊~lozf~⧫~lpar~(~lparlt~⦓~lrarr~⇆~lrcorner~⌟~lrhar~⇋~lrhard~⥭~lrtri~⊿~lscr~𝓁~lsh~↰~lsim~≲~lsime~⪍~lsimg~⪏~lsqb~[~lsquor~‚~lstrok~ł~ltcc~⪦~ltcir~⩹~ltdot~⋖~lthree~⋋~ltimes~⋉~ltlarr~⥶~ltquest~⩻~ltrPar~⦖~ltri~◃~ltrie~⊴~ltrif~◂~lurdshar~⥊~luruhar~⥦~lvertneqq~≨︀~lvnE~≨︀~mDDot~∺~male~♂~malt~✠~maltese~✠~map~↦~mapsto~↦~mapstodown~↧~mapstoleft~↤~mapstoup~↥~marker~▮~mcomma~⨩~mcy~м~measuredangle~∡~mfr~𝔪~mho~℧~mid~∣~midast~*~midcir~⫰~minusb~⊟~minusd~∸~minusdu~⨪~mlcp~⫛~mldr~…~mnplus~∓~models~⊧~mopf~𝕞~mp~∓~mscr~𝓂~mstpos~∾~multimap~⊸~mumap~⊸~nGg~⋙̸~nGt~≫⃒~nGtv~≫̸~nLeftarrow~⇍~nLeftrightarrow~⇎~nLl~⋘̸~nLt~≪⃒~nLtv~≪̸~nRightarrow~⇏~nVDash~⊯~nVdash~⊮~nacute~ń~nang~∠⃒~nap~≉~napE~⩰̸~napid~≋̸~napos~ŉ~napprox~≉~natur~♮~natural~♮~naturals~ℕ~nbump~≎̸~nbumpe~≏̸~ncap~⩃~ncaron~ň~ncedil~ņ~ncong~≇~ncongdot~⩭̸~ncup~⩂~ncy~н~neArr~⇗~nearhk~⤤~nearr~↗~nearrow~↗~nedot~≐̸~nequiv~≢~nesear~⤨~nesim~≂̸~nexist~∄~nexists~∄~nfr~𝔫~ngE~≧̸~nge~≱~ngeq~≱~ngeqq~≧̸~ngeqslant~⩾̸~nges~⩾̸~ngsim~≵~ngt~≯~ngtr~≯~nhArr~⇎~nharr~↮~nhpar~⫲~nis~⋼~nisd~⋺~niv~∋~njcy~њ~nlArr~⇍~nlE~≦̸~nlarr~↚~nldr~‥~nle~≰~nleftarrow~↚~nleftrightarrow~↮~nleq~≰~nleqq~≦̸~nleqslant~⩽̸~nles~⩽̸~nless~≮~nlsim~≴~nlt~≮~nltri~⋪~nltrie~⋬~nmid~∤~nopf~𝕟~notinE~⋹̸~notindot~⋵̸~notinva~∉~notinvb~⋷~notinvc~⋶~notni~∌~notniva~∌~notnivb~⋾~notnivc~⋽~npar~∦~nparallel~∦~nparsl~⫽⃥~npart~∂̸~npolint~⨔~npr~⊀~nprcue~⋠~npre~⪯̸~nprec~⊀~npreceq~⪯̸~nrArr~⇏~nrarr~↛~nrarrc~⤳̸~nrarrw~↝̸~nrightarrow~↛~nrtri~⋫~nrtrie~⋭~nsc~⊁~nsccue~⋡~nsce~⪰̸~nscr~𝓃~nshortmid~∤~nshortparallel~∦~nsim~≁~nsime~≄~nsimeq~≄~nsmid~∤~nspar~∦~nsqsube~⋢~nsqsupe~⋣~nsubE~⫅̸~nsube~⊈~nsubset~⊂⃒~nsubseteq~⊈~nsubseteqq~⫅̸~nsucc~⊁~nsucceq~⪰̸~nsup~⊅~nsupE~⫆̸~nsupe~⊉~nsupset~⊃⃒~nsupseteq~⊉~nsupseteqq~⫆̸~ntgl~≹~ntlg~≸~ntriangleleft~⋪~ntrianglelefteq~⋬~ntriangleright~⋫~ntrianglerighteq~⋭~num~#~numero~№~numsp~ ~nvDash~⊭~nvHarr~⤄~nvap~≍⃒~nvdash~⊬~nvge~≥⃒~nvgt~>⃒~nvinfin~⧞~nvlArr~⤂~nvle~≤⃒~nvlt~<⃒~nvltrie~⊴⃒~nvrArr~⤃~nvrtrie~⊵⃒~nvsim~∼⃒~nwArr~⇖~nwarhk~⤣~nwarr~↖~nwarrow~↖~nwnear~⤧~oS~Ⓢ~oast~⊛~ocir~⊚~ocy~о~odash~⊝~odblac~ő~odiv~⨸~odot~⊙~odsold~⦼~ofcir~⦿~ofr~𝔬~ogon~˛~ogt~⧁~ohbar~⦵~ohm~Ω~oint~∮~olarr~↺~olcir~⦾~olcross~⦻~olt~⧀~omacr~ō~omid~⦶~ominus~⊖~oopf~𝕠~opar~⦷~operp~⦹~orarr~↻~ord~⩝~order~ℴ~orderof~ℴ~origof~⊶~oror~⩖~orslope~⩗~orv~⩛~oscr~ℴ~osol~⊘~otimesas~⨶~ovbar~⌽~par~∥~parallel~∥~parsim~⫳~parsl~⫽~pcy~п~percnt~%~period~.~pertenk~‱~pfr~𝔭~phiv~ϕ~phmmat~ℳ~phone~☎~pitchfork~⋔~planck~ℏ~planckh~ℎ~plankv~ℏ~plus~+~plusacir~⨣~plusb~⊞~pluscir~⨢~plusdo~∔~plusdu~⨥~pluse~⩲~plussim~⨦~plustwo~⨧~pm~±~pointint~⨕~popf~𝕡~pr~≺~prE~⪳~prap~⪷~prcue~≼~pre~⪯~prec~≺~precapprox~⪷~preccurlyeq~≼~preceq~⪯~precnapprox~⪹~precneqq~⪵~precnsim~⋨~precsim~≾~primes~ℙ~prnE~⪵~prnap~⪹~prnsim~⋨~profalar~⌮~profline~⌒~profsurf~⌓~propto~∝~prsim~≾~prurel~⊰~pscr~𝓅~puncsp~ ~qfr~𝔮~qint~⨌~qopf~𝕢~qprime~⁗~qscr~𝓆~quaternions~ℍ~quatint~⨖~quest~?~questeq~≟~rAarr~⇛~rAtail~⤜~rBarr~⤏~rHar~⥤~race~∽̱~racute~ŕ~raemptyv~⦳~rangd~⦒~range~⦥~rangle~⟩~rarrap~⥵~rarrb~⇥~rarrbfs~⤠~rarrc~⤳~rarrfs~⤞~rarrhk~↪~rarrlp~↬~rarrpl~⥅~rarrsim~⥴~rarrtl~↣~rarrw~↝~ratail~⤚~ratio~∶~rationals~ℚ~rbarr~⤍~rbbrk~❳~rbrace~}~rbrack~]~rbrke~⦌~rbrksld~⦎~rbrkslu~⦐~rcaron~ř~rcedil~ŗ~rcub~}~rcy~р~rdca~⤷~rdldhar~⥩~rdquor~”~rdsh~↳~realine~ℛ~realpart~ℜ~reals~ℝ~rect~▭~rfisht~⥽~rfr~𝔯~rhard~⇁~rharu~⇀~rharul~⥬~rhov~ϱ~rightarrow~→~rightarrowtail~↣~rightharpoondown~⇁~rightharpoonup~⇀~rightleftarrows~⇄~rightleftharpoons~⇌~rightrightarrows~⇉~rightsquigarrow~↝~rightthreetimes~⋌~ring~˚~risingdotseq~≓~rlarr~⇄~rlhar~⇌~rmoust~⎱~rmoustache~⎱~rnmid~⫮~roang~⟭~roarr~⇾~robrk~⟧~ropar~⦆~ropf~𝕣~roplus~⨮~rotimes~⨵~rpar~)~rpargt~⦔~rppolint~⨒~rrarr~⇉~rscr~𝓇~rsh~↱~rsqb~]~rsquor~’~rthree~⋌~rtimes~⋊~rtri~▹~rtrie~⊵~rtrif~▸~rtriltri~⧎~ruluhar~⥨~rx~℞~sacute~ś~sc~≻~scE~⪴~scap~⪸~sccue~≽~sce~⪰~scedil~ş~scirc~ŝ~scnE~⪶~scnap~⪺~scnsim~⋩~scpolint~⨓~scsim~≿~scy~с~sdotb~⊡~sdote~⩦~seArr~⇘~searhk~⤥~searr~↘~searrow~↘~semi~;~seswar~⤩~setminus~∖~setmn~∖~sext~✶~sfr~𝔰~sfrown~⌢~sharp~♯~shchcy~щ~shcy~ш~shortmid~∣~shortparallel~∥~sigmav~ς~simdot~⩪~sime~≃~simeq~≃~simg~⪞~simgE~⪠~siml~⪝~simlE~⪟~simne~≆~simplus~⨤~simrarr~⥲~slarr~←~smallsetminus~∖~smashp~⨳~smeparsl~⧤~smid~∣~smile~⌣~smt~⪪~smte~⪬~smtes~⪬︀~softcy~ь~sol~/~solb~⧄~solbar~⌿~sopf~𝕤~spadesuit~♠~spar~∥~sqcap~⊓~sqcaps~⊓︀~sqcup~⊔~sqcups~⊔︀~sqsub~⊏~sqsube~⊑~sqsubset~⊏~sqsubseteq~⊑~sqsup~⊐~sqsupe~⊒~sqsupset~⊐~sqsupseteq~⊒~squ~□~square~□~squarf~▪~squf~▪~srarr~→~sscr~𝓈~ssetmn~∖~ssmile~⌣~sstarf~⋆~star~☆~starf~★~straightepsilon~ϵ~straightphi~ϕ~strns~¯~subE~⫅~subdot~⪽~subedot~⫃~submult~⫁~subnE~⫋~subne~⊊~subplus~⪿~subrarr~⥹~subset~⊂~subseteq~⊆~subseteqq~⫅~subsetneq~⊊~subsetneqq~⫋~subsim~⫇~subsub~⫕~subsup~⫓~succ~≻~succapprox~⪸~succcurlyeq~≽~succeq~⪰~succnapprox~⪺~succneqq~⪶~succnsim~⋩~succsim~≿~sung~♪~supE~⫆~supdot~⪾~supdsub~⫘~supedot~⫄~suphsol~⟉~suphsub~⫗~suplarr~⥻~supmult~⫂~supnE~⫌~supne~⊋~supplus~⫀~supset~⊃~supseteq~⊇~supseteqq~⫆~supsetneq~⊋~supsetneqq~⫌~supsim~⫈~supsub~⫔~supsup~⫖~swArr~⇙~swarhk~⤦~swarr~↙~swarrow~↙~swnwar~⤪~target~⌖~tbrk~⎴~tcaron~ť~tcedil~ţ~tcy~т~tdot~⃛~telrec~⌕~tfr~𝔱~therefore~∴~thetav~ϑ~thickapprox~≈~thicksim~∼~thkap~≈~thksim~∼~timesb~⊠~timesbar~⨱~timesd~⨰~tint~∭~toea~⤨~top~⊤~topbot~⌶~topcir~⫱~topf~𝕥~topfork~⫚~tosa~⤩~tprime~‴~triangle~▵~triangledown~▿~triangleleft~◃~trianglelefteq~⊴~triangleq~≜~triangleright~▹~trianglerighteq~⊵~tridot~◬~trie~≜~triminus~⨺~triplus~⨹~trisb~⧍~tritime~⨻~trpezium~⏢~tscr~𝓉~tscy~ц~tshcy~ћ~tstrok~ŧ~twixt~≬~twoheadleftarrow~↞~twoheadrightarrow~↠~uHar~⥣~ubrcy~ў~ubreve~ŭ~ucy~у~udarr~⇅~udblac~ű~udhar~⥮~ufisht~⥾~ufr~𝔲~uharl~↿~uharr~↾~uhblk~▀~ulcorn~⌜~ulcorner~⌜~ulcrop~⌏~ultri~◸~umacr~ū~uogon~ų~uopf~𝕦~uparrow~↑~updownarrow~↕~upharpoonleft~↿~upharpoonright~↾~uplus~⊎~upsi~υ~upuparrows~⇈~urcorn~⌝~urcorner~⌝~urcrop~⌎~uring~ů~urtri~◹~uscr~𝓊~utdot~⋰~utilde~ũ~utri~▵~utrif~▴~uuarr~⇈~uwangle~⦧~vArr~⇕~vBar~⫨~vBarv~⫩~vDash~⊨~vangrt~⦜~varepsilon~ϵ~varkappa~ϰ~varnothing~∅~varphi~ϕ~varpi~ϖ~varpropto~∝~varr~↕~varrho~ϱ~varsigma~ς~varsubsetneq~⊊︀~varsubsetneqq~⫋︀~varsupsetneq~⊋︀~varsupsetneqq~⫌︀~vartheta~ϑ~vartriangleleft~⊲~vartriangleright~⊳~vcy~в~vdash~⊢~vee~∨~veebar~⊻~veeeq~≚~vellip~⋮~verbar~|~vert~|~vfr~𝔳~vltri~⊲~vnsub~⊂⃒~vnsup~⊃⃒~vopf~𝕧~vprop~∝~vrtri~⊳~vscr~𝓋~vsubnE~⫋︀~vsubne~⊊︀~vsupnE~⫌︀~vsupne~⊋︀~vzigzag~⦚~wcirc~ŵ~wedbar~⩟~wedge~∧~wedgeq~≙~wfr~𝔴~wopf~𝕨~wp~℘~wr~≀~wreath~≀~wscr~𝓌~xcap~⋂~xcirc~◯~xcup~⋃~xdtri~▽~xfr~𝔵~xhArr~⟺~xharr~⟷~xlArr~⟸~xlarr~⟵~xmap~⟼~xnis~⋻~xodot~⨀~xopf~𝕩~xoplus~⨁~xotime~⨂~xrArr~⟹~xrarr~⟶~xscr~𝓍~xsqcup~⨆~xuplus~⨄~xutri~△~xvee~⋁~xwedge~⋀~yacy~я~ycirc~ŷ~ycy~ы~yfr~𝔶~yicy~ї~yopf~𝕪~yscr~𝓎~yucy~ю~zacute~ź~zcaron~ž~zcy~з~zdot~ż~zeetrf~ℨ~zfr~𝔷~zhcy~ж~zigrarr~⇝~zopf~𝕫~zscr~𝓏~~AMP~&~COPY~©~GT~>~LT~<~QUOT~"~REG~®', ze.html4);
var Yi = {
  0: 65533,
  128: 8364,
  130: 8218,
  131: 402,
  132: 8222,
  133: 8230,
  134: 8224,
  135: 8225,
  136: 710,
  137: 8240,
  138: 352,
  139: 8249,
  140: 338,
  142: 381,
  145: 8216,
  146: 8217,
  147: 8220,
  148: 8221,
  149: 8226,
  150: 8211,
  151: 8212,
  152: 732,
  153: 8482,
  154: 353,
  155: 8250,
  156: 339,
  158: 382,
  159: 376
}, Ji = String.fromCodePoint || function(u) {
  return String.fromCharCode(Math.floor((u - 65536) / 1024) + 55296, (u - 65536) % 1024 + 56320);
}, Ge = function() {
  return Ge = Object.assign || function(u) {
    for (var E, b = 1, l = arguments.length; b < l; b++) {
      E = arguments[b];
      for (var f in E) Object.prototype.hasOwnProperty.call(E, f) && (u[f] = E[f]);
    }
    return u;
  }, Ge.apply(this, arguments);
}, Zi = Ge(Ge({}, ze), { all: ze.html5 }), Xi = {
  scope: "body",
  level: "all"
}, iu = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);/g, nu = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+)[;=]?/g, Pr = {
  xml: {
    strict: iu,
    attribute: nu,
    body: ru.xml
  },
  html4: {
    strict: iu,
    attribute: nu,
    body: ru.html4
  },
  html5: {
    strict: iu,
    attribute: nu,
    body: ru.html5
  }
}, Qi = Ge(Ge({}, Pr), { all: Pr.html5 }), Jr = String.fromCharCode, Ki = Jr(65533);
function en(u, E, b, l) {
  var f = u, p = u[u.length - 1];
  if (b && p === "=")
    f = u;
  else if (l && p !== ";")
    f = u;
  else {
    var a = E[u];
    if (a)
      f = a;
    else if (u[0] === "&" && u[1] === "#") {
      var d = u[2], h = d == "x" || d == "X" ? parseInt(u.substr(3), 16) : parseInt(u.substr(2));
      f = h >= 1114111 ? Ki : h > 65535 ? Ji(h) : Jr(Yi[h] || h);
    }
  }
  return f;
}
function Zr(u, E) {
  var b = Xi, l = b.level, f = l === void 0 ? "all" : l, p = b.scope, a = p === void 0 ? f === "xml" ? "strict" : "body" : p;
  if (!u)
    return "";
  var d = Qi[f][a], h = Zi[f].entities, i = a === "attribute", r = a === "strict";
  return u.replace(d, function(s) {
    return en(s, h, i, r);
  });
}
const Xr = ({ cents: u, locale: E, showCents: b = !1 }) => new Intl.NumberFormat(E, {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: b ? 2 : 0,
  maximumFractionDigits: b ? 2 : 0
}).format(u / 100), qn = ({
  project: u,
  locale: E = document.documentElement.lang || "de",
  href: b,
  onClick: l,
  className: f,
  showDescription: p,
  openInTab: a,
  bottomContent: d,
  children: h,
  showCarrierName: i
}) => {
  var g, v, x, o, w, S, A, C;
  const r = Xr({ cents: u.open_amount_in_cents, locale: E }), s = new Intl.NumberFormat(E).format(u.donations_count), e = E === "de" ? "fehlen noch" : "still needed", t = E === "de" ? "Spenden" : "donations", c = b || ((g = u.links.find((R) => R.rel === "platform")) == null ? void 0 : g.href), m = (x = (v = u.profile_picture) == null ? void 0 : v.links.find((R) => R.rel === "fill_410x214")) == null ? void 0 : x.href, y = (S = (w = (o = u.carrier) == null ? void 0 : o.picture) == null ? void 0 : w.links.find((R) => R.rel === "fill_100x100")) == null ? void 0 : S.href, n = (R) => {
    l && l(R, u);
  };
  return /* @__PURE__ */ M.jsxs(
    "a",
    {
      title: u.title ? Zr(u.title) : "",
      onClick: n,
      className: `donatable-teaser ${f ?? ""} ${p ? "donatable-teaser--with-description" : ""} ${d ? "donatable-teaser--with-bottom-content" : ""}`,
      href: c,
      target: a ? "_blank" : "_parent",
      rel: "noreferrer",
      children: [
        h,
        /* @__PURE__ */ M.jsx(
          "div",
          {
            className: "donatable-teaser--profile-picture",
            style: { backgroundImage: `url(${m})` },
            title: u.title
          }
        ),
        /* @__PURE__ */ M.jsx(st, { as: "h2", className: "donatable-teaser--title", value: u.title }),
        p && /* @__PURE__ */ M.jsx(st, { className: "donatable-teaser--description", as: "div", value: u.description }),
        /* @__PURE__ */ M.jsxs("div", { className: "donatable-teaser--divider", children: [
          /* @__PURE__ */ M.jsxs("div", { className: "donatable-teaser--factlist", children: [
            /* @__PURE__ */ M.jsxs("div", { children: [
              u.city && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
                /* @__PURE__ */ M.jsx("span", { children: u.city }),
                ",",
                " "
              ] }),
              u.country
            ] }),
            /* @__PURE__ */ M.jsx("div", { children: i ? /* @__PURE__ */ M.jsx("span", { children: (A = u.carrier) == null ? void 0 : A.name }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
              /* @__PURE__ */ M.jsx("span", { children: s }),
              " ",
              t
            ] }) }),
            /* @__PURE__ */ M.jsxs("div", { children: [
              /* @__PURE__ */ M.jsx("span", { children: r }),
              " ",
              e
            ] })
          ] }),
          /* @__PURE__ */ M.jsx("img", { src: y, alt: (C = u.carrier) == null ? void 0 : C.name, className: "donatable-teaser--carrier-logo" })
        ] }),
        /* @__PURE__ */ M.jsx("div", { className: "donatable-teaser--progress", children: /* @__PURE__ */ M.jsx("div", { className: "donatable-teaser--progress-bar", style: { width: `${u.progress_percentage}%` } }) }),
        d
      ]
    }
  );
}, tn = (u, E) => E === 1 ? u === "de" ? "Spende" : "donation" : u === "de" ? "Spenden" : "donations", On = ({
  fundraisingEvent: u,
  locale: E = document.documentElement.lang || "de",
  href: b,
  onClick: l,
  openInTab: f,
  children: p
}) => {
  var e, t, c, m, y, n, g, v;
  const a = b || ((e = u.links.find((x) => x.rel === "platform")) == null ? void 0 : e.href), d = (c = (t = u.profile_picture) == null ? void 0 : t.links.find(
    (x) => x.rel === "fill_410x214"
  )) == null ? void 0 : c.href, h = Xr({ cents: u.donated_amount_in_cents, locale: E }), i = (n = (y = (m = u.contact) == null ? void 0 : m.picture) == null ? void 0 : y.links.find((x) => x.rel === "fill_100x100")) == null ? void 0 : n.href, r = (x) => {
    l && l(x, u);
  }, s = tn(E, u.donations_count);
  return /* @__PURE__ */ M.jsxs(
    "a",
    {
      title: u.title ? Zr(u.title) : "",
      onClick: r,
      className: "donatable-teaser",
      href: a,
      target: f ? "_blank" : "_parent",
      rel: "noreferrer",
      children: [
        p,
        /* @__PURE__ */ M.jsx(
          "div",
          {
            className: "donatable-teaser--profile-picture",
            style: { backgroundImage: `url(${d})` },
            title: u.title
          }
        ),
        /* @__PURE__ */ M.jsx(st, { as: "h2", className: "donatable-teaser--title", value: u.title }),
        /* @__PURE__ */ M.jsxs("div", { className: "donatable-teaser--divider", children: [
          /* @__PURE__ */ M.jsxs("div", { className: "donatable-teaser--factlist", children: [
            /* @__PURE__ */ M.jsx("div", { children: /* @__PURE__ */ M.jsx(st, { as: "span", value: (g = u.contact) == null ? void 0 : g.name }) }),
            /* @__PURE__ */ M.jsxs("div", { children: [
              /* @__PURE__ */ M.jsx("span", { children: u.donations_count }),
              " ",
              s
            ] }),
            /* @__PURE__ */ M.jsxs("div", { children: [
              /* @__PURE__ */ M.jsx("span", { children: h }),
              " ",
              E === "de" ? "gesammelt" : "collected"
            ] })
          ] }),
          /* @__PURE__ */ M.jsx(
            "img",
            {
              style: { borderRadius: "50%", border: "1px solid #cccccc" },
              src: i,
              alt: ((v = u.contact) == null ? void 0 : v.name) ?? "",
              className: "donatable-teaser--carrier-logo"
            }
          )
        ] })
      ]
    }
  );
}, un = ({
  icon: u,
  content: E,
  className: b = "",
  boxShadow: l,
  buttonClassName: f = "",
  ...p
}) => {
  const a = u;
  return /* @__PURE__ */ M.jsxs(
    "a",
    {
      ...p,
      className: `share-button--full ${l ? "share-button--box-shadowed" : ""} ${f} ${b}`,
      children: [
        /* @__PURE__ */ M.jsx("div", { className: "share-button--full-icon-wrapper", children: /* @__PURE__ */ M.jsx(a, { className: "share-button--icon" }) }),
        /* @__PURE__ */ M.jsx("span", { className: "share-button--text", children: E })
      ]
    }
  );
}, rn = ({
  icon: u,
  content: E,
  className: b = "",
  buttonClassName: l = "",
  boxShadow: f,
  ...p
}) => {
  const a = u;
  return /* @__PURE__ */ M.jsxs("a", { ...p, className: `share-button--minimal ${l} ${b}`, children: [
    /* @__PURE__ */ M.jsx(a, { className: "share-button--icon" }),
    /* @__PURE__ */ M.jsx("span", { className: "share-button--text", children: E })
  ] });
}, nn = ({ icon: u, className: E = "", boxShadow: b, buttonClassName: l = "", ...f }) => {
  const p = u;
  return /* @__PURE__ */ M.jsx(
    "a",
    {
      ...f,
      className: `share-button--round ${b ? "share-button--box-shadowed" : ""} ${l} ${E}`,
      children: /* @__PURE__ */ M.jsx(p, {})
    }
  );
}, an = ({
  icon: u,
  className: E = "",
  buttonClassName: b = "",
  boxShadow: l,
  ...f
}) => {
  const p = u;
  return /* @__PURE__ */ M.jsx("a", { ...f, className: `share-button--square ${b} ${E}`, children: /* @__PURE__ */ M.jsx(p, {}) });
}, sn = ({
  icon: u,
  content: E,
  className: b = "",
  boxShadow: l,
  buttonClassName: f = "",
  ...p
}) => {
  const a = u;
  return /* @__PURE__ */ M.jsxs("div", { className: `share-button--round-with-label ${b}`, children: [
    /* @__PURE__ */ M.jsx(
      "a",
      {
        ...p,
        className: `share-button--round ${l ? "share-button--box-shadowed" : ""} ${f}`,
        children: /* @__PURE__ */ M.jsx(a, {})
      }
    ),
    E
  ] });
}, on = {
  full: un,
  minimal: rn,
  round: nn,
  square: an,
  roundWithLabel: sn
}, Be = ({
  action: u,
  ariaLabel: E,
  buttonLabel: b,
  className: l,
  icon: f
}) => (a) => {
  const d = on[a.shape], h = (i) => {
    i.preventDefault(), a.beforeOnClick && a.beforeOnClick(i), u(a);
  };
  return /* @__PURE__ */ M.jsx(
    d,
    {
      "aria-label": E,
      boxShadow: a.boxShadow,
      className: a.className || "",
      buttonClassName: l,
      href: "#",
      onClick: h,
      role: "button",
      title: a.title || "",
      label: b || E,
      icon: f,
      content: a.content
    }
  );
}, cn = ({ size: u = "60%" }) => /* @__PURE__ */ M.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    children: /* @__PURE__ */ M.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
      }
    )
  }
), ln = ({ size: u = "60%" }) => /* @__PURE__ */ M.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 264 512",
    children: /* @__PURE__ */ M.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"
      }
    )
  }
), fn = ({ size: u = "60%" }) => /* @__PURE__ */ M.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ M.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M224 32C15.9 32-77.5 278 84.6 400.6V480l75.7-42c142.2 39.8 285.4-59.9 285.4-198.7C445.8 124.8 346.5 32 224 32zm23.4 278.1L190 250.5 79.6 311.6l121.1-128.5 57.4 59.6 110.4-61.1-121.1 128.5z"
      }
    )
  }
), dn = ({ size: u = "60%" }) => /* @__PURE__ */ M.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ M.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"
      }
    )
  }
), hn = ({ size: u = "60%" }) => /* @__PURE__ */ M.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ M.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
      }
    )
  }
), pn = ({ size: u = "60%" }) => /* @__PURE__ */ M.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 700",
    children: /* @__PURE__ */ M.jsxs("g", { children: [
      /* @__PURE__ */ M.jsx(
        "path",
        {
          fill: "currentColor",
          d: `M337.5,448c-5.7,0-11.4-1.7-16.4-5.2c-5.6-3.9-10.8-8.5-15.5-13.5l-19.3-20.6c-48.9-52.1-46.2-134.3,5.9-183.2l95-89.1
		c52.1-48.9,134.3-46.2,183.2,5.9c48.9,52.1,46.2,134.3-5.9,183.2l-31.8,29.8c-11.5,10.8-29.6,10.2-40.4-1.3
		c-10.8-11.5-10.2-29.6,1.3-40.4l31.8-29.8c29.2-27.3,30.7-73.3,3.3-102.5c-27.3-29.2-73.3-30.7-102.5-3.3l-95,89.1
		c-29.2,27.3-30.7,73.3-3.3,102.5l19.3,20.6c2,2.2,4.3,4.1,6.7,5.9c12.9,9.1,16,26.9,6.9,39.8C355.3,443.8,346.5,448,337.5,448z`
        }
      ),
      /* @__PURE__ */ M.jsx(
        "path",
        {
          fill: "currentColor",
          d: `M245.8,617.8c-34.6,0-69.1-13.7-94.6-40.9c-48.9-52.1-46.2-134.3,5.9-183.2l31.8-29.8c11.5-10.8,29.6-10.2,40.4,1.3
		c10.8,11.5,10.2,29.6-1.3,40.4l-31.8,29.8c-29.2,27.3-30.7,73.3-3.3,102.5c27.3,29.2,73.3,30.7,102.5,3.3l95-89.1
		c29.2-27.3,30.7-73.3,3.3-102.5L374.4,329c-2-2.2-4.3-4.1-6.7-5.9c-12.9-9.1-16-26.9-6.9-39.8c9.1-12.9,26.9-16,39.8-6.9
		c5.6,3.9,10.8,8.5,15.5,13.5l19.3,20.6c48.9,52.1,46.2,134.3-5.9,183.2l-95,89.1C309.5,606.3,277.6,617.8,245.8,617.8z`
        }
      )
    ] })
  }
), bn = ({ size: u = "60%" }) => /* @__PURE__ */ M.jsxs(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.486 40.912",
    children: [
      /* @__PURE__ */ M.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M95.09,109.768c.137-.971.242-1.947.417-2.911.991-5.459,4.855-9.173,10.381-9.364,6.654-.229,13.327-.241,19.98,0a10.692,10.692,0,0,1,10.558,10.687q.3,9.583,0,19.182a10.691,10.691,0,0,1-10.558,10.687c-6.653.24-13.328.246-19.98,0-6.016-.226-10.174-4.69-10.576-10.715-.035-.521-.147-1.038-.223-1.557Zm20.749,24.713c3.045,0,6.092.091,9.133-.021,4.767-.177,7.7-3.022,7.811-7.785q.207-8.9,0-17.812c-.111-4.762-3.046-7.673-7.811-7.775q-9.072-.192-18.151,0c-4.729.1-7.67,2.952-7.8,7.661q-.245,9.014,0,18.039c.128,4.709,3.069,7.5,7.8,7.671C109.823,134.572,112.832,134.482,115.839,134.482Zm0,0",
          transform: "translate(-95.09 -97.317)"
        }
      ),
      /* @__PURE__ */ M.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M184.564,174a10.572,10.572,0,1,0,10.572,10.571A10.572,10.572,0,0,0,184.564,174Zm0,17.5a6.932,6.932,0,1,1,6.932-6.932A6.932,6.932,0,0,1,184.564,191.5Zm0,0",
          transform: "translate(-163.821 -164.111)"
        }
      ),
      /* @__PURE__ */ M.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M328.315,153.258a2.515,2.515,0,1,1-2.515-2.515A2.515,2.515,0,0,1,328.315,153.258Zm0,0",
          transform: "translate(-293.868 -143.855)"
        }
      )
    ]
  }
);
function mn(u) {
  return u.toLowerCase().startsWith("utm_");
}
const gn = (u) => new URLSearchParams(Object.entries(u).filter(([b, l]) => l !== void 0)), bu = (u, E = {}) => {
  if (!u) return u;
  const b = u.startsWith("http") ? u : `https://${u}`, l = new URL(b);
  return l.searchParams.forEach((p, a, d) => {
    mn(a) && d.delete(a);
  }), gn(E).forEach((p, a) => l.searchParams.set(a, p)), l.toString();
}, Je = (u, E = {}, b = "") => {
  const l = bu(u, E);
  return encodeURIComponent(b + l);
}, Qr = (u) => window.open(u, "sharer", "toolbar=no,width=1042,height=436"), Kr = (u) => {
  const E = document.createElement("textarea");
  E.value = u, document.body.appendChild(E), E.select();
  const b = document.execCommand("copy");
  if (document.body.removeChild(E), !b) {
    const f = (document.documentElement.lang || "de") === "de" ? "Sorry, dein Browser unterstützt diese Funktion nicht." : "Sorry, your Browser doesn't support this feature.";
    alert(f);
  }
  return b;
}, ei = () => /(android|iphone|ipad|mobile)/i.test(navigator.userAgent), vn = ({
  shareUrl: u,
  subject: E = null,
  teaser: b = "",
  utmParams: l
}) => {
  const f = encodeURIComponent(E || b), p = Je(u, l, `${b} `);
  return window.open(`mailto:?subject=${f}&body=${p}`, "_self");
}, _n = Be({
  action: vn,
  ariaLabel: "Email",
  className: "share-button--email",
  icon: cn
}), yn = ({ shareUrl: u, utmParams: E }) => Qr(`https://www.facebook.com/sharer/sharer.php?u=${Je(u, E)}`), Nn = Be({
  action: yn,
  ariaLabel: "Facebook",
  className: "share-button--facebook",
  icon: ln
}), xn = ({
  facebookAppId: u,
  shareUrl: E,
  utmParams: b
}) => {
  const l = ei(), f = Je(E, b);
  return l ? window.open(`fb-messenger://share?link=${f}&app_id=${u}`) : Qr(
    `http://www.facebook.com/dialog/send?app_id=${u}&link=${f}&redirect_uri=${encodeURIComponent(E)}`
  );
}, Rn = Be({
  action: xn,
  ariaLabel: "Facebook Messenger",
  buttonLabel: "Messenger",
  className: "share-button--facebook-messenger",
  icon: fn
}), wn = ({ shareUrl: u, teaser: E = "", utmParams: b }) => window.open(
  `https://telegram.me/share/url?url=${Je(u, b)}&text=${encodeURIComponent(E)}`
), Cn = Be({
  action: wn,
  ariaLabel: "Telegram",
  className: "share-button--telegram",
  icon: dn
}), En = ({ shareUrl: u, utmParams: E }) => window.open(
  `https://${ei() ? "api" : "web"}.whatsapp.com/send?text=${Je(u, E)}`
), Dn = Be({
  action: En,
  ariaLabel: "WhatsApp",
  className: "share-button--whatsapp",
  icon: hn
}), Sn = ({ shareUrl: u, utmParams: E }) => {
  Kr(bu(u, E));
}, Ln = Be({
  action: Sn,
  ariaLabel: "ShareLink",
  buttonLabel: "Link",
  className: "share-button--share-link",
  icon: pn
}), Tn = ({ shareUrl: u, utmParams: E }) => {
  Kr(bu(u, E));
}, In = Be({
  action: Tn,
  ariaLabel: "Instagram",
  className: "share-button--instagram",
  icon: bn
}), Pn = (u, E) => u.replace(
  /\w\w/g,
  (b) => ("0" + Math.min(255, Math.max(0, parseInt(b, 16) + E)).toString(16)).substr(-2)
);
export {
  _n as EmailButton,
  Nn as FacebookButton,
  Rn as FacebookMessengerButton,
  On as FundraisingEventTeaser,
  In as InstagramButton,
  Ln as LinkButton,
  qn as ProjectTeaser,
  Cn as TelegramButton,
  Dn as WhatsappButton,
  Pn as changeBrightness,
  vn as emailShareAction,
  Je as encodeShareURL,
  xn as facebookMessengerShareAction,
  yn as facebookShareAction,
  Xr as formatAmount,
  bu as getShareURL,
  Tn as instagramAction,
  Sn as linkAction,
  Qr as openPopup,
  wn as telegramShareAction,
  En as whatsappShareAction
};
